var _style, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPagenotfound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 416 416",
    style: {
      enableBackground: "new 0 0 416 416"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F7F7F7;}\r\n\t.st1{fill:#EFEFEF;}\r\n\t.st2{fill:#CE0E2D;}\r\n\t.st3{fill:#BDBDBD;}\r\n\t.st4{fill:#737373;}\r\n\t.st5{fill:#ADADAD;}\r\n\t.st6{fill:#A5A5A5;}\r\n\t.st7{fill:#9C9C9C;}\r\n\t.st8{fill:#949494;}\r\n\t.st9{fill:#8C8C8C;}\r\n\t.st10{fill:#848484;}\r\n\t.st11{fill:#7B7B7B;}\r\n\t.st12{fill:#6B6B6B;}\r\n\t.st13{fill:#636363;}\r\n\t.st14{fill:#424242;}\r\n\t.st15{fill:#5A5A5A;}\r\n\t.st16{fill:#525252;}\r\n\t.st17{fill:#4A4A4A;}\r\n\t.st18{fill:#313131;}\r\n\t.st19{fill:#292929;}\r\n\t.st20{fill:#212121;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.9,221.5c-0.2,9-0.4,11.9-1.6,18c-0.8,4-1.6,8-1.8,8.8s-0.8,2.8-1.2,4.2c-0.5,1.5-1,3.2-1.2,3.8 c-0.2,0.6-2,6-4,12c-4.7,14.5-9.2,27.5-11,32.5c-3.5,9.3-4,10.6-5.1,13c-0.6,1.4-1.3,3-1.5,3.8c-0.9,3-6,13.5-8.5,17 c-4.8,7.2-6.2,9-9.5,12.4c-4.4,4.5-6.5,6.1-13.1,9.6c-5.8,3.2-16,5.8-26.5,7c-4.8,0.5-23.3,0.8-23.8,0.3c-0.2-0.1-9.1-0.6-20-1 c-15.5-0.7-27.3-0.8-54.8-0.6c-43.8,0.3-56.6-0.2-68-2.6c-2.8-0.5-6.5-1.2-8.2-1.5c-4.5-0.7-16.3-4.5-21.9-6.9 c-6.1-2.7-14.6-7-15.6-7.8c-0.4-0.3-2.5-1.8-4.7-3.3c-2.2-1.5-4.5-3-5-3.4c-2.3-1.6-11.2-10.2-15-14.5c-3-3.3-9.4-13.2-11.8-18 c-1.1-2.3-2.3-4.8-2.8-5.5c-1-1.8-6.2-18-6.2-19.3c0-0.6-0.3-2.8-0.7-4.8c-2.3-12.2-2.3-12.2-2.3-26c0-7.5,0.2-15.8,0.5-18.4 c0.3-2.6,0.5-6.4,0.5-8.4s0.2-5.1,0.5-7c0.3-1.8,0.9-7.8,1.3-13.3c1.5-19.2,2.5-29.3,4.7-43c2-13.1,3.5-20.1,5.5-26.5 c0.8-2.5,1.5-4.9,1.5-5.4s0.5-1.9,1-3c0.5-1.2,1.8-4.1,2.8-6.4c3.5-8,11-17.5,17.5-22c4.2-2.9,12-6.4,17.5-7.9 c0.8-0.2,3.4-1.3,5.8-2.4c2.3-1.1,5.2-2.4,6.5-2.9c4-1.5,4.7-1.9,15.2-6.8c1.1-0.5,4.2-1.8,6.8-2.9c2.6-1.1,6.5-2.8,8.5-3.6 c2-0.9,4.5-1.8,5.2-2c0.8-0.2,3.7-1.2,6.2-2.2c6-2.2,8.8-3.2,10.8-3.8c0.8-0.2,3.5-1,6-1.7c2.5-0.8,5.4-1.5,6.5-1.8 c1.1-0.3,4-0.9,6.3-1.5c2.4-0.5,6.2-1.3,8.5-1.6s5.5-0.8,7.2-1c8-1.2,26.5-1,33,0.5c2.2,0.5,8,1.8,11,2.5c2.7,0.6,14.8,5.1,16,6 c0.3,0.2,2.3,1.3,4.5,2.5c2.2,1.2,5.2,3,6.6,4c1.5,1,2.7,2,2.9,2c0.5,0,4.8,3.1,6.1,4.4c0.8,0.8,2.4,2,3.5,2.8 c1.1,0.8,2.8,2.1,3.8,3.1c0.9,0.9,2.6,2.2,3.7,3s2.7,1.9,3.5,2.6c3,2.5,10,8,11.8,9.2c1,0.7,2.6,2,3.7,3c1,1,2.4,2.1,3,2.5 c1.5,1,3.1,2.5,5,4.2c0.8,0.8,1.9,1.6,2.5,1.9c0.6,0.3,1.6,1.1,2.3,1.7c0.7,0.6,3.2,2.8,5.7,5c2.4,2.1,4.3,4,4.3,4.3 c0,0.3,0.2,0.5,0.5,0.5c1.8,0,24.7,22.5,31.1,30.5c0.8,1,1.9,2.2,2.5,3c0.5,0.7,1.8,2.2,2.6,3.5c0.8,1.2,2.8,4,4.4,6 c1.6,2.1,3.9,5.6,5,7.8c1.2,2.2,2.3,4.3,2.5,4.7c2.2,3.6,7.8,16.8,8.2,19.5c0.2,0.7,0.7,2.7,1.2,4.5 C380.6,205.3,381.1,210.2,380.9,221.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207,288.5c-13.1-1.5-16.2-2-15.9-3.2c0.4-1.4,9.8-2.5,10.6-1.2c0.1,0.2,1.1,0.5,1.9,0.4 c1.1,0,1.6,0.1,1.5,0.5c-0.1,0.5,0.5,0.9,1.6,0.6c2.7-0.5,4.9-0.4,5.2,0.3c0.3,0.6,0.9,0.8,2.6,0.5c1.2-0.1,3.8-0.1,5.7,0.1 s3.8,0.2,4,0c0.6-0.5,3.1-1,5-1.3c3.8-0.4,4.9-0.6,5.2-1.2c0.2-0.4,0.6-0.5,0.9-0.3c0.5,0.3,1.8-0.9,1.4-1.2 c-0.1-0.1,0.9-0.2,2.1-0.1c3.3,0,7.9,1.1,9.2,2.1c2.1,1.7,0.2,2.6-8.3,4C236.3,289.1,212.4,289,207,288.5L207,288.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283,287.5c-10.8-0.6-20.5-1.5-21.7-1.9c-2.5-1,9.5-1.8,35.7-2.6l19.7-0.6l1.8,2c2,2.4,4,3.1,5.2,1.9 c0.5-0.5,1.1-0.8,1.5-0.8s1-0.4,1.3-0.8c0.6-0.8,2.8-1,4.2-0.5c1.5,0.5,0.8,1.6-1.5,2.5c-2.1,0.8-4.8,0.9-20.4,1 C298.9,287.9,287.3,287.7,283,287.5L283,287.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M201.2,307.4c-1.7,1.5-1.8,1.6-6.3,1.5c-2.6,0-6.4-0.4-8.4-0.7c-4.8-0.9-8-2.3-9.7-4.3 c-1.5-1.7-1.5-2.1-0.8-3.5c0.9-1.7,3.9-3.1,7.5-3.5c4.2-0.5,11.6,0.1,15,1.3C203.7,300,204.8,304,201.2,307.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M189.1,284.7c-0.7,1.6-3.4,3.1-11.3,6.5c-12.3,5.3-19.8,7.5-31.8,9.3c-9.2,1.4-26.5,1.7-34.6,0.7 c-10.9-1.4-24.2-5.5-26.8-8.4c-1.4-1.6-1.8-4-0.9-5.8c2-3.9,9-6.7,22.5-8.9c9.1-1.5,27-1.2,44,0.8c7.5,0.8,17.7,1.6,22.8,1.8 C187.3,281.2,190.3,282,189.1,284.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78,291.8c-3.1,2.1-7.8,2.7-12.2,1.6c-2.2-0.6-3-1.9-2.6-3.9c0.8-3.3,4.8-4.6,10.4-3.3 C80.2,287.8,81.6,289.5,78,291.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M250,271.4c0,0.8-1,1.9-4.4,4.6c-5.1,4.2-14.7,8.2-19.6,8.5c-0.7,0-3.6,0.1-6.5,0.2s-6.6,0-8.2-0.2 c-7.2-1.1-19.2-4.6-19.2-5.6c0-0.3-0.8-0.6-1.7-0.6c-2.3,0-11.5-4.4-11.8-5.5c-0.1-0.7,0.1-0.8,0.6-0.6c0.4,0.1,0.9,0.1,1,0 c0.1-0.2,4.5-0.2,9.6-0.2c5.2,0,15.4-0.2,22.7-0.7c15.1-0.8,32-1,34.5-0.2c1.2,0.3,2,0.3,2.4,0C249.8,270.5,250,270.6,250,271.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M326,281.7c0-1.2,1-2.7,1.8-2.7c1,0,1,0.3-0.1,2C326.7,282.6,326,282.9,326,281.7L326,281.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M318.8,280.9c-0.5-2-0.4-3.4,0.4-3.4c0.7,0,1.3,1.5,1.3,3.4c0,0.6-0.3,1.1-0.7,1.1 C319.4,282,319,281.5,318.8,280.9L318.8,280.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M329.2,273.5c0.9-2.5,1.9-4.5,2.2-4.5c0.9,0,0.8,0.8-0.6,4.6c-1.5,4-1.6,4.4-2.5,4.4 C327.8,278,328,276.8,329.2,273.5L329.2,273.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M169.8,274.5c-2.1,2.3-8.3,3.2-12.7,1.8c-3.6-1.1-4.5-2.5-3.2-5.2c1-1.9,3-2.8,6.3-2.5c2.8,0.2,8.3,2.5,9.6,4 C170.6,273.5,170.6,273.5,169.8,274.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M250.5,270.6c0-1.2,2.8-4.6,3.9-4.6c0.5,0,0.2,0.7-0.9,2.2C251.2,271.4,250.5,271.9,250.5,270.6L250.5,270.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M317.1,267.8c-0.7-1.5-0.8-3.2-0.2-3.2c0.5,0,1.5,1.6,2.1,3.3c0.4,1,0.3,1.2-0.5,1.2 C318,269,317.4,268.5,317.1,267.8L317.1,267.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M175.5,264.8c0-1.2,0.2-1.8,0.8-1.8s0.8,0.5,0.8,1.8s-0.2,1.8-0.8,1.8S175.5,266,175.5,264.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M182.4,263.6c0.5-1.3,1.3-2.5,1.8-2.5c0.8-0.1,0.7,0-0.1,2.2c-0.5,1.3-1.3,2.5-1.8,2.5 C181.6,266,181.6,265.9,182.4,263.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M255.5,263.8c0-1,3-6.2,3.6-6.2c0.8,0,0.4,1.4-0.9,3.6C256.7,263.9,255.5,265,255.5,263.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M311.6,261.9c-0.6-0.3-1.1-0.9-1.1-1.2c0-0.5,0.2-0.5,1.6,0c1.6,0.6,2.5,1.9,1.3,1.8 C313,262.4,312.2,262.2,311.6,261.9z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M184,260c0-0.3,0.9-3.4,1.9-6.9c1.1-3.5,2.1-7.1,2.3-7.9c0.2-1,0.6-1.6,1.1-1.6c0.9,0,0.7,1.1-2.1,9.9 c-1.1,3.7-2.4,6.8-2.6,7C184.3,260.5,184,260.4,184,260L184,260z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M218.4,259.4c-1.6-1.2-1.4-3.2,0.4-3.9c2.6-1,5.9,1.4,4.8,3.5C222.9,260.1,219.7,260.4,218.4,259.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M300.1,259c-1.8-0.4-2.5-0.9-2-1.3c0.4-0.5,5.9,0.8,5.9,1.4C304,259.6,302.5,259.6,300.1,259L300.1,259z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M175.5,258.4c0-1.5,0.6-2.9,1.4-2.9c0.6,0,0.7,0.3,0.4,1.1c-0.1,0.6-0.3,1.4-0.3,1.8c0,0.3-0.4,0.6-0.8,0.6 S175.5,258.7,175.5,258.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M292.6,257.4c-2.1-0.5-2.2-1.6,0-1.2c1.8,0.4,2.1,0.5,1.9,1.2C294.3,257.6,293.6,257.6,292.6,257.4L292.6,257.4 z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M282,255c-0.4-0.2-0.5-0.6-0.4-0.8c0.5-0.4,3.4,0.2,3.4,0.8C285,255.7,283,255.6,282,255z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M334,253.9c0-1.5,0.6-2.9,1.3-2.9c0.8,0,0.9,0.6,0.4,2.4C335.3,254.5,334,254.9,334,253.9L334,253.9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M311.6,251.6c-1.5-0.6-0.5-1,2.4-1s3.8,0.4,2.2,1.1C315.3,252.1,312.6,252.1,311.6,251.6L311.6,251.6z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M226.1,250.1c-0.3-0.5-0.6-1.9-0.9-3c-0.2-1.6-0.2-2.1,0.4-2.1c0.7,0,1.9,3.2,1.9,5.2 C227.5,251.3,226.6,251.2,226.1,250.1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M303.1,249.9c-1.6-0.4-2.3-1.4-1-1.4s4.4,1.1,4.4,1.5C306.5,250.6,305.3,250.6,303.1,249.9z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M334.5,249.6c0-1.5,0.5-2.6,1.3-2.6s0.9,0.6,0.4,2.4C335.8,250.8,334.5,250.9,334.5,249.6L334.5,249.6z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M296.2,248.5c-0.8-0.2-2.1-0.6-2.9-0.7c-2.2-0.5-1.8-1.4,0.5-1.1c3.5,0.6,5.6,1.4,5.6,1.8 C299.5,249.1,298.4,249.1,296.2,248.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M322,247c1.3-1.8,1.6-2.1,2.4-1.6s-1.5,3.1-2.6,3.1C321,248.5,321.1,248.3,322,247z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M177,246.4c0-1.5,0.6-2.9,1.4-2.9c0.6,0,0.7,0.3,0.4,1.1c-0.1,0.6-0.3,1.4-0.3,1.8c0,0.3-0.4,0.6-0.8,0.6 S177,246.7,177,246.4z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M282.6,245.6c-3.5-0.8-4.4-2-1.1-1.4c4.2,0.6,7,1.4,7,1.9C288.5,246.7,286.4,246.6,282.6,245.6L282.6,245.6z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M273.5,243.5c-0.4-0.2-0.5-0.6-0.4-0.8c0.5-0.4,3.4,0.2,3.4,0.8C276.5,244.2,274.5,244.1,273.5,243.5z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M189,242.4c0-1.7,1.2-4.9,1.9-4.9c0.6,0,0.6,0.4,0.4,1.3c-0.2,0.8-0.5,1.9-0.6,2.8 C190.4,242.9,189,243.7,189,242.4L189,242.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M178,240.4c0-1.5,0.6-2.9,1.4-2.9c0.6,0,0.7,0.3,0.4,1.1c-0.1,0.6-0.3,1.4-0.3,1.8c0,0.3-0.4,0.6-0.8,0.6 S178,240.7,178,240.4z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M326.5,240.2c0-1.2,1-2.7,1.8-2.7c1,0,1,0.2,0,2C327.4,241.1,326.5,241.5,326.5,240.2z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M264.3,236.2c-0.1-0.4-0.4-1.9-0.6-3.2c-0.2-2.1-0.2-2.5,0.5-2.5c0.8,0,1,0.5,1.6,4.6c0.2,1.4,0.1,1.9-0.5,1.9 C264.9,237,264.5,236.6,264.3,236.2z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M329,236.2c0-1.2,1.6-2.9,2.6-2.6c0.5,0.1,0.3,0.6-1,1.9C329.2,237,329,237,329,236.2L329,236.2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M190.5,235.9c0-1.5,0.6-2.9,1.4-2.9c0.6,0,0.7,0.3,0.4,1.1c-0.1,0.6-0.3,1.4-0.3,1.8c0,0.3-0.4,0.6-0.8,0.6 S190.5,236.2,190.5,235.9z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M179,234.9c0-1.5,0.6-2.9,1.4-2.9c0.6,0,0.7,0.3,0.4,1.1c-0.1,0.6-0.3,1.4-0.3,1.8c0,0.3-0.4,0.6-0.8,0.6 S179,235.2,179,234.9z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M228,233.6c0-0.3,0.6-1.1,1.2-1.9c1.1-1.2,1.2-1.3,1.2-0.4c0,0.6-0.3,1.4-0.6,1.9 C229.1,234.1,228,234.3,228,233.6z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M192,228.9c0-1.5,0.6-2.9,1.3-2.9c0.8,0,0.9,0.6,0.4,2.4C193.3,229.5,192,229.9,192,228.9z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M219.1,225.9c-0.9-0.9-0.7-1.4,0.9-1.4c1.6,0,2.1,1.1,0.7,1.7C219.7,226.6,219.8,226.6,219.1,225.9L219.1,225.9 z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M181.2,224.4c0.1-0.6,0.3-1.4,0.3-1.8c0-0.4,0.4-0.6,0.8-0.6c0.8,0,0.9,0.6,0.4,2.4c-0.2,0.6-0.6,1.1-1.1,1.1 C181.1,225.5,180.9,225.2,181.2,224.4z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M262.8,224.4c-0.5-1.8-0.4-2.4,0.4-2.4s1.3,1.1,1.3,2.6C264.5,225.9,263.2,225.8,262.8,224.4L262.8,224.4z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M193,223.9c0-1.5,0.6-2.9,1.3-2.9c0.8,0,0.9,0.6,0.4,2.4C194.3,224.5,193,224.9,193,223.9z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M231.8,221.6c-1.2,1-2.6,1-4.2,0.3c-1.6-0.8-2-2.9-0.9-3.8c1.4-1.1,3.6-0.8,5,0.6 C233.3,220.2,233.3,220.7,231.8,221.6z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M182.8,217.6c0.4-1.6,1.1-2.5,1.5-2.1c0.6,0.6-0.4,3.4-1.1,3.4C182.6,219,182.6,218.6,182.8,217.6L182.8,217.6z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M194,217.9c0-1.5,0.6-2.9,1.3-2.9c0.8,0,0.9,0.6,0.4,2.4C195.3,218.5,194,218.9,194,217.9z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M185.5,207.9c0-1.5,0.6-2.9,1.3-2.9c0.9,0,0.9,0.5,0.2,2.2C186.5,208.6,185.5,209,185.5,207.9z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M195.5,207.1c0-1.7,0.6-3.1,1.3-3.1c0.8,0,0.9,1.1,0.4,2.9C196.8,208.2,195.5,208.4,195.5,207.1z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M187,203.1c0-1.7,1.3-4.6,2.1-4.6c0.9,0,0.9,0.1,0,2.4C188.3,203,187,204.4,187,203.1z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M249.8,201.2c-1.1-1-3.2-2.5-4.6-3.4c-2.8-1.6-3.3-2.4-1.7-2.4c0.9,0,7.8,4.6,9.8,6.6c0.9,0.9,0.9,0.9-0.2,0.9 C252.3,202.9,250.9,202.1,249.8,201.2L249.8,201.2z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M236.6,193.6c-4.4-1.8-4.2-3,0.1-1.4c3.8,1.4,4.2,1.6,4.2,2.3C241,195.2,240.1,195.1,236.6,193.6L236.6,193.6z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M221.9,189.6c-1.2-0.3-1.1-1.1,0.1-1.1c1.3,0,2.6,0.5,2.6,1.1C224.5,190,223.4,190.1,221.9,189.6L221.9,189.6z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M214.9,188.6c-0.5-0.1-0.9-0.4-0.9-0.7s0.4-0.4,0.9-0.4c1.4,0,3.1,0.6,3.1,1.1S216.4,189.1,214.9,188.6 L214.9,188.6z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M209.4,188.1c-0.5-0.1-0.9-0.4-0.9-0.7s0.4-0.4,0.9-0.4c1.4,0,3.1,0.6,3.1,1.1S210.9,188.6,209.4,188.1 L209.4,188.1z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M194,187.4c0-0.8,1.4-1.1,4.7-0.9c4.1,0.1,5.8,0.4,5.8,1.1c0,0.2-2.2,0.4-5.2,0.3 C196.4,187.8,194,187.6,194,187.4z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M185.6,172c-1.2-0.6-2.1-1.2-2.1-1.5c0-0.6,0.2-0.6,2.3,0.2l1.8,0.8l-0.3-1.2c-0.2-1-0.1-1.1,0.6-0.9 c1.1,0.4,1.6,1.1,1.6,2.6C189.5,173.3,188.6,173.3,185.6,172L185.6,172z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M176.6,168.2c-0.9-0.4-1.6-0.9-1.6-1.2c0-0.6,0-0.6,1.9,0.1c0.9,0.3,1.6,0.9,1.6,1.2 C178.5,169.2,178.6,169.2,176.6,168.2z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M150.9,166.6c-3.9-0.4-1.7-0.9,3.9-0.9c6.1,0,7.4,0.4,3.1,0.9C155.2,167,154.2,167,150.9,166.6z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M171.6,166.2c-0.9-0.4-1.6-0.9-1.6-1.2c0-0.6,0-0.6,1.9,0.1c0.9,0.3,1.6,0.9,1.6,1.2 C173.5,167.2,173.6,167.2,171.6,166.2z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M144.4,166.1c-1-0.2-1.2-1.1-0.2-1.1c1.2,0,2.9,0.6,2.9,1.1S145.9,166.6,144.4,166.1L144.4,166.1z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M184.5,163c-0.7-2.9-0.5-3.6,1.2-4.8c1.6-1.1,2.4-0.4,0.8,0.8c-1.1,0.8-1.1,1.1-0.6,2.9 c0.8,2.6,0.7,3.7-0.1,3.7C185.4,165.5,184.9,164.5,184.5,163z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M135.9,164.6c-0.5-0.1-0.9-0.5-0.9-0.9c0-0.5,0.4-0.6,1.8-0.1C139.6,164.5,138.8,165.4,135.9,164.6z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M120.9,158.5c-0.9-0.5-2.1-1.3-2.4-1.7c-1.1-1.4,0.8-1,3.2,0.6C125.1,159.5,124.5,160.4,120.9,158.5 L120.9,158.5z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M191.5,154.4c1.1-0.9,1.8-1.2,1.9-0.9c0.2,0.7-1.9,2.4-2.9,2.4C190.1,155.9,190.4,155.3,191.5,154.4z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M196.5,149.5c1.4-1.9,2-2.3,2-1.1c0,1.1-1.4,2.6-2.4,2.6C195.7,151,195.8,150.4,196.5,149.5z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.3,146.7c-0.4-1.1-0.3-2.7,0.1-2.7s2.1,2.6,2.1,3.2C110.5,147.8,108.6,147.4,108.3,146.7z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M106.9,125.1c0.8-1.8,2.8-5.1,3.2-5.1c0.8,0,0.4,1.3-0.9,3.7c-0.7,1.2-1.6,2.3-2,2.3 C106.8,126,106.6,125.7,106.9,125.1z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M199.1,123.2c-1.4-2.5-1.4-2.8-0.6-2.8c0.6,0,1.4,0.8,2.1,1.9c1.8,2.8,1.9,3.6,0.9,3.6 C201.1,125.9,200.1,124.8,199.1,123.2z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M192.1,114.9c-2.4-1.8-3.4-3.4-2.2-3.4c0.9,0,5.1,3.8,5.1,4.7c0,0.4-0.1,0.8-0.1,0.8 C194.8,117,193.5,116.1,192.1,114.9z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M119.5,111.6c0-0.4,2.6-2.1,3.2-2.1c0.8,0,0.1,1.1-1.2,1.8C119.8,112.1,119.5,112.2,119.5,111.6z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M175.1,105.8c-2.1-0.7-2.1-1.6-0.1-1.2c1.8,0.3,2.1,0.6,1.9,1.2C176.8,106.1,176.1,106.1,175.1,105.8z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M132,105.6c0-0.6,2.9-1.3,3.4-0.9c0.4,0.4,0,0.8-1.8,1.1C132.6,106,132,105.9,132,105.6z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M167.9,104.2c-1.2-0.3-1.1-1.2,0.1-1.2c1.3,0,2.6,0.5,2.6,1.1C170.5,104.5,169.4,104.6,167.9,104.2z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M140.5,103.6c0-0.6,2.9-1.3,3.4-0.9c0.4,0.4,0,0.8-1.8,1.1C141.1,104,140.5,103.9,140.5,103.6z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M161.9,103.2c-1-0.2-1.2-1.2-0.2-1.2c1.2,0,2.9,0.6,2.9,1.1C164.5,103.5,163.4,103.6,161.9,103.2z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M150,102.6c0-0.6,4.9-1.1,6.4-0.8c2.2,0.6,1,1.2-2.6,1.2C151.7,103,150,102.8,150,102.6z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M218.2,284.5c-0.8-0.3-0.4-0.5,1.2-0.5s2,0.1,1.2,0.5c-0.6,0.2-1.1,0.5-1.2,0.5S218.8,284.8,218.2,284.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M324.5,284.1c0-0.9,1.5-3.1,2-3.1c0.8,0,0.5,0.9-0.8,2.4C325.1,284.1,324.5,284.5,324.5,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M208,283.5c0-0.6,1.4-0.6,2.8,0c0.8,0.4,0.6,0.5-0.9,0.5C208.8,284,208,283.8,208,283.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M227.5,283.9c0.1-0.1,1.9-0.9,4-1.5c2.1-0.7,4.6-1.6,5.6-2c1-0.5,1.9-0.6,1.9-0.4c0,0.6-7.1,3.4-9.8,3.9 C228.1,284,227.4,284,227.5,283.9L227.5,283.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M204.8,283.1c-1.3-0.3-2.2-1.1-1.2-1.1c1.3,0,2.9,0.6,2.9,1C206.5,283.5,206.4,283.5,204.8,283.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M190,278.3c-8.2-3.4-9-3.7-9-4.2c0-0.3,1.9,0.3,4.1,1.2c2.2,1,5.4,2.2,6.9,2.8c2.6,1,3.9,1.7,3.4,2.1 C195.3,280.3,192.9,279.4,190,278.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M243.8,276.2c3.2-2.8,4.9-4,4.6-3.1c-0.3,0.9-5.2,5-6.1,5C242,278,242.6,277.2,243.8,276.2L243.8,276.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M318.8,275.5c-0.3-1.9-0.1-3,0.5-2.4c0.5,0.5,0.9,4.5,0.4,4.5C319.4,277.5,319,276.6,318.8,275.5L318.8,275.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M178.1,273.1c-1.7-0.9-3.2-3.6-1.9-3.6c0.4,0,0.8,0.5,1,1.1c0.1,0.6,0.9,1.5,1.6,1.8s1.2,0.8,1.2,1.1 C180,274.1,180.1,274.1,178.1,273.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M330.6,270.4c1-4.7,2.6-9.9,3-9.9c0.5,0,0.1,2.5-1.2,7.4c-0.6,2-1.2,3.6-1.5,3.6S330.5,271,330.6,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M251.1,270c0-1,1.8-3.1,2.4-2.9c0.3,0.1-0.1,1-0.9,1.9C251.7,270,251.1,270.5,251.1,270z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M181.4,266.5c1.6-3.4,3.2-5,1.9-1.7c-1.4,3.3-2.1,4.4-2.6,4.6C180.3,269.5,180.7,268.2,181.4,266.5 L181.4,266.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M317.4,267.9c-0.4-0.9-1.3-2.4-2-3.2c-1.6-2-1.8-3-0.2-2c1.5,1,3.9,4.7,3.9,5.9 C319,270,318.1,269.6,317.4,267.9L317.4,267.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M255,264.6c0-0.9,1.5-3.1,2-3.1c0.8,0,0.5,0.9-0.8,2.4C255.6,264.6,255,265,255,264.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M183.5,261.7c0-1,0.9-2.7,1.4-2.7c0.2,0,0.2,0.8-0.1,1.8C184.3,262.5,183.5,263.1,183.5,261.7L183.5,261.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M175.7,259.9c0.1-0.9,0.4-1.7,0.6-1.8c0.6-0.5,0.8,0.5,0.5,1.9C176.3,262.1,175.3,262,175.7,259.9L175.7,259.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M302.8,259.5c-2.7-0.6-3.5-0.9-3.1-1.2s6,0.8,6.6,1.4C306.8,260.1,305.4,260.1,302.8,259.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M259.6,256.7c1.6-2.4,4.4-4.7,4.4-3.8c0,0.3-0.6,1.1-1.4,1.7c-0.8,0.6-1.9,1.9-2.4,2.8s-1.2,1.6-1.6,1.6 S258.6,258.1,259.6,256.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M333.5,258.4c0-1.2,0.6-2.9,1-2.9c0.5,0,0.6,1.5,0.1,2.7C334.3,259.2,333.5,259.2,333.5,258.4L333.5,258.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M293.9,257.6c-1.4-0.2-2-1.1-0.8-1.1s2.9,0.6,2.9,1c0,0.2-0.1,0.4-0.4,0.4 C295.4,257.9,294.6,257.7,293.9,257.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M176.1,254.7c0.1-1,0.4-1.9,0.6-2.1c0.6-0.6,0.9,0.4,0.6,2.1C176.9,257.1,175.8,257.1,176.1,254.7L176.1,254.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M283.8,255.4c-2.7-0.6-3.5-0.9-3.1-1.2c0.4-0.4,5.9,0.8,5.9,1.4C286.5,256,286.5,256,283.8,255.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M274.1,253.4c-1.2-0.2-2.1-0.6-2.1-0.9c0-0.2,1-0.2,2.1,0s2.2,0.4,2.5,0.4c0.2,0,0.4,0.2,0.4,0.5 C277,254,277,254,274.1,253.4L274.1,253.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M227.3,252.2c-0.2-0.4-0.2-0.9-0.1-1.1c0.4-0.4,1.8,0.9,1.4,1.4C228.3,253.2,227.6,253.1,227.3,252.2 L227.3,252.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M264.5,252.6c0-0.2,0.5-0.6,1.1-0.8c1.8-0.4,4.4-0.4,4.4,0.2c0,0.2-0.8,0.4-1.6,0.4c-0.9,0-2.1,0.1-2.8,0.3 C265,252.9,264.5,252.8,264.5,252.6L264.5,252.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M334.5,251.9c0-1.7,0.5-3.4,1-3.4c0.2,0,0.5,0.5,0.5,1.1c0,1.6-0.5,3.4-1,3.4 C334.7,253,334.5,252.5,334.5,251.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M176.8,249.6c0.4-3.3,0.8-4.1,1.4-4.1c0.5,0,0.4,1.1-0.4,5.1C177.2,253,176.4,252.1,176.8,249.6L176.8,249.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M187,250.9c0-1.2,1.1-4.9,1.6-4.9c0.6,0,0.6,0.6-0.1,3.3C187.9,251.2,187,252.4,187,250.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M309.4,251.1c-0.5-0.1-0.9-0.4-0.9-0.6c0-0.5,2.5-0.1,4.2,0.6c0.8,0.3,0.6,0.4-0.8,0.4 C311,251.4,309.9,251.3,309.4,251.1L309.4,251.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M304.8,250.1c-1.3-0.3-2.2-1.1-1.2-1.1c1.3,0,3,0.6,3,1.1S306.4,250.6,304.8,250.1L304.8,250.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M225.6,248.1c-0.2-0.8-0.4-3.1-0.4-5.2c0.1-3.3,0.3-4.4,1.6-7.1c0.9-1.8,1.8-3.2,2.1-3.2 c0.6,0,0.6,0.1-0.8,2.9c-0.7,1.4-1.4,3.6-1.7,5.1c-0.4,2.6,0,7.4,0.7,8.5c0.1,0.3-0.1,0.5-0.4,0.5 C226.3,249.5,225.8,248.9,225.6,248.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M297.9,248.6c-0.5-0.1-0.9-0.4-0.9-0.6c0-0.5,3-0.1,3.3,0.5C300.5,249,299.4,249,297.9,248.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M288.1,246.6c-0.9-0.1-1.6-0.4-1.6-0.7s0.6-0.4,1.6-0.2C290.8,246.3,290.8,246.9,288.1,246.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M335.2,245.4c0.1-0.9,0.4-1.7,0.5-1.8c0.5-0.6,0.8,0.4,0.5,1.9C335.8,247.6,334.8,247.5,335.2,245.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M277.4,244.3c-2.2-0.5-3.7-1.3-2.5-1.3s5.9,1.1,6.4,1.6C281.9,245.2,280.4,245.1,277.4,244.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M324.5,244.5c0-1.1,1.2-3,1.9-3c0.4,0,0.6,0.1,0.5,0.4c-1.1,2.2-1.6,3.1-2,3.1 C324.7,245,324.5,244.8,324.5,244.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M189.2,242.4c0.4-1.9,0.6-2.2,1.1-1.8s-0.3,3.4-0.9,3.4C189.1,244,189.1,243.4,189.2,242.4L189.2,242.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M335.3,242.2c-0.5-1.1-0.4-2.7,0.1-2.7s1,1.6,1,2.9C336.5,243.2,335.6,243.1,335.3,242.2L335.3,242.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M266.2,239.6c-1.9-2.8-3-7.1-1.8-7.1c0.2,0,0.7,1.1,1,2.4c0.3,1.3,1.1,3.1,1.8,3.9c0.6,0.9,1.2,1.8,1.2,2.1 C268.5,242.1,267.5,241.4,266.2,239.6L266.2,239.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M190.5,237.2c0-1.2,1.2-5.2,1.6-5.2c0.6,0,0.6,0.6-0.1,3.3c-0.3,1.2-0.8,2.2-1,2.2S190.5,237.4,190.5,237.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M329,235.5c1-1.4,2-2,2-1.2s-1.7,2.8-2.4,2.8C328.1,237,328.2,236.6,329,235.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M333.8,234.7c-0.5-0.7-0.7-1.4-0.6-1.6c0.4-0.3,2.4,1.7,2.4,2.4C335.5,236.4,334.6,236,333.8,234.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M179.5,233.8c0-0.7,2.1-10.1,2.2-10.2c0.8-0.8,0.6,0.8-0.2,5.1c-0.6,2.6-1,4.9-1,5.1s-0.2,0.2-0.5,0.2 C179.8,234,179.5,233.9,179.5,233.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M263.8,230.4c-0.5-1.7-0.4-3.9,0.1-3.9s1,1.8,1,3.6C265,231.8,264.2,231.9,263.8,230.4L263.8,230.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M192,230.6c0-0.9,3.1-16.9,3.2-17.1c0.8-0.7,0.7,1-0.2,6.5c-1.5,8.7-2,10.9-2.6,10.9 C192.2,231,192,230.8,192,230.6L192,230.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M183,217.9c0-1.4,1.1-4.9,1.6-4.9c0.3,0,0.4,0.6,0.2,1.3c-0.2,0.8-0.5,1.9-0.6,2.8 C183.9,218.4,183,219.1,183,217.9L183,217.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M260.3,215.1c-0.1-0.2-0.5-1-0.8-1.8c-0.4-1-0.4-1.3,0.1-1.3c0.6,0,1.8,2,1.8,3 C261.5,215.6,260.6,215.6,260.3,215.1L260.3,215.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M184.5,212.2c0-1.1,2.2-8.2,2.6-8.2c0.2,0,0.4,0.2,0.4,0.5c0,1.1-2.2,8-2.6,8 C184.7,212.5,184.5,212.4,184.5,212.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M257.6,210c-0.3-0.6-0.6-1.2-0.6-1.4c0-0.8-7.2-7.8-9.8-9.6c-3.1-2.1-2.9-1.9-2.6-2.3c1-0.9,9.4,5.9,12.7,10.4 c1.2,1.6,2.2,3.2,2.2,3.4C259.5,211.4,258.2,211,257.6,210L257.6,210z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M195.8,207.6c0.5-3.8,0.8-4.6,1.3-4.6s0.4,1.6-0.4,5.6C196.2,211,195.4,210.1,195.8,207.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M196.5,198.6c0-1.9,0.5-3.6,1.1-3.6c0.5,0,0.6,2.2,0.1,3.9C197.2,200.4,196.5,200.3,196.5,198.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M189.1,196.9c0.4-0.9,0.9-1.8,1.2-1.9c0.5-0.1,0.5,0.1-0.1,1.4c-0.4,0.9-0.9,1.8-1.2,1.9 C188.6,198.5,188.6,198.2,189.1,196.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M191.6,191.1c0.6-1.8,1.9-3.4,2.2-3.1c0.4,0.4-1.7,4.4-2.3,4.4C191.2,192.5,191.2,191.9,191.6,191.1 L191.6,191.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M229.4,191.1c-1.5-0.4-1-1.2,0.5-0.9c1.7,0.4,2.6,1.2,1.4,1.1C230.7,191.4,229.9,191.3,229.4,191.1 L229.4,191.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M219.8,189c-0.8-0.4-0.6-0.4,0.9-0.4c1-0.1,1.9,0.2,1.9,0.4C222.5,189.6,221.1,189.6,219.8,189z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M204.2,187.5c-0.8-0.3-0.4-0.4,1.5-0.4c1.4,0,2.9,0.2,3.5,0.4c0.8,0.3,0.4,0.4-1.5,0.4 C206.4,187.9,204.8,187.8,204.2,187.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M194.8,186.9c0.4-0.6,3.2-0.4,4.4,0.1c0.7,0.4,0.2,0.4-1.9,0.4C195.8,187.3,194.7,187.1,194.8,186.9 L194.8,186.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M187.2,172.2c-0.8-0.6-0.8-0.8-0.1-0.5c1.1,0.4,1.1-0.5,0.1-2.2c-0.9-1.5-0.9-2.5-0.2-2.5 c0.4,0,2.9,4.9,2.9,5.8C190,173.3,188.1,172.9,187.2,172.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M183.1,170.7c-0.9-0.4-1.6-0.9-1.4-1c0.4-0.4,3.4,0.8,3.4,1.4S185.1,171.6,183.1,170.7L183.1,170.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M174.5,167.2c-2.9-1.2-5.6-2.1-5.9-1.9c-0.4,0.1-0.6,0-0.6-0.2c0-0.9,2-0.5,6.6,1.3c4.4,1.6,5.8,2.4,5.3,2.9 C179.8,169.3,177.4,168.4,174.5,167.2L174.5,167.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M146.5,166c-0.6-0.4-0.6-0.5,0.2-0.4c0.6,0,1.4,0.2,2,0.4c0.9,0.4,0.9,0.4-0.2,0.4 C147.8,166.4,146.9,166.2,146.5,166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M138.9,165.1c-0.5-0.1-0.9-0.4-0.9-0.6c0-0.5,2.9-0.1,3.3,0.5C141.6,165.5,140.4,165.5,138.9,165.1 L138.9,165.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M185.1,163.9c-0.3-0.9-0.6-2-0.6-2.5c0-1.8,0.8-0.9,1.6,1.6c0.6,2,0.6,2.5,0.1,2.5 C185.9,165.5,185.4,164.8,185.1,163.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M129.6,162.4c-0.6-0.3-1.1-0.8-1.1-0.9c0-0.5,2.9,0.5,3.3,1.1C132.2,163.2,131,163.1,129.6,162.4L129.6,162.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M124.6,160.2c-1.4-0.7-2.6-1.5-2.6-1.8c0-0.2,0.2-0.4,0.4-0.3c2.8,1.4,5.1,2.7,5.1,3 C127.5,161.6,127.5,161.6,124.6,160.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M115.1,154.2c-0.9-0.7-1.5-1.5-1.3-1.8c0.2-0.2-0.1-0.4-0.4-0.4c-1.1,0-4.4-4.4-6.1-7.8 c-1.3-2.9-2.7-8.9-2.1-9.6c0.6-0.5,0.8,0.1,1.2,2.1c0.7,5,4.2,11.4,8.6,15.5C117.7,155,117.9,156.3,115.1,154.2L115.1,154.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M195.7,150.9c2.2-2.8,4.6-6.6,5.4-8.5c0.4-1.1,0.9-1.9,1.3-1.9c0.7,0,0.4,1.1-1.3,4.4 c-1.2,2.4-5.4,7.6-6.1,7.6C194.6,152.5,195,151.8,195.7,150.9L195.7,150.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M105.2,131.6c0.7-4.1,0.9-4.7,1.6-4.7c0.6,0,0.6,0.3,0.2,1.4c-0.2,0.8-0.6,2.2-0.8,3.2c-0.2,1-0.6,1.9-0.8,1.9 C105.1,133.5,105,132.8,105.2,131.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M200.8,125.5c-0.1-0.6-1.1-2.1-2.1-3.4c-1.6-2.4-2.3-4.4-1.1-3.8c0.7,0.4,3.8,5.3,4.4,6.9 c0.4,0.9,0.3,1.2-0.2,1.2C201.4,126.5,200.9,126.1,200.8,125.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107,125.2c0-0.6,1.7-3.2,2.1-3.2c0.6,0,0.5,0.3-0.3,2C108.1,125.3,107,126.1,107,125.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M110.4,119.7c1.2-1.8,3.1-3.4,3.3-3.1c0.3,0.3-3.2,4.4-3.8,4.4C109.6,121,109.8,120.4,110.4,119.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M191.5,114.1c-1.2-1.1-1.5-1.5-0.9-1.6c1.1,0,3.1,1.7,2.9,2.4C193.3,115.3,192.6,115,191.5,114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M116.5,114.1c0-0.5,2.6-2.6,3.2-2.6s-0.2,0.9-1.8,2C117.2,114.1,116.5,114.3,116.5,114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M125,108.6c0-0.2,0.4-0.6,0.9-0.7c0.4-0.1,1.3-0.4,1.8-0.7c0.7-0.2,0.8-0.2,0.7,0.2 C127.9,108.1,125,109.1,125,108.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M178.6,106.9c-0.6-0.3-1.1-0.8-1.1-0.9c0-0.5,2.9,0.5,3.3,1.1C181.2,107.7,180,107.6,178.6,106.9L178.6,106.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M132,105.6c1.2-0.7,6.5-2,6.5-1.6c0,0.2-1.4,0.8-3,1.2C132.2,106.1,130.8,106.2,132,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M170.9,104.6c-3.9-0.9-3.7-1.7,0.1-0.8c3.4,0.8,5.5,1.7,3.7,1.6C174.2,105.4,172.4,105,170.9,104.6 L170.9,104.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M163.2,103c-0.9-0.3-0.8-0.4,0.6-0.4c0.9-0.1,1.8,0.2,1.9,0.4C166.1,103.6,164.6,103.6,163.2,103z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M146.8,102.5c0.1-0.2,1.1-0.5,1.9-0.4c1.4,0,1.4,0.1,0.6,0.4C147.9,103.1,146.4,103.1,146.8,102.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M319.8,284c-0.9-1.8-1-3-0.1-3c0.4,0,1,0.8,1.3,1.8c0.4,1,0.9,1.8,1.1,1.8s0.5,0.2,0.5,0.5 C322.5,286.1,320.5,285.4,319.8,284z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M214.4,284.6c-1.5-0.4-1-1.1,0.8-1.1c2.1,0,3.9,0.5,3.9,1C219,285,215.9,285,214.4,284.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M221,284.6c0-0.5,3.4-1.4,3.9-0.9s0,0.7-2,1C221.7,285,221,284.9,221,284.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M209.4,284.1c-0.5-0.1-0.9-0.5-0.9-0.7c0-0.8,3.1-0.3,3.4,0.5C212.1,284.5,211.1,284.6,209.4,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M206.3,283.5c-0.8-0.1-1.6-0.5-1.7-1c-0.2-0.5,0.1-0.6,1.4-0.4c1.9,0.4,2.2,0.5,1.9,1.1 C207.8,283.6,207.1,283.6,206.3,283.5L206.3,283.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M230,283.1c0-0.2,0.8-0.6,1.8-1c1.4-0.5,1.8-0.4,1.8,0.1c0,0.4-0.5,0.8-1.1,1 C230.8,283.6,230,283.6,230,283.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M200.4,282.1c-0.5-0.1-0.9-0.5-0.9-1s0.4-0.6,1.4-0.4c1.7,0.5,2.1,0.6,2.1,1.2 C203,282.5,201.9,282.5,200.4,282.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M234.1,281.9c0.1-0.3,0.9-0.9,1.9-1.2c1.3-0.5,1.6-0.5,1.4,0c-0.1,0.3-0.9,0.9-1.9,1.2 C234.2,282.4,233.9,282.4,234.1,281.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M190.2,278.5c-4-1.6-6.1-2.6-6.1-3.2c-0.1-0.8-0.1-0.8,2,0c1.2,0.5,2.4,1,2.6,1.2c0.3,0.2,2.1,0.9,3.9,1.5 c2.9,1,4.4,2,3.8,2.7C196.3,280.9,193.6,279.9,190.2,278.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M238,280.1c0-0.5,4.1-3.1,4.9-3.1c1.2,0,0.4,0.9-1.9,2.1C238.4,280.6,238,280.8,238,280.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M328,277.5c0-1.2,1-3,1.8-3c0.6,0,0.6,0.2,0.1,1.6C329.2,277.6,328,278.6,328,277.5L328,277.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M245,275c0.9-0.8,1.8-1.2,1.9-1c0.3,0.9-1.4,2.5-2.6,2.5C243.4,276.5,243.4,276.2,245,275L245,275z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M180.6,274.4c-0.6-0.3-1.1-0.9-1.1-1.2s0.1-0.6,0.4-0.5c2.2,1.1,3.1,1.6,3.1,2 C183,275.1,182,275.1,180.6,274.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M176,271.5c-0.7-1.4-0.6-2.5,0.2-2.5c0.6,0,1.3,1.4,1.3,2.9C177.5,272.9,176.6,272.6,176,271.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M330,271.9c0-1.5,0.6-2.9,1.3-2.9c0.9,0,0.9,0.5,0.2,2.2C331,272.6,330,273,330,271.9L330,271.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M251,269c1.4-2,2-2.3,2-1.1c0,1-1.4,2.6-2.4,2.6C250.2,270.5,250.3,270,251,269z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M317.8,269c-0.2-0.9-0.2-1.6,0-1.9c0.5-0.5,1.8,1.4,1.8,2.5C319.5,271.1,318.1,270.6,317.8,269z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M181.3,266.6c0.4-1,0.9-2.2,1.1-2.5c0.1-0.4,0.6-0.6,0.9-0.6c0.6,0,0.6,0.3-0.1,1.9c-0.4,1-0.9,2.1-1.1,2.5 c-0.1,0.3-0.6,0.6-0.9,0.6C180.6,268.5,180.6,268.2,181.3,266.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M175.5,265c0-2.1,0.2-3,0.6-3c0.5,0,0.7,0.9,0.7,3s-0.2,3-0.7,3C175.7,268,175.5,267.1,175.5,265z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M253.6,266.8c0-1.2,1.1-2.8,1.9-2.8c0.9,0,0.7,0.9-0.7,2.4C253.6,267.6,253.6,267.6,253.6,266.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M316.1,265.9c-0.4-0.4-0.6-1.1-0.6-1.9v-1.3l1.2,1.4c0.7,0.8,1.2,1.6,1.2,1.9 C318,266.7,316.8,266.6,316.1,265.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M256,262.8c0-1,1.9-3.1,2.2-2.7c0.4,0.4-1.2,3.4-1.9,3.4C256.2,263.5,256,263.2,256,262.8L256,262.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M311,261.5c-0.4-0.2-2-0.7-3.4-1c-3-0.7-3.7-1.8-0.9-1.2c3,0.5,5.4,1.5,5.6,2.1 C312.6,262.1,312.1,262.1,311,261.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M175.5,258.9c0-1.4,0.6-2.9,1.2-2.9c0.4,0,0.6,0.6,0.4,1.8c-0.1,1-0.5,1.8-0.9,1.8S175.5,259.2,175.5,258.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M300.9,259.1c-1-0.2-1.2-1.1-0.2-1.1c1.2,0,2.9,0.6,2.9,1C303.5,259.5,302.4,259.5,300.9,259.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M295.9,258.1c-0.5-0.1-0.9-0.5-0.9-0.7s0.4-0.5,0.9-0.5c1.4,0,3.1,0.6,3.1,1 C299,258.5,297.5,258.5,295.9,258.1L295.9,258.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M259,257.5c0-0.3,0.5-1.1,1.2-1.9c1.4-1.6,1.8-0.6,0.5,1.2C259.9,258,259,258.4,259,257.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M287.9,256.4c-1.7-0.4-2.6-1.4-1.4-1.4c1.4,0,5.5,1.1,5.5,1.5C292,257.1,290.4,257,287.9,256.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M279.4,254.6c-0.5-0.1-0.9-0.4-0.9-0.7s0.4-0.4,0.9-0.4c1.4,0,3.1,0.6,3.1,1.1S281,255.1,279.4,254.6 L279.4,254.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M176.4,251.8c0.1-1.1,0.5-1.8,0.9-1.8c0.8,0,0.9,0.6,0.4,2.4C177.2,254.2,176.1,253.8,176.4,251.8 L176.4,251.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M269.9,252.6c-0.5-0.1-0.9-0.4-0.9-0.7s0.4-0.4,0.9-0.4c1.4,0,3.1,0.6,3.1,1.1S271.5,253.1,269.9,252.6 L269.9,252.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M186.5,252.1c0-1.6,1.8-6.6,2.4-6.6c0.7,0,0.6,0.5-0.6,4.7C187.8,252,186.5,253.3,186.5,252.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M311.8,251.8c-0.2-0.1-1.8-0.4-3.4-0.8c-1.6-0.3-2.9-0.8-2.9-1.1c0-0.6,0.9-0.6,5,0.4c2,0.4,3.5,1,3.5,1.2 C314,252,312.8,252.1,311.8,251.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M215.1,250C215.1,250,215.1,250,215.1,250C215.1,249.9,215.1,249.9,215.1,250 C215.1,249.9,215.1,249.9,215.1,250C215.1,250,215.1,250,215.1,250z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M215.7,249.9c-0.5,0.7-0.9,1-1.2,1c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0-0.1 c0.1,0,0.2-0.1,0.3-0.1c0,0,0,0,0.1,0c0,0,0,0,0,0c0.2-0.1,0.3-0.2,0.5-0.4c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0-0.1 c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v-0.1c0-0.1,0-0.2,0-0.2c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1v0 c-0.1-0.2-0.2-0.4-0.3-0.6c-0.2-0.2-0.4-0.4-0.6-0.5c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0.1-0.1c0,0,0,0,0,0 c0.1,0,0.1-0.1,0.2-0.1c0.3,0,0.6,0.2,1.1,0.7C216,248.9,216.1,249.3,215.7,249.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M225.8,249.4c-0.8-2.9,0.7-3.4,1.6-0.6c0.5,1.6,0.4,1.8-0.4,1.8C226.5,250.5,226,250,225.8,249.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M318.5,250.1c0-0.2,0.8-0.9,1.8-1.6c1.3-0.8,1.8-0.9,1.8-0.4c0,0.4-0.5,1.1-1.2,1.5 C319.5,250.6,318.5,250.8,318.5,250.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M334.7,248.9c0.1-0.6,0.3-1.4,0.3-1.8c0-0.4,0.4-0.6,0.8-0.6c0.8,0,0.9,0.6,0.5,2.4c-0.2,0.6-0.6,1.1-1,1.1 C334.6,250,334.5,249.7,334.7,248.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M298.4,248.9c-1.7-0.4-2.6-1.4-1.4-1.4c1.4,0,5.5,1.1,5.5,1.6S300.9,249.6,298.4,248.9L298.4,248.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M291.1,247.4c-2-0.4-3-1.4-1.4-1.4c1.5,0,5.2,1.1,5.2,1.6C295,248.1,294,248.1,291.1,247.4L291.1,247.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M177.2,245.7c0.1-0.4,0.3-1.2,0.3-1.8c0-0.5,0.4-0.9,0.8-0.9c0.8,0,0.9,0.6,0.4,2.4c-0.2,0.6-0.6,1.1-1.1,1.1 C177.1,246.5,177,246.2,177.2,245.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M276,244c-0.4-0.2-0.5-0.6-0.4-0.8c0.5-0.4,3.4,0.2,3.4,0.8C279,244.7,277,244.6,276,244z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M270.2,242.7c-1.1-0.4-2-0.7-2.1-0.7s-0.1-0.4-0.1-0.9c0-1,0.2-0.9,4.5,1.3c0,0.1,0,0.3,0,0.6 C272.3,243.3,271.5,243.2,270.2,242.7L270.2,242.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M326,241.2c0-1.2,1-2.8,1.8-2.8c0.6,0,0.6,0.2,0.1,1.6C327.1,241.9,326,242.6,326,241.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M266.4,240.1c-1.2-1.3-2.2-3.9-2.6-6.8c-0.3-2-0.2-2.4,0.4-2.4c0.5,0,0.8,0.1,0.8,0.1c0,1.4,1.2,6.3,1.9,7.1 c0.4,0.6,0.6,1.5,0.5,2C267.2,241,267.1,241,266.4,240.1L266.4,240.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M178.2,239.7c0.1-0.4,0.3-1.2,0.3-1.8c0-0.5,0.4-0.9,0.8-0.9c0.8,0,0.9,0.6,0.4,2.4c-0.2,0.6-0.6,1.1-1.1,1.1 C178.1,240.5,178,240.2,178.2,239.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M189.7,239.7c0.1-0.4,0.4-1.6,0.6-2.8c0.2-1.1,0.6-1.9,1-1.9c0.9,0,0.9,0.4,0.1,3.3c-0.4,1.4-0.9,2.2-1.3,2.2 C189.6,240.5,189.5,240.2,189.7,239.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M334.8,239.4c-0.5-1.8-0.4-2.4,0.4-2.4c0.6,0,1.3,1.4,1.3,2.9C336.5,240.9,335.1,240.5,334.8,239.4 L334.8,239.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M191,234c0-0.2,0.2-1.6,0.6-3c0.4-1.6,0.8-2.5,1.3-2.5c0.6,0,0.7,0.4,0.5,1.1c-0.1,0.6-0.4,1.9-0.6,3 c-0.2,1.1-0.6,1.9-1.1,1.9C191.3,234.5,191,234.3,191,234z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M229.8,231c0.4-0.7,4.6-3.5,5.2-3.5c1.1,0,0.4,0.8-2.1,2.4C230.4,231.5,229.1,231.9,229.8,231z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M180.2,229.2c0.4-2.1,1.1-3.1,1.6-2.6s-0.5,4-1.2,4.2C180,231.1,179.9,230.7,180.2,229.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M192.5,226.4c0-1.5,0.6-2.9,1.4-2.9c0.6,0,0.7,0.3,0.4,1.1c-0.1,0.6-0.3,1.4-0.3,1.8c0,0.3-0.4,0.6-0.8,0.6 S192.5,226.7,192.5,226.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M219.4,225.9c-1-0.6-1.1-2.1-0.1-2.9c0.7-0.6,2.3-0.2,2.3,0.4c0,0.2,0.1,0.8,0.3,1.1 C222.2,225.7,220.5,226.5,219.4,225.9L219.4,225.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M181.5,223.4c0-1.5,0.6-2.9,1.3-2.9c0.6,0,0.6,0.4,0.4,1.4c-0.2,0.8-0.4,1.5-0.6,1.8 C182.3,224.2,181.5,224,181.5,223.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M193.7,220.4c0.1-0.6,0.3-1.4,0.3-1.8c0-0.4,0.4-0.6,0.8-0.6c0.8,0,0.9,0.6,0.4,2.4c-0.2,0.6-0.6,1.1-1.1,1.1 C193.6,221.5,193.4,221.2,193.7,220.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M260.2,215.4c-0.6-1.6-0.6-2.4,0.3-2.4c0.6,0,2,3.1,1.6,3.6C261.7,217.5,260.9,217,260.2,215.4L260.2,215.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M194.5,214.9c0-1.5,0.6-2.9,1.4-2.9c0.6,0,0.7,0.3,0.4,1.1c-0.1,0.6-0.3,1.4-0.3,1.8c0,0.3-0.4,0.6-0.8,0.6 S194.5,215.2,194.5,214.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M183.5,214.8c0-0.1,0.2-0.9,0.6-1.8c0.6-1.6,1.4-2.1,1.4-0.9c0,1.4-0.6,2.9-1.3,2.9 C183.8,215,183.5,214.9,183.5,214.8L183.5,214.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M258.3,211.4c-1-1.7-0.7-2.4,0.6-1.6c0.9,0.6,1.5,3.2,0.8,3.2C259.4,213,258.8,212.3,258.3,211.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M195.3,209.6c0.6-4.6,0.8-5.1,1.5-5.1s0.8-0.1-0.1,5.1c-0.2,1.1-0.6,1.9-1,1.9 C195.2,211.5,195.1,211,195.3,209.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M185.8,206.6c0.4-1.6,1.1-2.5,1.5-2.1c0.6,0.6-0.4,3.4-1.1,3.4C185.6,208,185.6,207.6,185.8,206.6 L185.8,206.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M252.6,203.8c-0.9-0.9-1.6-2.1-1.6-2.5c0-0.8,0.1-0.8,1.5,0.2c0.8,0.6,1.9,1.7,2.5,2.5c1,1.4,1,1.5,0.1,1.5 C254.6,205.5,253.5,204.8,252.6,203.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M196,203.4c0-1.2,0.6-2.9,1.1-2.9c0.2,0,0.4,0.8,0.4,1.8c0,1.2-0.2,1.8-0.8,1.8 C196.4,204,196,203.7,196,203.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M188.7,197.9c0.6-2.3,2.2-5.9,2.8-5.9c0.7,0,0.6,0.4-0.6,3.8C189.7,198.8,188.1,200.4,188.7,197.9 L188.7,197.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M237.4,193.9c-0.8-0.3-1.4-0.9-1.4-1.2c0-0.6,0.3-0.6,1.6,0c0.9,0.4,1.6,0.9,1.8,1.2 C239.6,194.6,239.3,194.6,237.4,193.9L237.4,193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M229.1,191.1c-2.4-0.7-3.6-1.6-2.1-1.6c1.6,0,4.9,1.2,4.9,1.8c0,0.4-0.1,0.7-0.1,0.6 C231.8,191.9,230.5,191.6,229.1,191.1L229.1,191.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M192,190.3c0-1.4,2.5-3.8,4.1-3.8c0.8,0,1.4,0.2,1.4,0.5s-0.6,0.5-1.2,0.5c-0.9,0-1.6,0.5-2.4,1.8 C192.7,191.1,192,191.4,192,190.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M218.9,189.1c-1-0.2-1.2-1.1-0.2-1.1c1.2,0,2.9,0.6,2.9,1.1S220.4,189.6,218.9,189.1L218.9,189.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M209.9,188.1c-0.5-0.1-0.9-0.4-0.9-0.8c0-0.2,0.4-0.4,0.8-0.2c0.4,0.1,1.2,0.3,1.8,0.3c0.5,0,0.9,0.2,0.9,0.5 C212.5,188.5,211.4,188.6,209.9,188.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M198.9,187.6c-1.5-0.4-1-1.1,0.8-1.1c2.1,0,3.9,0.5,3.9,1.1C203.5,188,200.4,188.1,198.9,187.6L198.9,187.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M187.9,172.9c-0.5-0.2-0.9-0.7-0.9-0.9c0-0.8,2.9-0.6,3.1,0.2C190.6,173.5,189.4,173.9,187.9,172.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M173.1,166.8c-1.7-0.7-2.4-2.1-0.8-1.5c0.4,0.2,1.2,0.5,1.8,0.6c0.4,0.1,0.9,0.6,0.9,0.9 C175,167.7,175.1,167.7,173.1,166.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M185.6,166.1c-0.8-1.5-1.7-6.1-1.4-6.6c0.6-0.9,1.7-0.6,1.4,0.4c-0.1,0.4,0.1,1.9,0.6,3.1 c0.9,2.5,0.9,4.1,0.2,4.1C186.2,167,185.9,166.6,185.6,166.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M144.4,166.1c-0.8-0.1-1.4-0.4-1.4-0.8s0.6-0.4,1.6-0.2c0.9,0.1,1.9,0.3,2.2,0.3c0.4,0,0.7,0.2,0.7,0.5 C147.5,166.5,146.9,166.6,144.4,166.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M158.8,166c1.4-0.6,2.8-0.6,2.8,0c0,0.3-0.9,0.5-1.9,0.4C158.1,166.4,157.9,166.3,158.8,166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162,166.1c0-0.4,4.6-1.6,6.1-1.6c1,0,0.2,0.9-0.9,1.2C163.2,166.5,162,166.6,162,166.1L162,166.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M132.4,163.6c-0.5-0.1-0.9-0.5-0.9-0.9c0-0.5,0.4-0.6,1.8-0.1C136.1,163.5,135.2,164.4,132.4,163.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M120.4,158.1c-1.5-0.9-1.8-1.6-0.8-1.6c0.8,0,2.8,1.4,2.8,2.1C122.5,159.2,121.9,159.1,120.4,158.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M116,155.1c-1.5-1.3-1.6-1.5-0.7-1.6c1.4,0,2.8,1.1,2.7,2.2C117.8,156.4,117.5,156.3,116,155.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M191,155.5c0-0.8,2.1-2.4,2.9-2.5c0.9,0,0.4,0.8-1.4,2C191.6,155.6,191,155.8,191,155.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M110,149.1c-1.2-1.5-1.3-1.9-0.8-2.1c0.9-0.2,1.9,0.6,3.3,2.5c1,1.4,1,1.4,0,1.4 C112,151,110.9,150.1,110,149.1L110,149.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M198.5,147.2c0-0.6,1.7-3.2,2.1-3.2c0.6,0,0.5,0.8-0.2,2.2C199.9,147.4,198.5,148.1,198.5,147.2L198.5,147.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M105.6,139.8c-0.7-2.9-0.7-3.3,0.1-3.3c0.4,0,1,1.1,1.4,2.8c0.7,2.6,0.7,2.8-0.1,2.8 C106.4,142,105.9,141.4,105.6,139.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M202.2,138.2c0.1-0.4,0.3-1.2,0.3-1.8c0-0.5,0.4-0.9,0.8-0.9c0.8,0,0.9,0.6,0.4,2.4c-0.2,0.6-0.6,1.1-1.1,1.1 C202.1,139,202,138.7,202.2,138.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M199,122.6c-0.6-1.2-0.6-2.6-0.1-2.6c0.4,0,2.1,2.6,2.1,3.2C201,123.9,199.5,123.4,199,122.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M109,121.6c0-0.8,2.1-3.1,2.8-3.1c0.6,0,0.4,0.4-0.4,1.8C110.3,121.8,109,122.6,109,121.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M195.9,118.1c-0.3-0.8-1.2-1.7-2-2.1c-0.9-0.4-1.4-1-1.4-1.7c0-0.9,0-0.9,1.4,0c1.3,0.9,2.6,2.3,4.1,4.2 c0.6,0.8,0.6,0.8-0.4,0.8C196.8,119.5,196.2,119,195.9,118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M130.5,106.5c0-0.6,1.7-1.5,2.8-1.5s0.4,0.6-1.4,1.4C131.1,106.8,130.5,106.8,130.5,106.5L130.5,106.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M135.5,104.6c0-0.2,0.6-0.6,1.4-0.7c0.8-0.2,2-0.4,2.8-0.7c0.8-0.2,1.3-0.1,1.3,0.2c0,0.2-1,0.8-2.2,1.1 C136.1,105.1,135.5,105.2,135.5,104.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M169.4,104.4c-1.8-0.4-2.6-1.4-1.4-1.4c1.2,0,4.9,1.2,4.9,1.6C173,105.1,171.8,105.1,169.4,104.4L169.4,104.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M143.5,103.1c0-0.2,0.8-0.6,1.6-0.8c2.7-0.4,2.6,0.4-0.1,0.9C144.1,103.5,143.5,103.4,143.5,103.1 L143.5,103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.1,103.2c-0.6-0.1-1.1-0.4-1.1-0.8s0.6-0.4,1.6-0.2c0.9,0.2,1.8,0.3,2,0.3s0.4,0.2,0.4,0.5 C165,103.5,164.2,103.6,162.1,103.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M149,102.5c0-0.2,0.9-0.5,1.9-0.4c1.5,0,1.6,0.1,0.9,0.4C150.4,103.1,149,103.1,149,102.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M155.8,102.5c-0.8-0.3-0.6-0.4,0.9-0.4c1-0.1,1.9,0.2,1.9,0.4C158.5,103.1,157.1,103.1,155.8,102.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M222,284.4c0-0.2,0.1-0.4,0.2-0.4c1.1,0,9.1-1.6,10.8-2.2c1.6-0.6,2.1-0.6,1.9-0.1 C234.4,282.9,222,285.6,222,284.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.8,284.1c-0.6-0.1-1.5-0.3-2.1-0.5c-2-0.4-1.3-1.4,0.8-1c3.9,0.7,4.6,0.9,4.6,1.4 S211.6,284.5,209.8,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M325.1,282.2c1-1.6,2.4-2.4,2.4-1.3c0,0.8-2,3-2.8,3C324.2,284,324.2,283.6,325.1,282.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M200.1,282c-0.9-0.2-1.6-0.8-1.6-1.1c0-0.5,0.4-0.6,1.8-0.1c0.9,0.3,1.8,0.8,1.8,1.2c0,0.4-0.1,0.6-0.1,0.6 C201.8,282.5,201,282.2,200.1,282L200.1,282z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M318.8,280.4c-0.5-1.8-0.4-2.4,0.4-2.4c0.6,0,1.3,1.4,1.3,2.9C320.5,281.9,319.1,281.5,318.8,280.4 L318.8,280.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M193.6,279.8c-1.8-0.6-2.7-1.8-1.5-1.8c1.3,0,3.9,1.2,3.9,1.9C196,280.6,195.8,280.6,193.6,279.8L193.6,279.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M184.4,276.1c-1.6-0.7-2.9-1.6-2.9-2c0-0.8,0.2-0.6,4.6,1.2c1.3,0.5,2.4,1.2,2.4,1.5 C188.5,277.7,187.6,277.5,184.4,276.1L184.4,276.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M245.2,274.8c1.4-1.2,2.9-2.2,3.4-2.2s0.9-0.4,0.9-0.9c0-1,1.5-2.6,2.4-2.6c1.1,0-1.3,2.9-4.6,5.5 C243.6,277.7,241.8,277.9,245.2,274.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M329.1,273.9c0.6-1.5,1.9-2.5,1.9-1.5c0,1.2-1,3-1.8,3C328.6,275.5,328.6,275.3,329.1,273.9L329.1,273.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M318.5,272.4c0-0.4-0.1-1.1-0.3-1.8c-0.2-0.9-0.1-1.1,0.5-1.1c0.4,0,0.9,0.5,1,1.1c0.5,1.8,0.4,2.4-0.5,2.4 C318.9,273,318.5,272.7,318.5,272.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M180.5,268.5c0.6-1.2,1.8-1.4,1.3-0.2c-0.1,0.5-0.3,0.9-0.3,1s-0.4,0.2-0.8,0.2 C180.1,269.5,180.1,269.3,180.5,268.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M331.2,267.9c0.1-0.6,0.3-1.5,0.3-1.8c0-0.4,0.4-0.6,0.8-0.6c0.8,0,0.9,0.6,0.5,2.4c-0.2,0.6-0.6,1.1-1,1.1 C331.1,269,331,268.7,331.2,267.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M175.5,265c0-2.5,0.2-3.5,0.6-3.5s0.6,1,0.6,3.5s-0.2,3.5-0.6,3.5S175.5,267.5,175.5,265z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M315.6,265.2c-1-1.7-1.1-1.8-0.1-1.8s2,1.4,2,2.7C317.5,267.5,316.9,267.1,315.6,265.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M183.3,261.6c1.4-3.8,1.4-3.8,2.1-3.6c0.7,0.3-1.9,7-2.7,7C182.2,265,182.4,264.1,183.3,261.6L183.3,261.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M333.2,259.4c0.1-0.6,0.3-1.5,0.3-1.8c0-0.4,0.4-0.6,0.8-0.6c0.8,0,0.9,0.6,0.5,2.4c-0.2,0.6-0.6,1.1-1,1.1 C333.1,260.5,333,260.2,333.2,259.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M303.4,259.6c-1-0.2-1.2-1.1-0.2-1.1c1.2,0,2.9,0.6,2.9,1C306,260,304.9,260,303.4,259.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.4,258.6c-1-0.2-1.2-1.1-0.2-1.1c1.2,0,2.9,0.6,2.9,1C301,259,299.9,259,298.4,258.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M259,258c0-1,1.6-3,2.3-3c0.4,0,0.7-0.4,0.7-0.8c0-0.8,3.4-2.8,4.8-2.8c1.2,0,0.9,0.9-0.6,1.2 c-1.9,0.4-4.4,2.4-5.5,4.2C259.8,258.5,259,259,259,258z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M176,256.2c0-1.2,0.2-1.8,0.8-1.8c0.8,0,0.9,0.6,0.4,2.4C176.7,258.6,176,258.2,176,256.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M185.3,255.6c0.4-1.6,1.1-2.5,1.5-2.1c0.6,0.6-0.4,3.4-1.1,3.4C185.1,257,185.1,256.6,185.3,255.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M288.9,256.6c-1-0.2-1.2-1.1-0.2-1.1c1.2,0,2.9,0.6,2.9,1C291.5,257,290.4,257,288.9,256.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M277.4,254.1c-1-0.2-1.2-1.1-0.2-1.1c1.2,0,2.9,0.6,2.9,1.1S278.9,254.6,277.4,254.1L277.4,254.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M334.3,252.1c0.6-4.5,0.8-5.1,1.5-5.1s0.7,0.6,0,5.4C335.4,254.8,334,254.5,334.3,252.1L334.3,252.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M272.4,253.1c-1-0.2-1.2-1.1-0.2-1.1c1.2,0,2.9,0.6,2.9,1.1S273.9,253.6,272.4,253.1L272.4,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M186.8,250.6c0.4-1.6,1.1-2.5,1.5-2.1c0.6,0.6-0.4,3.4-1.1,3.4C186.6,252,186.6,251.6,186.8,250.6 L186.8,250.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M317,251c0-0.6,3-2.2,3.4-1.8c0.5,0.4-0.4,1.2-1.9,1.7C317.6,251.2,317,251.2,317,251z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M176.7,249.2c0.1-0.4,0.3-1.2,0.3-1.8c0-0.5,0.4-0.9,0.8-0.9c0.8,0,0.9,0.6,0.4,2.4c-0.2,0.6-0.6,1.1-1.1,1.1 C176.6,250,176.5,249.7,176.7,249.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M301.9,249.6c-1-0.2-1.2-1.1-0.2-1.1c1.2,0,2.9,0.6,2.9,1.1S303.4,250.1,301.9,249.6L301.9,249.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M213.2,249.3C213.2,249.3,213.2,249.3,213.2,249.3C213.2,249.3,213.2,249.3,213.2,249.3 C213.2,249.3,213.2,249.3,213.2,249.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215,248.3L215,248.3C215,248.3,215,248.3,215,248.3c-0.2-0.2-0.4-0.4-0.6-0.5c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c-0.2,0-0.3,0-0.5,0c-0.1,0-0.1,0-0.2,0l0,0c0,0,0,0,0,0c0,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0 c0,0,0,0,0,0c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c-0.2,0.3-0.3,0.8-0.2,1.2c0,0,0,0,0,0c0,0-0.1,0-0.1,0 c-0.1,0-0.2-0.1-0.2-0.1c0,0,0,0,0,0c-0.1,0-0.1-0.1-0.1-0.1c0-0.4,0.4-1,1-1.3c0,0,0,0,0,0c0.1,0,0.2-0.1,0.3-0.1 c0,0,0.1,0,0.1,0c0.1,0,0.2-0.1,0.2-0.1c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0c0.2,0,0.3,0,0.4,0.1c0.1,0,0.2,0.1,0.2,0.2h0 c0,0.1,0.1,0.1,0.1,0.2C214.9,248.1,215,248.2,215,248.3C215,248.3,215,248.3,215,248.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M323.5,245.1c1-1.6,2.3-3.8,2.7-4.8c0.8-1.8,1.9-2.6,1.9-1.4c0,1-2.5,5.9-3,5.9c-0.2,0-0.5,0.3-0.5,0.6 c0,0.8-1.6,2.4-2.4,2.4C321.8,248,322.4,246.7,323.5,245.1L323.5,245.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M289.1,246.9c-1.2-0.2-2.1-0.6-2.1-0.9c0-0.6,0.4-0.6,3.5,0.1c1.4,0.3,2.5,0.8,2.5,1 C293,247.6,292,247.6,289.1,246.9L289.1,246.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M188.2,245.6c0.1-0.5,0.5-2,0.9-3.4c0.6-2.6,1.2-3.6,1.8-3.1c0.6,0.6-1.4,7.4-2.1,7.4 C188.2,246.5,188.1,246.2,188.2,245.6L188.2,245.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M281.9,245.4c-1.8-0.4-2.6-1.4-1.4-1.4s5,1.1,5,1.6S284.4,246.1,281.9,245.4L281.9,245.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M273.2,243.6c-3.8-0.9-5.2-1.6-6.2-2.8s0.7-1.1,2.4,0.1c0.8,0.6,3.1,1.4,5.2,1.8c2.1,0.4,3.9,1.1,3.9,1.3 C278.5,244.7,277.3,244.6,273.2,243.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M177.7,242.4c0.1-0.9,0.3-1.8,0.3-2s0.4-0.4,0.8-0.4c0.6,0,0.8,0.4,0.5,1.6c-0.1,0.9-0.3,1.8-0.3,2 s-0.4,0.4-0.8,0.4C177.6,244,177.4,243.6,177.7,242.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M225.2,240.1c0.2-1.1,0.6-2.6,1-3.5c0.8-1.9,2.1-2.3,1.6-0.5c-0.2,0.6-0.6,2.1-0.9,3.5 C226.1,242.6,224.7,243,225.2,240.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M265,238.1c-0.7-1.4-0.6-2.6,0.2-2.6c0.6,0,1.3,1.4,1.3,2.9C266.5,239.3,265.6,239.1,265,238.1L265,238.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M334.1,236.1c-0.9-2.9-0.8-3.4,0.4-2.3c1.3,1.3,1.9,4.2,0.9,4.2C334.9,238,334.4,237.1,334.1,236.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M179.2,234.1c0.1-0.5,0.4-1.6,0.6-2.5c0.2-0.9,0.6-1.6,0.9-1.6c0.5,0,0.6,0.5,0.2,2.1 c-0.2,1.1-0.4,2.2-0.4,2.5c0,0.2-0.4,0.4-0.8,0.4C179.2,235,179,234.7,179.2,234.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M191.2,233.2c0.1-0.4,0.3-1.2,0.3-1.8c0-0.5,0.4-0.9,0.8-0.9c0.8,0,0.9,0.6,0.4,2.4c-0.2,0.6-0.6,1.1-1.1,1.1 C191.1,234,191,233.7,191.2,233.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M229,232c1.2-1.7,2-2.3,2-1.5c0,0.9-1.6,3-2.4,3C228.1,233.5,228.1,233.1,229,232z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M263,225.4c-0.7-3.9-0.7-3.9,0.1-3.9c0.7,0,1,0.7,1.5,4.9c0.2,1.6,0.2,2.1-0.4,2.1 C263.8,228.5,263.4,227.6,263,225.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M180.9,225.9c0.3-1.6,1.6-2.6,1.6-1.3c0,1.4-0.6,2.9-1.2,2.9C180.8,227.5,180.7,227,180.9,225.9L180.9,225.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M193,223.9c0-1.5,0.6-2.9,1.4-2.9c0.6,0,0.7,0.3,0.4,1.1c-0.1,0.6-0.3,1.4-0.3,1.8c0,0.3-0.4,0.6-0.8,0.6 S193,224.2,193,223.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M182.3,219.9c1-4.4,2.6-9.9,2.9-10.3c0.9-0.9,0.6,1-0.8,6.9c-1,3.9-1.9,6.6-2.2,6.6 C181.8,223,181.8,222.3,182.3,219.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M194,218.4c0-1.5,0.6-2.9,1.4-2.9c0.5,0,0.6,0.3,0.4,0.8c-0.1,0.4-0.3,1.2-0.3,1.8c0,0.5-0.4,0.9-0.8,0.9 S194,218.7,194,218.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M195.7,206.7c0.1-0.4,0.3-1.2,0.3-1.8c0-0.5,0.4-0.9,0.8-0.9c0.8,0,0.9,0.6,0.4,2.4c-0.2,0.6-0.6,1.1-1.1,1.1 C195.6,207.5,195.5,207.2,195.7,206.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M186,206.4c0-1.5,0.6-2.9,1.3-2.9c0.9,0,0.9-0.1,0.1,1.9C186.9,207,186,207.6,186,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M196.5,200.2c0-1.2,0.2-1.8,0.8-1.8c0.8,0,0.9,0.6,0.4,2.4C197.2,202.6,196.5,202.2,196.5,200.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M249.3,200.6c-1.6-1.7-0.6-2.1,1.2-0.6c1.6,1.3,1.6,1.5,0.7,1.6C250.6,201.5,249.8,201.1,249.3,200.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M241.6,195.9c-0.6-0.3-1.1-0.9-1.1-1.2c0-0.9,0.2-0.8,2,0.1C245,196.1,244.1,197.1,241.6,195.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M228.9,191.1c-1-0.2-1.2-1.1-0.2-1.1c1.2,0,2.9,0.6,2.9,1.1S230.4,191.6,228.9,191.1L228.9,191.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M222.4,189.6c-1-0.2-1.2-1.1-0.2-1.1c1.2,0,2.9,0.6,2.9,1.1S223.9,190.1,222.4,189.6L222.4,189.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M193,188.9c0-0.9,1.6-2.4,2.6-2.4c0.4,0,0.9,0.2,0.9,0.6c0,0.3-0.1,0.4-0.4,0.2c-0.2-0.2-0.9,0.2-1.8,1 C193.4,189.3,193,189.5,193,188.9L193,188.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215.4,188.6c-0.5-0.1-0.9-0.4-0.9-0.8s0.5-0.4,1.1-0.2c0.6,0.1,1.4,0.3,1.8,0.3c0.3,0,0.6,0.2,0.6,0.5 C218,189,216.9,189.1,215.4,188.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.6,188.1c-0.9-0.1-1.6-0.4-1.6-0.7s0.6-0.4,1.6-0.2C212.3,187.8,212.3,188.4,209.6,188.1L209.6,188.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M199.4,187.6c-1.8-0.4-0.9-1.3,1-0.9c1,0.1,2.1,0.3,2.5,0.3c0.3,0,0.6,0.2,0.6,0.5 C203.5,188,201.1,188.1,199.4,187.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M182.1,170.5c-1.2-0.6-2.1-1.2-2.1-1.5c0-0.6,0.1-0.6,2.7,0.5c1.2,0.5,2.3,1.2,2.3,1.5 C185,171.6,184.6,171.6,182.1,170.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M174.4,167.2c-0.8-0.4-1.4-0.9-1.4-1.2c0-0.7,3.1,0.6,3.4,1.4C176.6,168.2,176,168.1,174.4,167.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M148,166c0-0.6,1.4-0.6,2.8,0c0.8,0.4,0.6,0.4-0.9,0.4C148.8,166.5,148,166.3,148,166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M162.5,166.1c0-0.2,0.7-0.6,1.5-0.8c0.9-0.1,2.2-0.4,3-0.6c0.9-0.1,1.5-0.1,1.5,0.2c0,0.2-0.9,0.6-1.9,0.8 c-1.1,0.1-2.4,0.4-3,0.6C163,166.4,162.5,166.3,162.5,166.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M128.8,162.2c-2.1-0.8-3.1-1.5-2.7-1.9s4.9,1.6,4.9,2.2c0,0.2-0.1,0.5-0.1,0.4 C130.8,162.9,129.8,162.6,128.8,162.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M184.3,160.7c-0.1-0.4-0.2-0.9-0.1-1.2c0.2-0.4,4.5-3,4.9-3c0.9,0,0.1,0.9-1.7,1.9c-1.2,0.7-2,1.4-2,2.1 C185.5,161.7,184.8,161.8,184.3,160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M116.3,155.2c-0.5-0.4-0.8-1.1-0.8-1.5c0.1-0.6,0.5-0.5,1.9,0.7s1.6,1.5,0.8,1.5 C117.7,155.9,116.8,155.6,116.3,155.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M109.2,147.8c-1.3-1.6-1.4-2.3-0.4-2.3c1.1,0,1.9,1.3,1.7,2.6C110.2,149.2,110.2,149.2,109.2,147.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M199.5,146c0-1.1,1.7-4,2.4-4c0.4,0,0.5,0.3,0.1,1.2C201.1,145.7,199.5,147.4,199.5,146z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M106.5,143.1c-0.7-1.2-0.7-3.1,0-3.1s2.1,3.1,1.7,3.6C107.8,144.3,107,144.1,106.5,143.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M202.5,132.4c0-0.4-0.1-1.1-0.3-1.8c-0.2-0.9-0.1-1.1,0.4-1.1c0.4,0,0.9,0.5,1.1,1.1c0.4,1.8,0.4,2.4-0.4,2.4 C202.9,133,202.5,132.7,202.5,132.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M198.1,121.4c-0.4-0.3-0.6-1.1-0.6-1.8s-0.3-1.2-0.6-1.2c-0.8,0-3.9-3.1-3.9-3.9c0-1.1,2.2,0.8,4.7,3.8 c1.2,1.5,2.3,2.9,2.3,3.2C200,122.2,198.8,122.1,198.1,121.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M120.5,111.1c0-0.4,2.6-2.1,3.2-2.1c0.8,0,0.2,0.8-1.2,1.7C120.9,111.6,120.5,111.7,120.5,111.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M184.6,109.9c-0.6-0.3-1.1-0.8-1.1-1.2c0-0.8,0.2-0.8,2,0.1C188,110.1,187.1,111.1,184.6,109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M129,106.9c0-0.4,2.1-1.4,3.1-1.4c0.9,0-0.1,0.9-1.6,1.4C129.6,107.2,129,107.2,129,106.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M176.6,106.3c-1.8-0.6-2.2-1.3-0.8-1.3c0.9,0,3,1.3,2.6,1.7C178.4,106.8,177.5,106.6,176.6,106.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M133.8,105.1c0.7-0.8,3.2-1.2,3.2-0.7s-1.6,1.1-2.9,1.1C133.6,105.5,133.5,105.3,133.8,105.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M170.6,104.7c-1.2-0.2-1.6-1.2-0.5-1.2c1.2,0,2.9,0.6,2.9,1.1C173,105,172.6,105.1,170.6,104.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M138,104.1c0-0.6,2.9-1.3,3.4-0.8c0.4,0.4,0.1,0.6-1.7,0.9C138.8,104.3,138,104.2,138,104.1L138,104.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M148.5,102.5c0-0.2,0.9-0.5,1.9-0.4c1.5,0,1.6,0.1,0.9,0.4C149.9,103.1,148.5,103.1,148.5,102.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M156.2,102.5c-0.8-0.3-0.6-0.4,0.9-0.4c1-0.1,1.9,0.2,1.9,0.4C159,103.1,157.6,103.1,156.2,102.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M320.3,284.7c-1-1-1-1.7,0-1.7c0.6,0,1.8,1.4,1.8,2.2C322,285.8,321,285.5,320.3,284.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M214.6,284.6c-0.6-0.1-1.1-0.5-1.1-0.8s0.6-0.4,1.6-0.2c0.9,0.1,1.8,0.3,2,0.3s0.4,0.2,0.4,0.5 C217.5,285,216.7,285,214.6,284.6L214.6,284.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M220.5,284.5c0-0.2,0.9-0.5,1.9-0.5c1.5,0,1.6,0.1,0.9,0.5C221.9,285.1,220.5,285.1,220.5,284.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M225.5,284.1c0-0.5,3-1.4,3.4-0.9c0.4,0.4-0.1,0.7-1.8,1C226.1,284.5,225.5,284.4,225.5,284.1L225.5,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M200.5,282c-5.8-1.7-6.5-2-6.5-2.5c0-0.6,0.8-0.5,4.2,0.5c1.6,0.5,4.4,1.4,5.9,1.8c1.6,0.4,2.9,1,2.9,1.2 C207,283.8,205.6,283.5,200.5,282z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M230,283.1c0-0.2,1.1-0.8,2.5-1.2c2.6-0.8,3.6-0.3,1.2,0.6C231.4,283.4,230,283.6,230,283.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M319,281.3c0-0.4-0.1-1.4-0.3-2.2c-0.2-1.2-0.1-1.5,0.5-1.5c0.5,0,0.8,0.3,0.8,0.7c0,0.4,0.1,1.4,0.3,2.2 c0.2,1.2,0.1,1.5-0.5,1.5C319.3,282,319,281.7,319,281.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M327,279.4c1.5-3.7,2.6-5.9,3-5.9c0.8,0,0.6,0.4-0.8,3.9c-0.8,1.7-1.6,3.1-2,3.1 C326.7,280.5,326.7,280.2,327,279.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M190.4,278.6c-1.1-0.4-1.9-1-1.9-1.5c0-0.6,0.3-0.6,1.9,0c2.1,0.9,2.3,1,2.1,1.6 C192.3,279.2,191.5,279.1,190.4,278.6L190.4,278.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M183.9,275.9c-0.8-0.2-1.4-0.8-1.4-1.2c0-0.6,0.2-0.6,1.6,0c0.9,0.4,1.6,0.9,1.8,1.2 C186.1,276.6,185.8,276.6,183.9,275.9L183.9,275.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M246.5,274.4c0-0.4,1.1-1.8,2.5-3c1.4-1.3,2.5-2.5,2.5-2.8c0-0.6,1.9-2.1,2.5-2c0.6,0.2-4.4,6.4-6.2,7.6 C246.8,274.9,246.5,274.9,246.5,274.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M178.1,273.2c-1.9-0.8-2.6-2.4-2.6-5.5c0-2.7,0.9-2.9,1.2-0.3c0.6,3.7,0.8,4.1,2.2,4.9c0.9,0.5,1.5,1,1.5,1.2 C180.5,274.2,180.1,274.1,178.1,273.2L178.1,273.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M330.5,270.6c0-0.2,0.5-2.2,1-4.5c0.7-2.6,1.4-4.1,1.8-4.1c0.9,0,0.8,0.5-0.5,5c-0.6,2-1.4,3.8-1.8,4 C330.8,271,330.5,270.9,330.5,270.6L330.5,270.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M181.8,265.6c0.4-1,0.9-2.3,1.1-2.8c0.1-0.5,0.6-0.9,0.9-0.9c0.6,0,0.4,0.5-0.3,2.5c-0.6,1.4-1,2.6-1,2.8 c0,0.1-0.4,0.2-0.8,0.2C181.1,267.5,181.1,267.3,181.8,265.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M255.6,262.8c1.2-1.8,1.9-2.2,1.9-1.1c0,1-1.5,2.9-2.3,2.9C254.6,264.5,254.8,264.1,255.6,262.8L255.6,262.8z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M311.9,262c-2.2-1.1-2.6-2.1-0.5-1.5c2.1,0.8,3.6,1.6,3.6,2.1C315,263.2,313.9,263.1,311.9,262z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M333,260.6c0-0.2,0.4-2.3,0.8-4.6s0.8-4.3,0.8-4.4c0-0.1,0.3-0.1,0.7-0.1c0.4,0,0.6,0.4,0.5,0.9 c-0.1,0.4-0.5,2.6-0.8,4.8c-0.4,2.6-0.8,3.9-1.2,3.9C333.3,261,333,260.9,333,260.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M175.5,259.4c0-1.2,0.6-2.9,1.1-2.9c0.2,0,0.4,0.8,0.4,1.8c0,1.2-0.2,1.8-0.8,1.8 C175.9,260,175.5,259.7,175.5,259.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M184.2,259.2c0.2-0.5,0.7-2.2,1.1-3.8c0.5-1.7,1.1-2.9,1.5-2.9c0.8,0,0.8,0.1-0.5,3.9 c-0.6,1.8-1.4,3.4-1.8,3.5C184,260.1,183.9,259.9,184.2,259.2L184.2,259.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M258,259.4c0-1,1.9-3.2,2.2-2.8c0.4,0.4-1.2,3.4-1.9,3.4C258.2,260,258,259.7,258,259.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M292.6,257.4c-1.2-0.2-2.1-0.6-2.1-1c0-0.6,0.4-0.6,3.5,0.1c1.4,0.3,2.5,0.8,2.5,1 C296.5,258.1,295.5,258,292.6,257.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M283.1,255.4c-1.2-0.2-2.1-0.6-2.1-0.9c0-0.6,0.4-0.6,3.5,0.1c1.4,0.3,2.5,0.8,2.5,1 C287,256.1,286,256,283.1,255.4L283.1,255.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M176,254.4c0-1.2,0.6-2.9,1.1-2.9c0.2,0,0.4,0.8,0.4,1.8c0,1.2-0.2,1.8-0.8,1.8 C176.4,255,176,254.7,176,254.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M274.9,253.6c-1-0.2-1.2-1.1-0.2-1.1c1.2,0,2.9,0.6,2.9,1.1S276.4,254.1,274.9,253.6L274.9,253.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M227.4,252.6c-0.6-0.6-0.4-1.6,0.4-1.6c0.6,0,1.3,1,1.3,1.8C229,253.2,227.7,253.1,227.4,252.6L227.4,252.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M311.6,251.6c-2.3-0.4-1-0.9,2.4-0.9c3.7,0,4.6,0.4,2,1C314.3,252,313.5,252,311.6,251.6L311.6,251.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M176.8,248.9c0.6-4.1,0.9-4.9,1.4-4.9c0.4,0,0.5,0.8,0.1,3.5c-0.4,2.5-0.7,3.5-1.2,3.5 C176.5,251,176.5,250.6,176.8,248.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M187,250.4c0-1.5,0.6-2.9,1.3-2.9c0.9,0,0.9-0.1,0.1,1.9C187.9,251,187,251.6,187,250.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M318,250.4c0-0.6,3-2.1,3.4-1.8c0.4,0.4-1.3,1.6-2.5,1.9C318.4,250.8,318,250.7,318,250.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M304.4,250.1c-1-0.2-1.2-1.1-0.2-1.1c1.2,0,2.9,0.6,2.9,1.1S305.9,250.6,304.4,250.1L304.4,250.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M215.7,249.3c0,0-0.1,0.1-0.2,0.1c0,0-0.1,0-0.1,0h0v-0.1c0-0.1,0-0.2,0-0.2c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1v0 c-0.1-0.2-0.2-0.4-0.3-0.6c-0.2-0.2-0.4-0.4-0.6-0.5c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.2,0-0.3,0-0.5,0c-0.1,0-0.1,0-0.2,0 c0,0,0.1-0.1,0.2-0.1c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.4,0c0.4,0.1,0.7,0.4,1,0.8 C215.8,248.9,215.9,249.2,215.7,249.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M334.9,247.8c0.1-1.1,0.5-1.8,0.9-1.8c0.8,0,0.9,0.6,0.4,2.4C335.7,250.2,334.6,249.8,334.9,247.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M225.3,247.9c-0.4-1.8-0.4-2.4,0.4-2.4c0.6,0,1.3,1.4,1.3,2.9C227,249.4,225.6,249,225.3,247.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M287.9,246.6c-0.5-0.1-0.9-0.4-0.9-0.8s0.5-0.4,1.1-0.2c0.6,0.1,1.4,0.3,1.8,0.3c0.3,0,0.6,0.2,0.6,0.5 C290.5,247,289.5,247.1,287.9,246.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M278.4,244.6c-1-0.2-1.2-1.1-0.2-1.1c1.2,0,2.9,0.6,2.9,1.1S279.9,245.1,278.4,244.6L278.4,244.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M189.2,241.9c0.4-1.8,0.6-2.1,1.2-1.9c0.6,0.2-0.3,3.4-1,3.4C189,243.5,189,242.9,189.2,241.9L189.2,241.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M178,241.1c0-0.2,0.4-2.1,0.8-4.3c0.4-2.1,0.8-4.1,0.8-4.1c0-0.1,0.3-0.2,0.6-0.2c0.6,0,0.6,0.8-0.1,4.5 c-0.5,2.9-1,4.5-1.4,4.5C178.3,241.5,178,241.4,178,241.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M326.8,239.1c1-2.4,3.1-5.1,4-5.1s-3.2,6.9-4.1,7C326.1,241,326.1,240.6,326.8,239.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M334.8,239.1c-0.2-1.1-0.5-2.5-0.6-3.2c-0.3-1.6,0.5-1.9,1.2-0.5c0.2,0.4,0.6,1.9,0.8,3.2 c0.3,1.9,0.2,2.4-0.4,2.4C335.4,241,335,240.3,334.8,239.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M225.5,239.4c0-1.2,1.9-5.4,2.5-5.4c0.7,0,0.6,0.4-0.4,3.2C226.7,239.6,225.5,240.8,225.5,239.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M264.5,236.4c-0.2-0.6-0.5-2.2-0.8-3.5c-0.3-2-0.2-2.4,0.4-2.4c0.5,0,0.8,0.4,0.8,0.9s0.3,2.1,0.7,3.5 c0.5,2.2,0.5,2.6,0,2.6C265.3,237.5,264.8,237,264.5,236.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M190.8,234.6c0.4-1.6,1.1-2.5,1.5-2.1c0.6,0.6-0.4,3.4-1.1,3.4C190.6,236,190.6,235.6,190.8,234.6 L190.8,234.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M180,230.9c0-1.4,0.8-2.8,1.2-2.3s-0.2,3.4-0.8,3.4C180.2,232,180,231.5,180,230.9L180,230.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M191.7,230.6c0.1-0.5,0.4-1.6,0.6-2.5c0.2-1,0.6-1.6,1.1-1.6s0.7,0.3,0.5,0.9c-0.1,0.4-0.4,1.6-0.6,2.5 c-0.2,0.9-0.6,1.6-1.1,1.6S191.5,231.2,191.7,230.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M231,230.6c0-0.6,2.4-2.6,3.1-2.6c0.9,0,0.4,0.8-1.3,1.9C231.8,230.5,231,230.8,231,230.6L231,230.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M263.4,227.2c-0.2-2,0.8-2.5,1.3-0.6c0.5,1.8,0.4,2.4-0.4,2.4C263.9,229,263.5,228.3,263.4,227.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M181.5,223.4c0.5-1.8,0.9-2.2,1.3-1.8c0.6,0.5-0.4,3.4-1.1,3.4C181.2,225,181.1,224.6,181.5,223.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M193.2,223.2c0.1-0.4,0.3-1.2,0.3-1.8c0-0.5,0.4-0.9,0.8-0.9c0.8,0,0.9,0.6,0.4,2.4c-0.2,0.6-0.6,1.1-1.1,1.1 C193.1,224,193,223.7,193.2,223.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M262,220.8c-0.7-2.9-0.7-3.3,0.1-3.3c0.4,0,0.9,0.9,1.2,2.2c0.7,2.9,0.7,3.3-0.1,3.3 C262.9,223,262.4,222.1,262,220.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M194.6,215.1c0.9-5.5,1-6.1,1.6-6.1c0.5,0,0.6,0.7,0.2,3.1c-0.6,4.8-0.9,5.9-1.6,5.9 C194.3,218,194.2,217.4,194.6,215.1L194.6,215.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M260,214.6c-0.2-0.6-0.5-1.3-0.5-1.8c0-0.4-0.2-0.8-0.4-0.9c-0.2-0.1-1.1-1.2-2-2.5c-1.2-1.8-1.4-2.4-0.9-2.6 c0.9-0.3,2.6,1.8,3.1,3.6c0.1,0.7,0.6,1.6,1,1.8c0.4,0.3,0.9,1.1,1.1,1.9c0.4,1.1,0.4,1.4-0.2,1.4 C260.9,215.5,260.3,215.1,260,214.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M185,209.9c0-1.5,0.6-2.9,1.3-2.9c0.9,0,0.9-0.1,0.1,1.9C185.9,210.5,185,211.1,185,209.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M195.5,207.9c0-1.4,0.6-2.9,1.2-2.9c0.4,0,0.6,0.6,0.4,1.8c-0.1,1.1-0.5,1.8-0.9,1.8S195.5,208.2,195.5,207.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M186.5,204.9c0-1.5,0.6-2.9,1.3-2.9c0.9,0,0.9-0.1,0.1,1.9C187.4,205.5,186.5,206.1,186.5,204.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M252.6,203.9c-0.6-0.6-1.1-1.6-1.1-2c0-0.8,0.1-0.8,1.2-0.1c0.7,0.4,1.6,1.4,2.1,2.1c0.7,1.1,0.7,1.2-0.1,1.2 C254.1,205,253.2,204.5,252.6,203.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M196,203.9c0-1.2,0.6-2.9,1.1-2.9c0.2,0,0.4,0.8,0.4,1.8c0,1.2-0.2,1.8-0.8,1.8 C196.4,204.5,196,204.2,196,203.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M189,197c2-5.1,2.4-6,3.1-6c0.3,0,0.4,0.4,0.2,0.9c-1.9,5.2-3.1,7.6-3.6,7.6S188.2,198.9,189,197z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M240.4,195.2c-1.7-0.9-1.9-1.9-0.2-1.4c1.4,0.4,2.4,1.1,2.4,1.8S242,196.1,240.4,195.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M232.4,192.1c-2.2-0.7-3.2-1.6-1.9-1.6c1.4,0,4.4,1.2,4.4,1.9c0,0.4-0.1,0.6-0.1,0.6 C234.8,193,233.7,192.6,232.4,192.1L232.4,192.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M192,190.1c0-0.3,0.6-1.1,1.2-1.9c1.4-1.6,1.7-0.8,0.4,1.1C192.9,190.5,192,190.9,192,190.1L192,190.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M223.6,189.9c-2.4-0.5-3-1.6-0.6-1.2c0.9,0.1,2.2,0.4,3,0.6c0.9,0.1,1.5,0.5,1.5,0.8 C227.5,190.6,226.5,190.6,223.6,189.9L223.6,189.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M215.4,188.6c-1.4-0.2-2-1.1-0.8-1.1s2.9,0.6,2.9,1.1c0,0.2-0.1,0.4-0.4,0.4 C216.9,188.9,216.1,188.8,215.4,188.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M210.2,188c-0.8-0.4-0.6-0.4,0.9-0.4c1-0.1,1.9,0.2,1.9,0.4C213,188.6,211.6,188.6,210.2,188z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M200.6,187.6c-0.9-0.1-1.6-0.4-1.6-0.8s0.6-0.4,1.6-0.2c0.9,0.1,2,0.3,2.5,0.3c0.6,0,0.9,0.2,0.9,0.5 C204,188,203.6,188,200.6,187.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M186.4,172.2c-1.8-0.9-1.9-1.9-0.1-1.2c0.7,0.3,1.4,0.5,1.4,0.5c0.1,0-0.4-1.1-1-2.6 c-1.1-2.5-1.2-3.4-0.2-3.4c0.9,0,2.5,4.6,2.2,6.1C188.4,173.2,188.2,173.2,186.4,172.2L186.4,172.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M177.6,168.6c-1.2-0.4-2.1-1.1-2.1-1.4c0-0.5,0.4-0.5,1.9,0.1C180.8,168.7,181.1,169.9,177.6,168.6 L177.6,168.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M145.2,166c-0.8-0.4-0.6-0.4,0.9-0.4c1-0.1,1.9,0.2,1.9,0.4C148,166.6,146.6,166.6,145.2,166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M159.2,166c1.4-0.6,2.8-0.6,2.8,0c0,0.3-0.9,0.5-1.9,0.4C158.6,166.4,158.4,166.3,159.2,166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M171.2,165.9c-0.6-0.2-1.6-0.4-2.4-0.4c-0.8-0.1-1.4-0.3-1.4-0.6c0-0.6,4.2-0.4,4.9,0.2 C173,165.8,172.2,166.3,171.2,165.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M138.4,165.1c-0.5-0.1-0.9-0.4-0.9-0.8s0.5-0.4,1.1-0.2c0.6,0.1,1.4,0.3,1.8,0.3c0.3,0,0.6,0.2,0.6,0.5 C141,165.5,139.9,165.6,138.4,165.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M130.9,162.9c-1.6-0.9-1-1.4,0.9-0.8c0.9,0.3,1.8,0.7,1.8,0.9C133.5,163.6,131.9,163.6,130.9,162.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M184.4,161.1c-0.1-0.5-0.1-1.1,0.1-1.4c0.5-0.8,8.6-6.1,8.6-5.6c0,0.6-2.1,2.3-4.9,4.1 c-2.2,1.4-2.6,1.9-2.4,2.8C185.9,162.3,184.8,162.5,184.4,161.1L184.4,161.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M124.4,160.2c-1.2-0.6-1.9-1.7-1.2-1.7c0.7,0,3.2,1.6,3.2,2C126.5,161.1,126,161.1,124.4,160.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M196.3,150.6c-0.2-0.4,3.1-5.1,3.8-5.1c0.8,0,0.4,0.9-1.3,3.2C196.9,151.1,196.7,151.2,196.3,150.6 L196.3,150.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M202.2,138.4c0.1-0.9,0.3-2,0.3-2.5c0-0.6,0.4-0.9,0.8-0.9c0.6,0,0.8,0.4,0.4,2.1c-0.4,2.4-0.6,2.9-1.4,2.9 C202.1,140,202,139.4,202.2,138.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M202.5,132.8c0-0.6-0.1-1.6-0.3-2c-0.2-0.5-0.1-0.8,0.4-0.8c0.7,0,1.4,1.4,1.4,3.1c0,0.4-0.4,0.9-0.8,0.9 C202.8,134,202.5,133.6,202.5,132.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M105,131.9c0-1.5,0.7-2.9,1.3-2.9c0.5,0,0.7,0.3,0.4,0.8c-0.2,0.4-0.3,1.2-0.3,1.8c0,0.5-0.3,0.9-0.8,0.9 S105,132.2,105,131.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M201.1,127.2c-0.5-1.6-0.4-1.8,0.4-1.8s1.5,1.2,1.5,2.9C203,129.8,201.6,128.9,201.1,127.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M106,127.8c0-1.1,2.1-5.2,3.4-6.8c1.8-2.2,1.7-0.8-0.4,3.3C106.9,128.2,106,129.3,106,127.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M197.5,120.4c-0.9-1.2-2.8-3.2-4.2-4.5c-2.1-1.9-2.4-2.4-1.5-2.4c1.3,0,7.1,5.7,7.5,7.3 C199.8,122.8,199.2,122.7,197.5,120.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M116.8,113.5c0.2-0.2,0.9-0.9,1.8-1.5c1.1-0.8,1.5-0.8,1.5-0.4s-0.7,1.1-1.4,1.6 C116.9,114.1,116.3,114.2,116.8,113.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M183.8,109.5c-4.4-2.4-6.4-4.1-3.4-2.9c3.5,1.3,8.6,4.2,8.6,4.8C189,112.3,188.8,112.2,183.8,109.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M125.6,108.4c0.2-0.7,3.4-2.1,3.4-1.5c0,0.2-0.8,0.8-1.8,1.2C126,108.8,125.4,108.8,125.6,108.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M168.4,104.2c-0.5-0.1-0.9-0.4-0.9-0.8s0.5-0.4,1.1-0.2c0.6,0.2,1.4,0.3,1.8,0.3c0.3,0,0.6,0.2,0.6,0.5 C171,104.5,169.9,104.6,168.4,104.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M140,103.6c0-0.2,0.8-0.6,1.6-0.8c2.7-0.4,2.6,0.4-0.1,0.9C140.6,104,140,103.9,140,103.6L140,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M144.5,102.9c0-0.2,0.5-0.4,1.1-0.7c1.4-0.4,6.1-0.4,5.7,0C150.9,102.7,144.5,103.3,144.5,102.9L144.5,102.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M162.1,103.1c-0.9-0.1-1.6-0.4-1.6-0.7c0-0.3,0.6-0.4,1.6-0.2C164.8,102.8,164.8,103.4,162.1,103.1 L162.1,103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M156.8,102.5c-0.8-0.3-0.6-0.4,0.9-0.4c1-0.1,1.9,0.2,1.9,0.4C159.5,103.1,158.1,103.1,156.8,102.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M214.6,284.6c-0.9-0.1-1.6-0.5-1.6-0.8s0.6-0.4,1.6-0.2c0.9,0.1,2,0.3,2.5,0.3c0.6,0,0.9,0.2,0.9,0.5 C218,285,217.6,285,214.6,284.6L214.6,284.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M209.8,284.1c-0.6-0.1-2.6-0.5-4.6-1c-2.1-0.5-3.6-1-3.6-1.4c0-0.5,0.9-0.4,3.6,0.2c1.9,0.5,4.4,1,5.5,1.1 c1,0.2,1.9,0.5,1.9,0.8C212.5,284.5,211.6,284.5,209.8,284.1L209.8,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M223.2,284c1.6-0.6,6.2-1.1,6.2-0.6s-2.9,1.1-5.5,1C222.6,284.4,222.4,284.3,223.2,284z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M234.1,282c0.1-0.3,0.9-0.9,1.9-1.2c1.1-0.5,1.6-0.5,1.4-0.1c-0.1,0.4-0.9,0.9-1.9,1.2 C234.4,282.4,233.9,282.4,234.1,282z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M318.8,279.4c-0.5-1.8-0.4-2.4,0.5-2.4c0.5,0,0.8,0.5,0.8,1.8C320,280.7,319.3,281.1,318.8,279.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M327.8,277.6c0.5-1,1-2.5,1.3-3.2c0.2-0.8,0.8-1.4,1.2-1.4c0.6,0,0.6,0.2-1.6,5.9c-0.1,0.3-0.5,0.6-1,0.6 C327.1,279.5,327.1,279.2,327.8,277.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M240.5,278.6c0-0.2,0.7-0.8,1.6-1.3s2.9-2.2,4.8-3.9c2.4-2.2,3.2-2.8,3.2-2.1c0,1-3.2,4-6.8,6.4 C241.3,279.1,240.5,279.3,240.5,278.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M187.4,277.4c-0.8-0.2-1.4-0.8-1.4-1.2c0-0.6,0.2-0.6,1.6,0c0.9,0.4,1.6,0.9,1.8,1.2 C189.6,278.1,189.3,278.1,187.4,277.4L187.4,277.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M181.4,274.7c-1.2-0.6-1.9-1.7-1.1-1.7c0.7,0,3.2,1.6,3.2,2C183.5,275.6,183,275.6,181.4,274.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M318.5,273.5c0-0.8-0.1-2.1-0.3-3c-0.2-1.2-0.1-1.5,0.4-1.5s0.9,0.7,1.1,1.9c0.5,3,0.4,4.1-0.5,4.1 C318.8,275,318.5,274.5,318.5,273.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M250.9,269.4c0.3-0.4,1.6-2,2.9-3.8c2.5-3.3,2.8-3.6,2.8-2.5s-4.5,6.8-5.4,6.8 C250.6,270,250.5,269.8,250.9,269.4L250.9,269.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M181.2,267.2c0.2-0.5,0.5-1.4,0.6-1.8c0.1-0.5,0.6-0.9,0.9-0.9c0.6,0,0.6,0.2,0.1,1.6 c-0.4,0.9-0.9,1.7-1.4,1.8C181.1,268.1,180.9,267.9,181.2,267.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M331.5,267.1c0-1.7,1.8-7.1,2.3-7.1c0.7,0,0.5,1.4-0.5,5.2C332.8,267,331.5,268.4,331.5,267.1L331.5,267.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M175.5,262c0-1.9,0.2-2.5,0.8-2.5c0.8,0,1,1.8,0.4,3.9C176.1,265.4,175.5,264.6,175.5,262z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M313.9,263.1c-1.8-2-0.6-2.2,1.5-0.4c1.3,1.1,1.3,1.2,0.4,1.2C315.2,264,314.3,263.6,313.9,263.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M305.9,260.1c-0.5-0.1-0.9-0.5-0.9-0.8s0.5-0.4,1.1-0.2c0.6,0.1,1.4,0.3,1.8,0.3c0.3,0,0.6,0.2,0.6,0.5 C308.5,260.5,307.5,260.5,305.9,260.1L305.9,260.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M299.9,258.9c-1.4-0.3-2.4-0.7-2.4-1c0-0.6,0.4-0.5,3.5,0.1c1.4,0.3,2.5,0.8,2.5,1 C303.5,259.5,303.1,259.5,299.9,258.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M291.4,257.1c-0.5-0.1-0.9-0.5-0.9-0.8s0.5-0.4,1.1-0.2c0.6,0.1,1.4,0.3,1.8,0.3c0.3,0,0.6,0.2,0.6,0.5 C294,257.5,293,257.5,291.4,257.1L291.4,257.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M282.1,255.1c-1.2-0.2-1.6-1.1-0.5-1.1c1.2,0,2.9,0.6,2.9,1.1S284.1,255.6,282.1,255.1L282.1,255.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M262.1,253.8c1.4-1.2,2.4-1.6,2.4-0.9c0,0.6-2.2,2.1-3,2.1C261,254.9,261.2,254.6,262.1,253.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M272.6,253.1c-1.2-0.2-1.6-1.1-0.5-1.1c1.2,0,2.9,0.6,2.9,1.1S274.6,253.6,272.6,253.1L272.6,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M176.5,251.2c0-1.2,0.2-1.8,0.8-1.8c0.8,0,0.9,0.6,0.4,2.4C177.2,253.6,176.5,253.2,176.5,251.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M226.3,250.4c-0.4-0.9-0.9-2.4-1.1-3.2c-0.6-2.6,0.9-2.1,1.8,0.8c0.4,1.3,0.9,2.8,1.1,3.2 c0.3,0.6,0.2,0.9-0.4,0.9C227.3,252,226.7,251.3,226.3,250.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M311.9,251.6c-0.5-0.1-0.9-0.4-0.9-0.8c0-0.2,0.4-0.4,0.8-0.2c0.5,0.1,1.2,0.3,1.8,0.3c0.5,0,1,0.2,1,0.5 C314.5,252,313.5,252.1,311.9,251.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M317,251c0-0.4,2.5-2,3.2-2c0.9,0,0,0.9-1.5,1.6C317.8,251.1,317,251.2,317,251z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M213.2,249.3C213.2,249.3,213.2,249.3,213.2,249.3C213.2,249.3,213.2,249.3,213.2,249.3 C213.2,249.3,213.2,249.3,213.2,249.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M214.2,250.5c0,0-0.1,0-0.1,0c0,0,0,0,0,0C214.1,250.5,214.1,250.5,214.2,250.5 C214.1,250.5,214.2,250.5,214.2,250.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M215.1,250C215.1,250,215.1,250,215.1,250C215.1,249.9,215.1,249.9,215.1,250 C215.1,249.9,215.1,249.9,215.1,250C215.1,250,215.1,250,215.1,250z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M215.7,249.3c0,0.2,0,0.5-0.2,0.7c-0.2,0.5-0.6,0.8-1,0.9c-0.3,0.1-0.6,0.1-1,0c-0.1,0-0.3-0.1-0.4-0.1 c0,0-0.1,0-0.1-0.1c-0.1,0-0.2-0.1-0.3-0.2c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0c0,0,0,0,0-0.1 c-0.3-0.3-0.4-0.6-0.4-0.9c0,0,0-0.1,0-0.1c0-0.2,0.1-0.3,0.1-0.5c0,0,0,0,0,0c0.1-0.2,0.3-0.4,0.6-0.6h0c0,0,0.1,0,0.2-0.1 c0,0,0,0,0.1,0c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c-0.2,0.3-0.3,0.8-0.2,1.2c0,0,0,0,0,0 c0,0.2,0,0.3,0.1,0.5c0,0,0,0,0,0c0.1-0.1,0.2-0.1,0.4-0.1c0,0,0,0,0,0c0,0.1,0,0.2,0,0.3v0c0,0.1,0,0.2,0,0.3c0,0,0,0,0.1,0.1 c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0,0.2,0,0.2,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.2-0.1,0.3-0.1 c0,0,0,0,0.1,0c0,0,0,0,0,0c0.2-0.1,0.3-0.2,0.5-0.4c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2 c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v-0.1c0-0.1,0-0.2,0-0.2c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1v0 c-0.1-0.2-0.2-0.4-0.3-0.6c-0.2-0.2-0.4-0.4-0.6-0.5c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0.1,0,0.3,0.1,0.4,0.2 c0.2,0.1,0.3,0.3,0.5,0.4c0,0,0,0,0,0C215.6,248.7,215.7,249,215.7,249.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M334.5,250.4c0-1.2,0.6-2.9,1-2.9c0.2,0,0.5,0.8,0.5,1.8c0,1.2-0.2,1.8-0.8,1.8 C334.9,251,334.5,250.7,334.5,250.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M303.1,249.9c-1.2-0.2-2.1-0.7-2.1-0.9c0-0.6,0.5-0.6,3.5,0.1c1.4,0.3,2.5,0.8,2.5,1 C307,250.6,305.9,250.6,303.1,249.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M187.5,248.4c0.5-1.8,0.9-2.2,1.3-1.8c0.6,0.5-0.4,3.4-1.1,3.4C187.2,250,187.1,249.6,187.5,248.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M294.9,248.1c-1.9-0.4-3.4-1-3.4-1.2c0-0.6,0.4-0.6,4.8,0.4c2,0.4,3.8,1,3.8,1.2 C300,249.1,298.9,249,294.9,248.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M283.1,245.6c-1.8-0.4-3.1-0.9-3.1-1.2s0.5-0.4,1.1-0.2c0.6,0.1,2.4,0.6,4,0.9c1.5,0.3,2.9,0.8,2.9,1.1 C288,246.7,287,246.6,283.1,245.6L283.1,245.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M177.5,244.6c0-2.1,0.6-3.6,1.2-3.6c0.4,0,0.5,0.6,0.2,2.1c-0.2,1.1-0.4,2.2-0.4,2.5c0,0.2-0.2,0.4-0.5,0.4 C177.8,246,177.5,245.4,177.5,244.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M324,244.6c0.5-0.8,1.7-2.9,2.6-4.8c0.9-1.9,1.8-3.4,2-3.4c0.8,0,0.5,1-1.6,5.3c-1.5,3.1-2.3,4.2-3,4.2 C323,246,323,246,324,244.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M274.9,243.9c-1.4-0.3-2.4-0.7-2.4-0.9c0-0.6,0.4-0.6,3.5,0.1c1.4,0.3,2.5,0.8,2.5,1 C278.5,244.6,278.1,244.6,274.9,243.9L274.9,243.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M189.7,239.9c0.4-1.8,0.6-2.1,1.2-1.9c0.6,0.2-0.3,3.4-1,3.4C189.5,241.5,189.5,240.9,189.7,239.9 L189.7,239.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M225.5,239.4c0.5-1.8,0.9-2.2,1.3-1.8c0.6,0.5-0.4,3.4-1.1,3.4C225.2,241,225.1,240.6,225.5,239.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M178.8,237.4c0.4-2.6,0.9-3.9,1.6-3.3c0.1,0.2,0.1,1.6-0.3,3.1C179.2,240.8,178.3,240.9,178.8,237.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M265.4,238.4c-0.5-1.1-0.6-1.7-0.2-1.9c0.7-0.2,1.9,1.4,1.9,2.6C267,240.5,266.2,240.1,265.4,238.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M190.5,236.5c0-1.6,1.2-5,1.8-5c0.8,0-0.3,5.1-1.1,5.4C190.8,237,190.5,236.8,190.5,236.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M226.8,235.9c0.5-1.6,3.1-5.2,4.6-6.1c1.6-1.1,1.4-0.3-0.5,1.8c-0.9,0.9-2,2.6-2.4,3.6 C227.5,237.1,226.2,237.8,226.8,235.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M332.9,234.3c-0.5-0.4-0.9-0.8-0.9-1c0-0.6,1.8-0.4,2.4,0.3C335.8,235,334.5,235.6,332.9,234.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M263.8,232.4c-0.5-1.8-0.4-2.4,0.5-2.4c0.5,0,0.8,0.6,0.8,1.8C265,233.7,264.3,234.1,263.8,232.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M192.5,226.9c0-1.5,0.6-2.9,1.4-2.9c0.5,0,0.6,0.3,0.4,0.8c-0.1,0.4-0.3,1.2-0.3,1.8c0,0.5-0.4,0.9-0.8,0.9 S192.5,227.2,192.5,226.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M181,225.9c0-1.2,0.6-2.9,1.1-2.9s0.6,1.6,0.1,2.7C181.8,226.6,181,226.8,181,225.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M220,225.3c0-0.4-0.4-0.8-0.8-0.8c-1.1,0-0.9-0.9,0.2-1.4c1.2-0.6,2.8,0.4,2.4,1.8 C221.7,225.9,220,226.4,220,225.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M262.7,223.1c-0.2-1.1-0.9-3.4-1.5-5.3c-1-3.1-1.1-3.4-0.3-3.2c0.9,0.1,2.5,4.6,3.3,8.6 c0.2,1.4,0.2,1.9-0.4,1.9C263.3,225,262.9,224.3,262.7,223.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M193.7,220.4c0.1-0.9,0.3-1.9,0.3-2.2c0-0.4,0.4-0.7,0.8-0.7c0.6,0,0.8,0.4,0.5,1.6c-0.1,0.9-0.3,1.9-0.3,2.2 c0,0.4-0.4,0.7-0.8,0.7C193.6,222,193.4,221.6,193.7,220.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M182.5,219.9c0-1.2,1.1-4.9,1.6-4.9c0.6,0,0.6,0.6-0.1,3.3C183.4,220.2,182.5,221.4,182.5,219.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M184.5,211.9c0-1.2,1.6-5.9,2.1-5.9c0.6,0,0.6,0.8-0.4,3.9C185.4,212.2,184.5,213.4,184.5,211.9L184.5,211.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M258.5,211.6c-0.6-1.1-0.6-2.6-0.1-2.6c0.4,0,2.1,2.6,2.1,3.2C260.5,212.9,259,212.4,258.5,211.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M195.5,209.2c0-1.2,0.2-1.8,0.8-1.8c0.8,0,0.9,0.6,0.4,2.4C196.2,211.6,195.5,211.2,195.5,209.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M255.9,207.4c-1.1-1.4-1.4-3.4-0.3-2.7c1,0.6,2.3,3.1,2,3.7C257.2,208.9,256.8,208.6,255.9,207.4L255.9,207.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M196.5,199.8c0-1.2,0.2-1.8,0.8-1.8c0.8,0,0.9,0.6,0.4,2.4C197.2,202.1,196.5,201.7,196.5,199.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M246.5,198.6c-0.9-0.8-2.9-1.9-4.4-2.6c-1.4-0.7-2.6-1.6-2.6-1.9c0-0.4,0.1-0.6,0.4-0.5 c3.6,1.8,5.1,2.6,5.1,2.9c0,0.1,0.8,0.6,1.7,0.9c0.9,0.4,2.1,1.1,2.6,1.6c0.9,0.9,0.9,1-0.1,1C248.6,200,247.4,199.4,246.5,198.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M190.2,194.2c0.2-0.6,0.5-1.4,0.6-1.8c0.1-0.5,0.6-0.9,0.9-0.9c0.6,0,0.6,0.2,0.1,1.6 c-0.4,0.9-0.9,1.7-1.4,1.8C190.1,195.1,189.9,194.9,190.2,194.2L190.2,194.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M234,192.6c-4.2-1.4-4.3-1.4-3.9-1.9c0.4-0.4,7.2,1.6,7.6,2.4C238.4,194,237.9,193.9,234,192.6L234,192.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M224.9,190.1c-0.5-0.1-0.9-0.4-0.9-0.8s0.5-0.4,1.1-0.2c0.6,0.1,1.4,0.3,1.8,0.3c0.3,0,0.6,0.2,0.6,0.5 C227.5,190.5,226.4,190.6,224.9,190.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M219.1,189.1c-0.6-0.1-1.1-0.4-1.1-0.8s0.6-0.4,1.6-0.2c0.9,0.1,1.8,0.3,2,0.3s0.4,0.2,0.4,0.5 C222,189.5,221.2,189.6,219.1,189.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M209.6,188.1c-1.2-0.1-2.1-0.4-2.1-0.8s0.6-0.4,1.6-0.2c0.9,0.1,2.2,0.3,3,0.3s1.4,0.2,1.4,0.5 s-0.4,0.4-0.9,0.4S210.8,188.2,209.6,188.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M200.6,187.6c-1.2-0.1-2.1-0.4-2.1-0.8s0.6-0.4,1.6-0.2c0.9,0.1,2.2,0.3,3,0.3s1.4,0.2,1.4,0.5 s-0.4,0.4-0.9,0.4S201.8,187.8,200.6,187.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M186.4,172.1c-0.6-0.6-0.4-1.1,0.6-0.8c0.9,0.2,0.9,0.1,0.5-1.1c-0.4-1.1-0.4-1.3,0.2-1.3 c0.8,0,1.8,1.5,1.8,2.7C189.5,172.5,187.1,172.8,186.4,172.1L186.4,172.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M180.6,169.8c-2.1-0.9-2.2-1.9-0.1-1.1c1.4,0.4,2.3,1.2,1.9,1.6C182.3,170.4,181.5,170.1,180.6,169.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M173.9,167.1c-3.2-1.2-4.2-2.1-2.7-2.1c1.1,0,6.3,2.4,6.3,3c0,0.2-0.1,0.5-0.1,0.4 C177.3,168.4,175.8,167.8,173.9,167.1L173.9,167.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M147.5,166c0-0.6,1.4-0.6,2.8,0c0.8,0.4,0.6,0.4-0.9,0.4C148.3,166.5,147.5,166.3,147.5,166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M161.5,166.1c0-0.2,0.8-0.6,1.8-0.6c1.9-0.2,2.4,0.3,0.6,0.8C162.3,166.6,161.5,166.6,161.5,166.1 L161.5,166.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M185.1,164.6c-0.7-2.2-0.8-4.6-0.2-4.6c0.2,0,0.9,1.4,1.4,3.2c1,3,1,3.2,0.2,3.2 C185.9,166.5,185.4,165.9,185.1,164.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M141.4,165.6c-0.5-0.1-0.9-0.4-0.9-0.8c0-0.2,0.4-0.4,0.8-0.2c0.4,0.1,1.2,0.3,1.8,0.3c0.5,0,0.9,0.2,0.9,0.5 C144,166,142.9,166.1,141.4,165.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M165.5,165.6c0-0.6,2.9-1.3,3.4-0.9c0.4,0.4,0.1,0.6-1.7,0.9C166.3,165.8,165.5,165.8,165.5,165.6 L165.5,165.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M131.1,163c-1.9-0.8-1.4-1.4,0.6-0.9c0.9,0.3,1.8,0.7,1.8,0.9C133.5,163.6,132.6,163.5,131.1,163L131.1,163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M126.7,161.2c-1.4-0.6-2.3-1.8-1.4-1.8c0.7,0,3.2,1.6,3.2,2C128.5,162.1,128.6,162.1,126.7,161.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M117.5,156.1c-1.6-1.3-1.6-1.5-0.7-1.6c1.2,0,2.9,1.6,2.6,2.5C119.3,157.3,118.5,156.9,117.5,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M112.4,151.6c-2.8-3-3.9-4.6-3.9-5.8c0-1.4,0.7-1.1,1.7,0.6c0.5,0.9,2.2,2.9,3.7,4.5c2.1,2.3,2.6,3,1.8,3 C115.2,154,113.7,152.9,112.4,151.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M198.6,146.8c1.1-1.8,1.9-2.2,1.9-1.2s-1.6,3-2.3,3C197.6,148.5,197.8,148.1,198.6,146.8L198.6,146.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M201.2,141.6c0.6-1.9,1.8-2.9,1.8-1.4c0,1.2-1.1,3.3-1.8,3.3C200.6,143.5,200.6,143.1,201.2,141.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M105.3,138.9c-0.4-2.2-0.4-2.4,0.4-2.4c0.6,0,1.3,2,1.3,3.6C107,141.2,105.6,140.3,105.3,138.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M202.5,134.9c0-3.4-0.9-7.2-2.1-9.8c-1.1-1.9-1.1-2.2-0.1-2.2c1.8,0,4.2,9.4,3.4,13.3 C203.2,139.1,202.5,138.2,202.5,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M105,134c0-1.4,0.2-2,0.8-2s0.8,0.6,0.8,2s-0.2,2-0.8,2S105,135.4,105,134z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M105.4,129.9c0.3-1.6,1.6-2.6,1.6-1.3c0,1.4-0.7,2.9-1.2,2.9C105.3,131.5,105.2,131,105.4,129.9L105.4,129.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M107.5,124.3c0-0.9,1.8-3.2,2.2-2.7c0.4,0.4-1.2,3.4-1.8,3.4C107.7,125,107.5,124.7,107.5,124.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M114.9,114.8c1.1-1.2,6.2-4.5,6.5-4.2c0.2,0.2-0.1,0.6-0.5,0.8s-1.9,1.2-3.2,2.2 C115.4,115.5,113.8,116.1,114.9,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M189.4,112.7c-2.1-1.6-3-2.7-2.1-2.7c0.5,0,5,3,5.6,3.8C194.2,115.2,191.8,114.5,189.4,112.7L189.4,112.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M124,109.1c0-0.6,2.9-1.8,3.3-1.4c0.2,0.2-0.4,0.7-1.2,1.1C124.3,109.6,124,109.7,124,109.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M175.1,105.8c-2-0.6-2.2-1.6-0.2-1.1c1.4,0.3,2.4,1.1,2.1,1.4C176.8,106.2,176,106.1,175.1,105.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M134,105.1c0-0.4,3.6-1.6,5-1.6c1.2,0-0.1,0.9-1.8,1.2c-0.9,0.2-2.1,0.5-2.5,0.7S134,105.4,134,105.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M141,103.5c0-0.2,0.5-0.5,1.1-0.7c1.4-0.3,4.6-0.4,4.2-0.1C145.9,103.2,141,103.9,141,103.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M164.6,103.4c-2.6-0.5-3.2-0.9-1.2-0.9c2.4,0,5.2,0.6,5.2,1.1C168.5,104.1,167.6,104.1,164.6,103.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M147.5,102.5c0-0.2,0.9-0.5,1.9-0.4c1.5,0,1.6,0.1,0.9,0.4C148.9,103.1,147.5,103.1,147.5,102.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M157.2,102.5c-0.8-0.3-0.6-0.4,0.9-0.4c1-0.1,1.9,0.2,1.9,0.4C160,103.1,158.6,103.1,157.2,102.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M320.3,284.5c-0.5-0.5-1-2.4-1.3-4.1c-0.6-4.1-0.6-4,0.2-4c0.5,0,0.8,0.9,1,2.6c0.3,3,1.2,5.4,2.2,5.4 c0.4,0,0.6,0.2,0.6,0.5C323,285.8,321.2,285.5,320.3,284.5L320.3,284.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M213,284.5c-4.9-0.5-7-1-7-1.6c0-0.3,0.5-0.4,1.1-0.2c0.6,0.1,3.4,0.5,6.2,0.9c2.8,0.3,5.1,0.8,5.1,1 C218.5,285,218.6,285,213,284.5L213,284.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M220,284.5c0-0.2,0.9-0.5,1.9-0.5c1.5,0,1.6,0.1,0.9,0.5C221.4,285.1,220,285.1,220,284.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M200.9,282.1c-1-0.2-1.2-1.1-0.2-1.1c1.2,0,2.9,0.6,2.9,1C203.5,282.5,202.4,282.5,200.9,282.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M233.2,282c0.4-0.6,3.3-1.6,3.3-1.1c0,0.4-2.2,1.5-3.1,1.5C233.1,282.5,233.1,282.3,233.2,282L233.2,282z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M190.4,278.6c-4.6-1.8-4.6-3-0.1-1.3c3.9,1.5,4.1,1.6,4.1,2.2S194.2,280.1,190.4,278.6L190.4,278.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M239,279.6c0-0.2,0.9-0.9,1.9-1.5s2.6-1.7,3.5-2.4c0.9-0.8,1.6-1,1.6-0.7c0,0.7-2,2.5-2.9,2.5 c-0.4,0-0.6,0.2-0.6,0.4c0,0.4-2.6,2.1-3.2,2.1C239.2,280,239,279.8,239,279.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M327.5,278.9c0-1,1.2-3.4,1.8-3.4c0.6,0,0.6,0.2,0,1.6C328.8,278.4,327.5,279.6,327.5,278.9L327.5,278.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M180,274.1c-2.8-1.4-3.8-2.1-3.9-3c-0.2-1.4,0.4-1.5,1.2-0.1c0.4,0.5,2.1,1.6,3.9,2.5c1.9,0.9,3.3,1.8,3.3,2 C184.5,276.2,184.1,276.1,180,274.1L180,274.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M318.5,273.8c0-2,0.7-2.4,1.2-0.6s0.4,2.4-0.5,2.4C318.8,275.5,318.5,275,318.5,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M247,274c0-0.8,2.6-3.5,3.4-3.5c0.5,0,0.5,0.3-0.1,1.2C249.4,273.1,247,274.8,247,274L247,274z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M175.5,267.8c0-2,0.7-2.4,1.2-0.6c0.4,1.8,0.4,2.4-0.4,2.4C175.8,269.5,175.5,269,175.5,267.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M317,267.5c-1.2-2.4-1.2-2.5-0.2-2.5c0.8,0,2.2,2.5,2.2,3.8C319,270.1,318,269.5,317,267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M184.1,259.3c0.9-2.6,1.9-4.8,2.2-4.8c0.4,0,0.1,1.4-1,4.6C183.2,265.3,182.1,265.4,184.1,259.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M312.9,262.5c-0.8-0.5-3-1.4-4.9-1.9c-3.8-0.9-4.9-1.9-1.4-1.4c3,0.5,7.4,2.2,7.7,3 C314.8,263.4,314.4,263.5,312.9,262.5L312.9,262.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M175.7,259.5c0.1-1.7,0.3-3.6,0.3-4.2c0-0.8,0.3-1.2,0.8-1.2c0.6,0,0.8,0.4,0.5,2.7c-0.6,4.8-0.8,5.9-1.4,5.9 C175.5,262.5,175.4,261.5,175.7,259.5L175.7,259.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M333,260.9c0.3-1.5,1.5-2.6,1.5-1.3c0,1.4-0.6,2.9-1.2,2.9C332.8,262.5,332.7,262,333,260.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M286.6,256.1c-1.2-0.2-1.6-1.1-0.5-1.1c1.2,0,2.9,0.6,2.9,1C289,256.5,288.6,256.5,286.6,256.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M334.2,253.9c0.1-0.9,0.3-2.1,0.3-2.8c0-0.8,0.3-1.2,0.8-1.2c0.6,0,0.8,0.4,0.5,1.6c-0.1,0.9-0.3,2.1-0.3,2.8 c0,0.8-0.3,1.2-0.8,1.2C334.1,255.5,334,255.1,334.2,253.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M186,253.3c0-0.1,0.2-0.9,0.6-1.8c0.6-1.6,1.4-2.1,1.4-0.9c0,1.4-0.6,2.9-1.3,2.9 C186.3,253.5,186,253.4,186,253.3L186,253.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M226.2,250.4c-1.1-2.8-1.4-5.4-0.6-5.4c0.4,0,0.9,1,1.2,2.4c0.4,1.3,0.8,2.9,0.9,3.5 C228.3,252.6,227.1,252.2,226.2,250.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M312.4,251.6c-1.7-0.4-0.9-0.9,1.6-0.9c2.6,0,3.2,0.4,1.4,0.9C314.1,252,313.7,252,312.4,251.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M214.2,250.5c0,0-0.1,0-0.1,0c0,0,0,0,0,0C214.1,250.5,214.1,250.5,214.2,250.5 C214.1,250.5,214.2,250.5,214.2,250.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M215.1,250C215.1,249.9,215.1,249.9,215.1,250C215.1,249.9,215.1,249.9,215.1,250 C215.1,250,215.1,250,215.1,250C215.1,250,215.1,250,215.1,250z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M215.4,249.7c0.1,0.4-0.2,0.9-0.9,1.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3,0 c-0.1,0-0.2,0-0.2,0c-0.2,0-0.3-0.1-0.4-0.1c0,0,0,0,0,0c0,0-0.1-0.1-0.1-0.1v0c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0.1,0.1 c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0,0.2,0,0.2,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.2-0.1,0.3-0.1 c0,0,0,0,0.1,0c0,0,0,0,0,0c0.2-0.1,0.3-0.2,0.5-0.4c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0-0.1 C215.3,249.8,215.3,249.7,215.4,249.7c0-0.1,0-0.1,0-0.1c0,0,0,0,0,0C215.4,249.6,215.4,249.6,215.4,249.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M319.5,249.7c0-0.5,2.2-2.1,2.9-2.2c0.3,0,0.6-0.4,0.6-0.9c0-1.1,1.7-2.8,2.5-2.5c0.8,0.2-4.5,5.9-5.5,5.9 C319.7,250,319.5,249.9,319.5,249.7L319.5,249.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M177,247.8c0-1.2,0.2-1.8,0.8-1.8c0.8,0,0.9,0.6,0.4,2.4C177.7,250.1,177,249.7,177,247.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M299.6,249.1c-1.2-0.2-1.6-1.1-0.5-1.1c1.2,0,2.9,0.6,2.9,1.1S301.6,249.6,299.6,249.1L299.6,249.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M335,247.2c0-1.2,0.2-1.8,0.8-1.8c0.8,0,0.9,0.6,0.5,2.4C335.7,249.6,335,249.2,335,247.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M295.1,248.1c-1.2-0.2-1.6-1.1-0.5-1.1c1.2,0,2.9,0.6,2.9,1.1S297.1,248.6,295.1,248.1L295.1,248.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M188.2,245.9c0.4-1.8,0.6-2.1,1.2-1.9c0.6,0.2-0.3,3.4-1,3.4C188,247.5,188,246.9,188.2,245.9L188.2,245.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M271.4,243.1c-0.5-0.1-0.9-0.4-0.9-0.8s0.5-0.4,1.1-0.2c0.6,0.1,1.4,0.3,1.8,0.3c0.3,0,0.6,0.2,0.6,0.5 C274,243.5,273,243.6,271.4,243.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M225,241.9c0-1.2,0.6-2.9,1.1-2.9c0.2,0,0.4,0.8,0.4,1.8c0,1.2-0.2,1.8-0.8,1.8 C225.4,242.5,225,242.2,225,241.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M334.9,239.8c-0.2-2,0.8-2.5,1.3-0.6c0.5,1.8,0.4,2.4-0.4,2.4C335.4,241.5,335,240.8,334.9,239.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M190,238.9c0-1.4,1.1-4.4,1.5-4.4c0.6,0,0.6,0.8-0.1,3.1C191,239.4,190,240.2,190,238.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M327.5,238.5c0-0.9,1.4-3.2,2.2-3.9c1.1-1,1,0.1-0.3,2.5C328.4,238.9,327.5,239.6,327.5,238.5L327.5,238.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M226,237.8c0-0.7,1.6-3.2,2-3.2c0.7,0-0.6,3.1-1.4,3.4C226.2,238,226,237.9,226,237.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M333.6,235c-0.4-0.6-1-1-1.4-1s-0.8-0.2-0.8-0.5c0-0.2,0.4-0.5,0.8-0.5c1.4,0,2.7,1,2.7,2 C335,236.3,334.4,236.2,333.6,235z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M179.5,233.4c0-1.4,0.8-2.8,1.2-2.3s-0.2,3.4-0.8,3.4C179.7,234.5,179.5,234,179.5,233.4L179.5,233.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M263.8,231.4c-0.8-5-0.8-7.4-0.1-7.4c0.7,0,1.3,3.3,1.3,7.1C265,233.4,264.1,233.6,263.8,231.4L263.8,231.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M191.5,232.2c0-0.7,2.1-10.5,2.2-10.6c0.1-0.1,0.4-0.1,0.6-0.1c0.6,0.2-1.5,10.6-2.2,10.9 C191.8,232.5,191.5,232.5,191.5,232.2L191.5,232.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M229.6,231.6c0.9-1.2,2.1-2.1,2.4-1.9c0.3,0.3-2,2.7-2.6,2.7C229.1,232.5,229.2,232.1,229.6,231.6 L229.6,231.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M180.5,228.4c0-1.4,0.8-2.8,1.2-2.3s-0.2,3.4-0.8,3.4C180.7,229.5,180.5,229,180.5,228.4L180.5,228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M232.5,229.1c0-0.4,2.1-1.6,2.8-1.6c0.8,0,0.1,0.9-1,1.4C232.7,229.6,232.5,229.6,232.5,229.1L232.5,229.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M261.5,218.2c-0.6-1.6-0.6-2.2,0-2.2s1.5,1.6,1.5,2.7C263,219.9,262,219.6,261.5,218.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M183.7,214.9c0.1-0.9,0.4-1.7,0.6-1.8c0.6-0.6,0.8,0.4,0.5,1.9C184.3,217.1,183.3,217,183.7,214.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M194.7,214.1c0.7-3.9,0.9-4.6,1.4-4.6c0.6,0,0.6,1,0.1,4.2c-0.2,1.6-0.6,2.3-1.1,2.3 C194.5,216,194.4,215.6,194.7,214.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M259.2,213c-0.8-1.6-1-3-0.4-3c0.5,0,1.5,1.6,2.1,3.3C261.7,215.1,260.2,214.9,259.2,213z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M185.5,208.4c0-1.4,0.6-2.9,1.2-2.9c0.5,0,0.6,0.4,0.1,1.8C186.4,208.9,185.5,209.6,185.5,208.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M195.8,206.6c0.6-4.1,0.8-5.1,1.3-5.1c0.6,0,0.6,1.2,0.1,4.9c-0.2,1.8-0.6,2.6-1.1,2.6 S195.5,208.5,195.8,206.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M187,202.8c0-0.9,1.2-3.3,1.8-3.3s0.6,0.4,0.1,1.8c-0.3,0.9-0.8,1.8-1.2,1.8C187.3,203,187,202.9,187,202.8 L187,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M248,199.6c-1.2-1.1-1.5-1.5-0.9-1.6c1.1,0,3.1,1.7,2.9,2.4C249.8,200.8,249.1,200.4,248,199.6L248,199.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M189.6,195.5c0.5-1.4,1.2-2.3,1.6-1.9c0.4,0.4-1,3.4-1.6,3.4C189.2,197,189.2,196.6,189.6,195.5L189.6,195.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M196.5,194.2c0-1.6,0.2-2.2,0.8-2.2s0.8,0.6,0.8,2.2s-0.2,2.2-0.8,2.2S196.5,195.9,196.5,194.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M240.6,195.2c-1.4-0.7-2.6-1.4-2.6-1.8c0-0.7,0.2-0.6,3,0.8c1.4,0.7,2.5,1.5,2.5,1.8 C243.5,196.6,243.7,196.7,240.6,195.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M227.4,190.6c-0.5-0.1-0.9-0.4-0.9-0.8s0.5-0.4,1.1-0.2c0.6,0.1,1.4,0.3,1.8,0.3c0.3,0,0.6,0.2,0.6,0.5 C230,191,228.9,191.1,227.4,190.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M222.4,189.6c-1.4-0.2-2-1.1-0.8-1.1s2.9,0.6,2.9,1.1c0,0.2-0.1,0.4-0.4,0.4 C223.9,189.9,223.1,189.8,222.4,189.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M193.4,188.6c-0.2-0.1,0-0.8,0.5-1.2c0.9-1,3.1-1.2,3.1-0.4c0,0.3-0.4,0.4-0.8,0.2c-0.4-0.1-1.1,0.2-1.6,0.7 C194.1,188.5,193.5,188.8,193.4,188.6L193.4,188.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M213.9,188.5c-3.4-0.4-4.4-1-1.8-1c2.8,0,6.4,0.6,6.4,1.1C218.5,189.1,218.1,189.1,213.9,188.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M200.6,187.6c-1.4-0.1-2.6-0.4-2.6-0.8s0.6-0.4,1.6-0.2c0.9,0.1,2.6,0.3,3.8,0.3s2.2,0.2,2.2,0.5 s-0.5,0.4-1.1,0.4C203.8,187.8,202,187.8,200.6,187.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M186.1,172.1c-1.8-0.8-3.4-1.6-3.4-2c-0.1-0.4,0.4-0.4,1.7,0.2c3.5,1.5,3.8,1.5,3.4,0c-0.5-2,0.6-1.6,1.8,0.6 c0.9,1.8,0.9,2.6,0.1,2.6C189.4,173.4,187.8,172.9,186.1,172.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M186,167.1c-0.7-1.4-0.6-2.7,0.1-2.4c0.4,0.1,0.9,0.9,1.2,1.8c0.6,1.4,0.6,1.6-0.1,1.6 C186.9,168,186.3,167.6,186,167.1L186,167.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M159.8,166c1.4-0.6,2.8-0.6,2.8,0c0,0.3-0.9,0.5-1.9,0.4C159.1,166.4,158.9,166.3,159.8,166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M138.9,165.1c-2.1-0.4-3.9-0.9-3.9-1.2s0.1-0.4,0.3-0.4c0.7,0,10.4,2.1,10.6,2.3 C146.4,166.2,142.6,165.9,138.9,165.1L138.9,165.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M167.2,165c0.4-0.6,3.2-0.6,3.2-0.1c0,0.2-0.8,0.4-1.8,0.5C167.7,165.4,167.1,165.2,167.2,165z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M119.2,157.2c-1.9-1.2-3.9-2.8-4.4-3.2c-0.8-0.8-0.8-0.9-0.2-0.9c0.8,0,8.6,5.2,8.8,6.1 C123.8,159.9,122.6,159.4,119.2,157.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M186,158.6c0-0.4,4.2-3.1,4.9-3.1c0.1,0,0,0.4-0.4,0.8C189.7,157.2,186,159.2,186,158.6L186,158.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M191.5,155.1c0-0.6,2.2-2.6,2.9-2.6c0.4,0,0.5,0.2,0.3,0.5C194.2,153.8,191.5,155.6,191.5,155.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M107.5,145.1c-0.7-1.2-0.7-2.6,0-2.6c0.4,0,2,2.6,2,3.2S108,145.9,107.5,145.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M199.5,145.8c0-0.7,1.6-3.2,2-3.2c0.6,0,0.6,0.3-0.2,2C200.6,145.8,199.5,146.6,199.5,145.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M201.5,141.4c0-1.5,0.6-2.9,1.3-2.9c0.9,0,0.9-0.1,0.1,1.9C202.4,142,201.5,142.6,201.5,141.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M202.5,134.5c0-1.6,0.2-3,0.4-3c0.7,0,1.2,2.8,0.8,4.5C203.2,138.5,202.5,137.7,202.5,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M105,134c0-1.8,0.2-2.5,0.7-2.5s0.7,0.7,0.7,2.5s-0.2,2.5-0.7,2.5S105,135.8,105,134z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M201.5,127.7c-0.6-1.6-0.6-2.2,0-2.2s1.5,1.7,1.5,2.7C203,129.4,202,129.1,201.5,127.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M109.5,120.7c1.7-2.2,4.8-5.2,5.4-5.2c0.8,0-4.3,5.7-5.4,5.9C108.9,121.6,108.9,121.5,109.5,120.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M189.6,112.7c-1.1-0.8-1.4-1.7-0.6-1.7c0.3,0,1.1,0.6,1.9,1.2C192.5,113.7,191.5,114,189.6,112.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M119.5,111.8c0-0.3,3.7-2.8,4.1-2.8c0.9,0,0.2,0.8-1.6,1.9C120.1,112,119.5,112.2,119.5,111.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M182.5,108.8c-1.8-0.9-3.9-1.8-4.6-2c-0.8-0.2-1.4-0.6-1.4-0.8c0-0.3,0.6-0.3,1.4-0.2 c2.4,0.6,8.6,3.7,8.6,4.2C186.5,110.8,186.1,110.6,182.5,108.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M128.2,107.1c0.4-0.6,3.3-1.6,3.3-1.1c0,0.4-2.2,1.6-3.1,1.6C128.1,107.5,128.1,107.3,128.2,107.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M172.6,105.2c-1.2-0.2-1.6-1.2-0.5-1.2c1.2,0,2.9,0.6,2.9,1.1C175,105.5,174.6,105.6,172.6,105.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M165.6,103.6c-0.9-0.1-1.6-0.4-1.6-0.7c0-0.3,0.6-0.4,1.6-0.2C168.3,103.3,168.3,103.9,165.6,103.6 L165.6,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M157.8,102.5c-0.8-0.3-0.6-0.4,0.9-0.4c1-0.1,1.9,0.2,1.9,0.4C160.5,103.1,159.1,103.1,157.8,102.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M320.4,284.6c-0.4-0.5-0.9-1.3-1-1.8c-0.5-1.5,0.9-1,1.6,0.4c0.5,1,0.9,1.2,1.9,1c0.8-0.1,1.1,0,1,0.4 C323.6,285.6,321.2,285.6,320.4,284.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M216.2,284.5c-0.6-0.2,0.9-0.5,4.5-0.6c5.2-0.2,6.2-0.1,5.7,0.3C226,284.6,217.1,284.9,216.2,284.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M209.9,284.1c-1.4-0.2-2-1.1-0.8-1.1s2.9,0.6,2.9,1c0,0.2-0.1,0.4-0.4,0.4 C211.4,284.4,210.6,284.2,209.9,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M228.5,283.5c0-0.5,1.6-1,3-1c1.1,0-0.1,0.8-1.6,1.2C229.1,283.9,228.5,283.8,228.5,283.5L228.5,283.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M204.6,283.1c-1.2-0.2-1.6-1.1-0.5-1.1c1.2,0,2.9,0.6,2.9,1C207,283.5,206.6,283.5,204.6,283.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M325.5,282.3c0-1,1.9-3.1,2.2-2.7c0.4,0.4-1.2,3.4-1.9,3.4C325.7,283,325.5,282.7,325.5,282.3L325.5,282.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M198.4,281.4c-1.9-0.6-3.4-1.4-3.4-1.7c0-0.5,1.1-0.2,4,0.7c2.2,0.7,4,1.5,4,1.7 C203,282.7,202.1,282.6,198.4,281.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M235,281.6c0-0.2,0.8-0.8,1.8-1.2c1.2-0.6,1.8-0.7,1.6-0.2C238.2,280.8,235,282.2,235,281.6L235,281.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M239,279.6c0-0.4,0.7-0.8,3.1-2c0.2-0.1,0.4,0,0.4,0.2c0,0.4-2.6,2.1-3.2,2.1C239.2,280,239,279.8,239,279.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M191.1,278.9c-0.9-0.2-1.6-0.8-1.6-1.1c0-0.5,0.4-0.5,1.5-0.1c1.4,0.5,2.4,1.3,1.9,1.6 C192.8,279.2,192,279.1,191.1,278.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M318.8,278.4c-0.5-1.8-0.4-5.9,0.1-5.9c0.6,0,1,1.9,1,4.6C320,279.6,319.3,280.3,318.8,278.4L318.8,278.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M185.6,276.5c-3.6-1.5-4.9-3-1.6-1.9c2.9,1,5.1,2.2,5.1,2.8C189,278.1,189.3,278.2,185.6,276.5L185.6,276.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M248.1,272.2c1.5-1.5,2.8-2.5,2.9-2.2c0.2,0.7-3.9,5-4.9,5C245.7,275,246.6,273.8,248.1,272.2L248.1,272.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M329.1,274.4c0.1-0.4,1-3.2,1.9-6.2c1-3.2,1.9-5.6,2.2-5.6c0.6,0-1.1,7.4-2.5,10.9 C330.1,274.9,328.6,275.8,329.1,274.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M176.9,272.4c-0.4-0.3-1-1.4-1.1-2.2c-0.2-1.3-0.1-1.6,0.5-1.6c0.5,0,0.8,0.4,0.8,1c0,0.5,0.2,1.5,0.6,2 C178.2,272.8,178,273.2,176.9,272.4L176.9,272.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M253,267.6c0-0.8,5-8.6,5.5-8.6c0.8,0,0.5,0.5-1.8,4.2C254.5,266.9,253,268.6,253,267.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M315.6,265c-0.7-1.1-0.8-2.7-0.1-2.2c0.2,0.1,1,1,1.5,1.8c1,1.4,1,1.5,0.1,1.5 C316.6,266,315.9,265.5,315.6,265z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M333.2,259.6c0.7-4.1,0.9-4.6,1.5-4.6c0.5,0,0.5,0.6,0.2,2.4c-0.6,3.3-1,4.1-1.5,4.1 C333.1,261.5,333,260.8,333.2,259.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M295.1,257.9c-1.2-0.2-2.1-0.7-2.1-1c0-0.2,0.5-0.4,1.1-0.2c0.6,0.1,2,0.5,3,0.6c1,0.2,1.9,0.5,1.9,0.8 C299,258.6,298,258.5,295.1,257.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M260,256c0.5-0.8,1.2-1.6,1.5-1.8c0.9-0.5,0.5,0.9-0.5,2.1C259.6,258,258.8,257.8,260,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M288.1,256.4c-1.2-0.2-2.1-0.7-2.1-0.9c0-0.3,0.4-0.4,0.9-0.2c0.5,0.1,1.8,0.4,3,0.6 c1.1,0.2,2.1,0.5,2.1,0.8C292,257.1,291,257,288.1,256.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M176,255.1c0.1-1.5,1.4-10.3,1.7-10.5c0.8-0.8,0.8,0.6,0.2,5.6c-0.4,3.6-0.8,5.3-1.2,5.3 C176.3,255.5,176,255.4,176,255.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M186.2,252.9c0.4-1.8,0.6-2.1,1.2-1.9c0.6,0.2-0.3,3.4-1,3.4C186,254.5,186,253.9,186.2,252.9L186.2,252.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M277.1,254.1c-0.6-0.1-1.1-0.4-1.1-0.8s0.6-0.4,1.5-0.2c0.9,0.1,1.8,0.3,2,0.3s0.5,0.2,0.5,0.5 C280,254.5,279.2,254.6,277.1,254.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M227,252.1c-0.6-1.3-0.6-1.6,0.2-1.6s1.9,1.7,1.4,2.2C228.1,253.2,227.5,253,227,252.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M270.1,252.6c-0.6-0.1-1.1-0.4-1.1-0.8s0.6-0.4,1.5-0.2c0.9,0.1,1.8,0.3,2,0.3s0.5,0.2,0.5,0.5 C273,253,272.2,253.1,270.1,252.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M312.8,251.5c-0.8-0.3-0.5-0.4,1.2-0.4s2,0.1,1.2,0.4c-0.5,0.2-1.1,0.4-1.2,0.4S313.3,251.8,312.8,251.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M307.9,250.9c-1.4-0.3-2.4-0.7-2.4-0.9c0-0.6,0.4-0.6,3.5,0.1c1.4,0.3,2.5,0.8,2.5,1 C311.5,251.6,311.1,251.6,307.9,250.9L307.9,250.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M334.9,245.6c0.1-5.4-0.1-8.4-1.1-10.8c-0.2-0.6-0.1-0.9,0.4-0.9c1.6,0,2.6,6.4,2.1,13.1 c-0.2,2.9-0.5,4.4-1,4.4C334.8,251.5,334.8,249.9,334.9,245.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M213.2,249.3C213.2,249.3,213.2,249.3,213.2,249.3C213.2,249.3,213.2,249.3,213.2,249.3 C213.2,249.3,213.2,249.3,213.2,249.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M213.5,250.8c0.1,0,0.2,0,0.2,0c0,0,0,0-0.1,0c0,0,0,0,0,0h0c-0.1,0-0.3,0-0.5-0.1c0,0-0.1,0-0.1,0 c-0.1,0-0.1-0.1-0.2-0.2c0,0,0,0,0,0c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1v0c0,0,0,0,0-0.1v0 c0,0,0-0.1-0.1-0.1c-0.1-0.3-0.2-0.5-0.3-0.7c0,0,0-0.1,0-0.1c0-0.2,0-0.3,0.1-0.5c0,0,0,0,0,0c0.1-0.1,0.3-0.3,0.5-0.4 c0,0,0,0,0.1,0c0,0-0.1,0.1-0.1,0.1c-0.2,0.3-0.3,0.8-0.2,1.2c0,0,0,0,0,0c0,0.2,0,0.3,0.1,0.5c0,0,0,0,0,0 c0.1-0.1,0.2-0.1,0.4-0.1c0,0,0,0,0,0c0,0.1,0,0.2,0,0.3v0c0,0.1,0,0.2,0,0.3c0,0,0,0,0.1,0.1 C213.2,250.7,213.4,250.7,213.5,250.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M213.8,247.7C213.8,247.7,213.8,247.7,213.8,247.7c0,0-0.1,0-0.2,0l0,0c0,0,0,0,0,0c0,0-0.1,0-0.2,0 c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0,0.1,0,0.1,0c0.1-0.1,0.2-0.1,0.3-0.2c0,0,0,0,0,0C213.6,247.6,213.7,247.6,213.8,247.7 C213.7,247.7,213.7,247.7,213.8,247.7C213.8,247.7,213.8,247.7,213.8,247.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M214.2,250.5C214.1,250.5,214.2,250.5,214.2,250.5c0,0-0.1,0-0.1,0c0,0,0,0,0,0 C214.1,250.5,214.1,250.5,214.2,250.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M318,250.6c0-0.2,0.8-0.9,1.8-1.6c1-0.7,1.7-0.9,1.6-0.5C321.1,249.3,318,251.3,318,250.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M301.1,249.4c-1.2-0.2-2.1-0.7-2.1-1c0-0.2,0.3-0.4,0.7-0.2c0.4,0.1,1.7,0.4,3,0.6c1.2,0.2,2.3,0.6,2.3,0.8 C305,250.1,304,250.1,301.1,249.4L301.1,249.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M188.9,243.4c1.3-4.9,1.4-5.2,1.9-4.8c0.6,0.6-1.9,9.4-2.6,9.4C187.8,248,187.9,246.8,188.9,243.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M225.3,246.9c-0.4-1.8-0.4-2.4,0.4-2.4c0.4,0,0.8,0.7,0.9,1.8C226.8,248.2,225.8,248.8,225.3,246.9 L225.3,246.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M292.9,247.6c-0.5-0.1-0.9-0.4-0.9-0.8c0-0.2,0.4-0.4,0.8-0.2c0.5,0.1,1.2,0.3,1.8,0.3c0.5,0,1,0.2,1,0.5 C295.5,248,294.5,248.1,292.9,247.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M323.7,245c1-1.4,1.9-2.9,2-3.5c0.2-0.6,0.6-1,1-1c0.6,0,0.6,0.2,0,1.8c-1,2.4-3.2,5.2-4.1,5.2 C322.2,247.5,322.5,246.6,323.7,245L323.7,245z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M225,242.4c0-1.2,0.6-2.9,1.1-2.9c0.2,0,0.4,0.8,0.4,1.8c0,1.2-0.2,1.8-0.8,1.8 C225.4,243,225,242.7,225,242.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M266.9,240.6c-2.2-2.4-4.4-11.6-2.7-11.6c0.5,0,0.8,1,1,3.3c0.2,2.1,0.8,4.1,1.6,5.7 C268.2,240.6,268.3,242.2,266.9,240.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M227.5,234.6c0-0.6,2.5-3.6,3.1-3.6c0.2,0-0.1,0.9-0.9,2C228.4,234.9,227.5,235.6,227.5,234.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M191.5,232.8c0-1.6,1.1-5.8,1.6-5.8c0.6,0,0.6,0.9-0.1,4C192.4,233.3,191.5,234.5,191.5,232.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M180.2,229.9c1.1-5.7,1.9-8.9,2.4-8.9c0.3,0,0.4,0.6,0.2,1.6c-1.1,5.6-1.9,8.9-2.4,8.9 C180.1,231.5,180,230.9,180.2,229.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M263,224.6c0-0.6-0.1-1.3-0.3-1.8c-0.2-0.5,0-0.8,0.5-0.8c0.4,0,0.9,0.5,1,1.1c0.5,1.8,0.4,2.4-0.5,2.4 C263.4,225.5,263,225.1,263,224.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M193.5,222.1c0-1.4,0.8-2.4,1.4-1.9c0.4,0.4-0.4,3.4-0.9,3.4C193.7,223.5,193.5,222.9,193.5,222.1 L193.5,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M194.2,217.2c0.4-2.4,0.9-3.6,1.5-3.1c0.5,0.5-0.5,5.1-1.1,5.3C194.1,219.5,194,219.1,194.2,217.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M184,214c0-1.2,1.7-6.5,2.1-6.5c0.6,0,0.5,0.6-0.4,4c-0.4,1.6-1,3-1.2,3C184.2,214.5,184,214.2,184,214 L184,214z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M195.5,209.1c0-1.4,0.8-2.4,1.4-1.9c0.4,0.4-0.4,3.4-0.9,3.4C195.7,210.5,195.5,209.9,195.5,209.1 L195.5,209.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M187.3,202.1c0.7-2.1,1.4-4.3,1.6-4.8c0.1-0.5,0.6-0.9,0.9-0.9c0.4,0,0.2,1.4-0.9,4.8 c-0.9,2.6-1.8,4.8-2.1,4.8C186.3,206,186.5,204.8,187.3,202.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M251.6,202.8c-3.4-3.5-3.1-4.8,0.4-1.5c1.7,1.6,2.6,2.8,2.5,3.4C254.3,205.4,253.7,205,251.6,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M196.6,195.8c0.1-4.1,0.2-5.2,0.7-5.2c0.6,0,0.7,1,0.7,4.1c0,4.4-0.4,6.4-1.1,6.4 C196.7,201,196.6,198.6,196.6,195.8L196.6,195.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M245,197.5c-0.7-0.5-1.1-1.1-0.9-1.2c0.4-0.4,3.4,1.2,3.4,1.9C247.5,198.8,246.3,198.5,245,197.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M238.6,194.2c-2.1-0.9-2.2-1.9-0.1-1.1c1.4,0.4,2.3,1.2,1.9,1.6C240.3,194.9,239.5,194.6,238.6,194.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M227.4,190.6c-1.4-0.2-2-1.1-0.8-1.1s2.9,0.6,2.9,1.1c0,0.2-0.1,0.4-0.4,0.4 C228.9,190.9,228.1,190.8,227.4,190.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M203.2,187.5c-0.8-0.4-0.6-0.4,0.9-0.4c1-0.1,1.9,0.2,1.9,0.4C206,188.1,204.6,188.1,203.2,187.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M207,187.5c0-0.6,1.4-0.6,2.8,0c0.8,0.4,0.6,0.4-0.9,0.4C207.8,188,207,187.8,207,187.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M188.4,172.9c-0.6-0.4-0.8-1.1-0.6-1.8c0.4-1.5,0.9-1.4,1.7,0.1C190.4,172.8,189.6,173.8,188.4,172.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M145.8,166c-0.8-0.4-0.6-0.4,1-0.4c1.1,0,2.4,0.2,3,0.4c0.8,0.4,0.6,0.4-1,0.4 C147.6,166.4,146.3,166.2,145.8,166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M170.5,165.6c-0.9-0.4-1.5-0.9-1.2-0.9c0.8-0.3,3.2,0.6,3.2,1.3C172.5,166.6,172.6,166.6,170.5,165.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M163.8,165.5c1.4-0.6,2.8-0.6,2.8,0c0,0.3-0.9,0.5-1.9,0.4C163.1,165.9,162.9,165.8,163.8,165.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M135.3,164.4c-1.1-0.4-2.1-0.9-2.1-1.2c-0.2-0.6,4.9,0.8,5.6,1.5C139.4,165.2,137.5,165,135.3,164.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M126.2,161c-1.2-0.5-2.2-1.2-2.2-1.5s0.2-0.4,0.4-0.4c0.2,0.1,1.2,0.6,2.2,1.1c1,0.4,1.8,1.1,1.8,1.3 C128.5,162.1,128.6,162.1,126.2,161z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M113.3,152.6c-1.1-1.1-1.8-2.3-1.7-2.7c0.1-0.5,1,0.1,2.8,1.9c2.1,2.1,2.4,2.7,1.8,2.7 C115.7,154.5,114.4,153.6,113.3,152.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M195.9,150.2c1.9-2.1,3.4-3.5,3.6-3.2c0.2,0.6-1.6,2.9-2.2,3c-0.4,0-0.6,0.3-0.6,0.6c0,0.9-2.6,3.4-3.4,3.4 C192.7,154,194,152.3,195.9,150.2L195.9,150.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M106.8,143.4c-0.4-1.1-0.5-1.7-0.2-1.9c0.7-0.2,1.9,1.4,1.9,2.6C108.5,145.5,107.5,145.1,106.8,143.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M105.2,137.7c-0.8-3.9,0.7-11.7,2.1-11.7c0.6,0,0.6,0.3,0.2,1.4c-0.9,2.5-1.4,6.5-1,9.3 c0.3,2.1,0.2,2.8-0.2,2.8C105.8,139.5,105.4,138.7,105.2,137.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M202.5,134.5c0-1.1,0.2-2,0.4-2c0.6,0,1,1.8,0.7,3C203.2,137.2,202.5,136.6,202.5,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M200.3,124.9c-1.6-3-1.5-2.9-0.6-2.9c0.8,0,2.7,3.5,2.8,4.9C202.5,128.2,201.5,127.3,200.3,124.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M111.5,118.9c0-0.9,5.4-6.1,5.9-5.7c0.2,0.2-1.1,1.7-2.8,3.3C112.8,118.4,111.5,119.3,111.5,118.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M192,114.6c-1.6-1.3-1.6-1.5-0.7-1.6c1.1,0,2.9,1.7,2.6,2.5C193.8,115.8,193,115.3,192,114.6L192,114.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M187.5,111.4c-1.2-0.8-2.6-1.7-3-1.9s-0.6-0.6-0.4-0.8c0.4-0.4,5.4,2.2,5.8,3.2 C190.3,113,189.9,112.9,187.5,111.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M123,109.6c0-0.2,0.8-0.8,1.8-1.2c2.1-1,2.3-0.4,0.3,0.8C123.5,110.1,123,110.2,123,109.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M127.5,107.5c0-0.2,0.7-0.7,1.6-0.9c1.9-0.7,2.1-0.7,1.8-0.1C130.4,107.1,127.5,108.1,127.5,107.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M175.1,105.8c-1.9-0.7-2.6-1.3-1.6-1.3s4.1,1,4.6,1.6C178.9,106.7,177.1,106.5,175.1,105.8L175.1,105.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M168.4,104.2c-1.4-0.2-2-1.2-0.8-1.2s2.9,0.6,2.9,1.1c0,0.2-0.1,0.4-0.4,0.4 C169.9,104.4,169.1,104.3,168.4,104.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M147,102.5c0-0.2,0.9-0.5,1.9-0.4c1.5,0,1.6,0.1,0.9,0.4C148.4,103.1,147,103.1,147,102.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M158.2,102.5c-0.8-0.3-0.4-0.4,1.2-0.4c1.2,0,2.7,0.2,3.2,0.4c0.8,0.3,0.4,0.4-1.2,0.4 C160.2,102.9,158.8,102.8,158.2,102.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M321,285c0-0.2-0.5-1-1-1.5c-1-1-1.4-4-0.5-4c0.2,0,0.7,1,1,2.2c0.8,3,1.5,3.6,3.2,2.3 c1.8-1.5,2.9-1.2,1.2,0.2C323.5,285.5,321,286,321,285L321,285z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M217.2,284.5c-0.7-0.3,0-0.5,2.2-0.5s2.9,0.1,2.2,0.5c-0.6,0.2-1.6,0.5-2.2,0.5S217.8,284.8,217.2,284.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M210.4,284.1c-0.5-0.1-0.9-0.4-0.9-0.6c0-0.4,5.4,0.2,5.9,0.6C215.7,284.5,211.7,284.5,210.4,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M225,284c0-0.3,0.4-0.5,0.9-0.5s1.7-0.1,2.6-0.3c1.1-0.2,1.6-0.1,1.2,0.2C229,284.2,225,284.7,225,284 L225,284z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M206.9,283.6c-1.4-0.2-2-1.1-0.8-1.1s2.9,0.6,2.9,1c0,0.2-0.1,0.4-0.4,0.4 C208.4,283.9,207.6,283.7,206.9,283.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M200.9,282.1c-1.6-0.5-2.9-1-2.9-1.2s0.5-0.4,1.1-0.2c0.6,0.1,2.1,0.5,3.5,0.9c1.3,0.3,2.4,0.8,2.4,1 C205,283.1,204.4,283,200.9,282.1L200.9,282.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M325.5,282.2c0-0.6,1.7-3.2,2.1-3.2c0.6,0,0.5,1-0.4,2.2C326.5,282.4,325.5,282.9,325.5,282.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M195.1,280.4c-0.9-0.2-1.6-0.8-1.6-1.1c0-0.5,0.4-0.5,1.5-0.1c1.4,0.5,2.4,1.3,1.9,1.6 C196.8,280.8,196,280.6,195.1,280.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M236.5,280.8c0-0.4,4.1-2.4,4.4-2c0.4,0.3-2.9,2.3-3.7,2.3C236.8,281,236.5,280.9,236.5,280.8L236.5,280.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M189.6,278.2c-2.1-0.9-2.2-1.9-0.1-1.1c1.4,0.5,2.3,1.2,1.9,1.6C191.3,278.9,190.5,278.6,189.6,278.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M318.8,277.9c-0.5-1.8-0.4-4.9,0.1-4.9c0.6,0,1,1.8,1,4.1C320,279.2,319.3,279.6,318.8,277.9L318.8,277.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M328.6,275.5c0.6-1.6,1.4-3,1.7-3c0.4,0,0.3,0.9-0.5,3c-0.6,1.6-1.4,3-1.7,3 C327.7,278.5,327.9,277.6,328.6,275.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M249.4,271.1c2.3-3.1,4.5-5.4,4.6-4.6c0,0.5-1.1,2-2.3,3.4C249.2,272.6,247.7,273.4,249.4,271.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M318,269.7c-0.6-1.7-0.6-2.2,0.2-2.2c0.6,0,1.3,1.4,1.3,2.9C319.5,271.5,318.5,271,318,269.7L318,269.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M175.5,268.2c0-2,0.7-2.4,1.2-0.6c0.4,1.8,0.4,2.4-0.4,2.4C175.8,270,175.5,269.5,175.5,268.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M180.5,268.8c0-0.7,1.6-3.2,2-3.2c0.7,0-0.6,3.1-1.4,3.4C180.8,269,180.5,268.9,180.5,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M314.4,263.6c-1.5-1.5-1-2.2,0.6-1.1c0.9,0.6,1.5,1.3,1.5,1.5C316.5,264.8,315.2,264.5,314.4,263.6 L314.4,263.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M332.5,263.4c0-1.4,0.8-2.8,1.2-2.3s-0.2,3.4-0.8,3.4C332.7,264.5,332.5,264,332.5,263.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M175.5,260.9c0-1.7,0.6-3.4,1.1-3.4c0.2,0,0.4,0.5,0.4,1.1c0,1.6-0.6,3.4-1.1,3.4 C175.7,262,175.5,261.5,175.5,260.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M309.4,260.9c-1-0.3-1.9-0.7-1.9-1c0-0.2,0.4-0.4,0.9-0.2c0.5,0.1,1.5,0.4,2.2,0.6c0.8,0.1,1.4,0.5,1.4,0.8 C312,261.5,311.9,261.5,309.4,260.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M303.4,259.6c-1.4-0.2-2-1.1-0.8-1.1s2.9,0.6,2.9,1c0,0.2-0.1,0.4-0.4,0.4 C304.9,259.9,304.1,259.7,303.4,259.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M333.7,257.4c0.5-3.8,0.9-4.9,1.4-4.9c0.4,0,0.4,0.9,0.2,2.6c-0.5,3.7-0.9,4.9-1.4,4.9 C333.6,260,333.5,259,333.7,257.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M298.9,258.6c-0.5-0.1-0.9-0.5-0.9-0.8c0-0.2,0.4-0.4,0.8-0.2c0.5,0.1,1.2,0.3,1.8,0.3c0.5,0,1,0.2,1,0.5 C301.5,259,300.5,259,298.9,258.6L298.9,258.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M291.8,257.1c-1.3-0.3-2.2-1.1-1.2-1.1c1.3,0,3,0.6,3,1C293.5,257.5,293.4,257.5,291.8,257.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M176,255.6c0-1.4,0.8-2.4,1.4-1.9c0.4,0.4-0.4,3.3-0.9,3.3C176.2,257,176,256.4,176,255.6L176,255.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M185.5,256c0-1.5,1.8-6.5,2.2-6.5s0.4,0.9-0.4,3.5c-0.6,1.9-1.2,3.5-1.4,3.5 C185.7,256.5,185.5,256.2,185.5,256L185.5,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M279.6,254.6c-0.6-0.1-1.1-0.4-1.1-0.8s0.6-0.4,1.5-0.2c0.9,0.1,1.8,0.3,2,0.3s0.5,0.2,0.5,0.5 C282.5,255,281.7,255.1,279.6,254.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M272.8,253.1c-1.3-0.3-2.2-1.1-1.2-1.1c1.3,0,3,0.6,3,1.1S274.4,253.6,272.8,253.1L272.8,253.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M226.6,250.8c-0.6-1.2-1.1-2.6-1.1-3c0-1.2,1-0.9,1.5,0.6c0.3,0.8,0.9,1.9,1.2,2.6c0.6,1.2,0.6,1.9-0.3,1.9 C227.8,253,227.1,252,226.6,250.8L226.6,250.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M266,252c0-0.2,0.8-0.5,1.8-0.5s1.8,0.2,1.8,0.5s-0.8,0.5-1.8,0.5S266,252.3,266,252z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M314.5,251.3c0.1-0.1,1.2-0.5,2.6-0.9c2.5-0.9,3.2-0.4,1.1,0.6C317.1,251.5,314,251.8,314.5,251.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M212.5,249.4c0,0.2,0,0.3,0.1,0.5c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0c0-0.1-0.1-0.2-0.1-0.4 c-0.1-0.4,0.1-0.9,0.4-1.2C212.5,248.5,212.5,249,212.5,249.4C212.5,249.4,212.5,249.4,212.5,249.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M213,250.1c0,0.1,0,0.2,0,0.3c-0.1,0-0.1-0.1-0.1-0.1c-0.1,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.2 c0,0,0,0,0,0c0,0,0,0,0-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0,0,0,0,0,0C213,249.9,213,250,213,250.1L213,250.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M213.2,249.3C213.2,249.3,213.2,249.3,213.2,249.3C213.2,249.3,213.2,249.3,213.2,249.3 C213.2,249.3,213.2,249.3,213.2,249.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M215.1,249.9C215.1,249.9,215.1,249.9,215.1,249.9C215.1,250,215.1,250,215.1,249.9 C215.1,249.9,215.1,249.9,215.1,249.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M215.5,249.4c0,0.1,0,0.2-0.1,0.2c0,0,0,0.1-0.1,0.1l0,0c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0v-0.1c0-0.1,0-0.2,0-0.2c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1v0c-0.1-0.2-0.2-0.4-0.3-0.6 c-0.2-0.2-0.4-0.4-0.6-0.5c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.2,0-0.3,0-0.5,0c-0.1,0-0.1,0-0.2,0l0,0c0,0,0,0,0,0 c0,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c-0.1,0-0.2,0.1-0.3,0.2c0.1-0.1,0.1-0.1,0.2-0.2 c0,0,0.1-0.1,0.2-0.1c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.2-0.1,0.3-0.1c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.4,0 c0,0,0,0,0,0c0.1,0,0.3,0.1,0.4,0.1h0c0.3,0.1,0.5,0.4,0.6,0.6c0,0,0,0,0,0C215.5,248.8,215.6,249.1,215.5,249.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M297.4,248.6c-1.4-0.2-2-1.1-0.8-1.1s2.9,0.6,2.9,1.1c0,0.2-0.1,0.4-0.4,0.4 C298.9,248.9,298.1,248.8,297.4,248.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M335.1,243.5c0-4.4,0.5-5.7,1.1-3.4c0.6,2.5,0.2,7.9-0.7,7.9C335.2,248,335.1,246,335.1,243.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M289.4,246.9c-1-0.3-1.9-0.7-1.9-1c0-0.2,0.4-0.4,0.9-0.2c0.5,0.1,1.7,0.4,2.8,0.6c1,0.1,1.9,0.5,1.9,0.8 C293,247.6,291.9,247.6,289.4,246.9L289.4,246.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M281.9,245.4c-1.4-0.3-2.4-0.8-2.4-1s0.7-0.4,1.6-0.1c0.9,0.2,2.4,0.5,3.2,0.6c0.9,0.1,1.6,0.5,1.6,0.7 C286,246.1,285,246.1,281.9,245.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M177.5,244.9c0-1.2,2.4-13.9,2.8-14.2c0.8-0.8,0.7,0.9-0.2,6.2c-1.4,8.1-1.5,8.7-2.1,8.7 C177.7,245.5,177.5,245.2,177.5,244.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M225.1,243.4c0.2-2.9,1.4-3.1,1.4-0.2c0,1.8-0.2,2.3-0.8,2.3S225,245.1,225.1,243.4L225.1,243.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M273.8,243.6c-1.9-0.4-3.5-1.1-3.6-1.4c-0.1-0.3,1.1-0.2,3.2,0.4c1.9,0.5,3.9,0.9,4.5,0.9 c0.6,0.1,1.1,0.3,1.1,0.6C279,244.7,277.9,244.6,273.8,243.6L273.8,243.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M189.2,242.4c0.1-0.9,0.4-1.7,0.6-1.8c0.6-0.6,0.8,0.4,0.5,1.9C189.8,244.6,188.8,244.5,189.2,242.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M190,239.5c0-1.4,1.1-5.5,1.6-5.5c0.6,0,0.6,0.4-0.1,3.5c-0.3,1.4-0.8,2.5-1,2.5S190,239.8,190,239.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M334.9,238.1c-0.2-0.1-0.4-0.8-0.4-1.4c0-2.3-2.2-3.6-3.5-2.1c-0.4,0.4-1,0.8-1.5,0.8 c-1-0.1,1.6-2.5,2.8-2.5c1.9,0,3.7,2.4,3.7,4.8C336,238.5,335.4,238.7,334.9,238.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M263.8,230.9c-0.5-1.8-0.4-2.4,0.5-2.4c0.5,0,0.8,0.6,0.8,1.8C265,232.2,264.3,232.6,263.8,230.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M232.1,229.2c0.8-0.7,1.6-1.2,2-1.2c0.4,0.1-0.1,0.6-0.9,1.2C231.3,230.9,230.4,230.9,232.1,229.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M262.8,223.2c-0.8-3.6-0.8-4.9,0.2-3.9c0.5,0.5,1.5,5.1,1.5,6.7C264.5,228.3,263.5,226.8,262.8,223.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M220,224.2c0-1,0.2-1.3,0.9-1.1c0.4,0.1,0.9,0.6,0.9,1.1c0,0.6-0.4,1.1-0.9,1.1 C220.2,225.5,220,225.2,220,224.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M182,221.9c0-1.2,1.1-4.9,1.6-4.9c0.6,0,0.6-0.1-0.1,3c-0.3,1.4-0.8,2.5-1,2.5S182,222.2,182,221.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M193.7,220.6c0.6-2.9,0.8-3.6,1.4-3.6c0.5,0,0.3,2.3-0.4,4.6C194.2,223.3,193.4,222.5,193.7,220.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M194.7,214.6c0.7-3.9,0.9-4.6,1.4-4.6s0.2,4.1-0.4,5.8C195.1,217.3,194.4,216.5,194.7,214.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M184.2,212.9c0.4-1.9,0.6-2.2,1.1-1.8s-0.3,3.4-0.9,3.4C184.1,214.5,184.1,213.9,184.2,212.9L184.2,212.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M259.2,213c-0.9-1.8-1-2-0.1-2c0.6,0,1.9,2,1.9,3S260,214.4,259.2,213z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M195.5,208.9c0-1.2,0.6-2.9,1.1-2.9s0.6,1.6,0.1,2.7C196.3,209.6,195.5,209.8,195.5,208.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M252.1,203.2c-1.5-1.5-2.6-2.9-2.5-3.2c0.3-0.9,5.6,4.2,5.4,5.1C254.8,205.7,254.1,205.2,252.1,203.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M196,204.9c0-1.3,0.6-2.9,1.1-2.9c0.7,0,0.2,3.1-0.4,3.4C196.3,205.5,196,205.3,196,204.9L196,204.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M196.5,198.6c0-2.4,0.4-4.1,1.1-4.1c0.5,0,0.6,3.1,0.1,4.9C197.2,201.1,196.5,200.7,196.5,198.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M238.1,194c-1.2-0.6-3.8-1.5-5.8-2.1c-3.5-1.1-5.2-1.9-3.8-1.9c0.9,0,7.6,2.1,10.1,3.2 c1,0.4,1.9,1.1,1.9,1.3C240.5,195.1,240.6,195.1,238.1,194z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M190.9,192.6c0.7-1.9,2.8-5.2,3.6-5.6c1.4-0.8,1.6-0.6,0.5,0.5c-0.5,0.5-1.6,2.1-2.2,3.5 C191.6,193.4,190.1,194.6,190.9,192.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M196.8,192.4c-0.4-1.8-0.4-2.4,0.4-2.4c0.5,0,0.8,0.6,0.8,1.8C198,193.7,197.3,194.1,196.8,192.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M224.1,189.9c-1.2-0.2-2.1-0.6-2.1-0.9c0-0.2,0.9-0.2,2.1,0c1.1,0.2,2.2,0.4,2.5,0.4c0.2,0,0.4,0.2,0.4,0.5 C227,190.5,227,190.5,224.1,189.9L224.1,189.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M216.1,188.7c-4.6-0.6-6.6-1.2-3.8-1.2c2.2,0.1,8.2,0.9,8.6,1.2C221.5,189.3,220.7,189.3,216.1,188.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M203.8,187.5c-0.8-0.4-0.6-0.4,0.9-0.4c1-0.1,1.9,0.2,1.9,0.4C206.5,188.1,205.1,188.1,203.8,187.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M197,187c0-0.6,1.9-0.6,3.2,0c0.8,0.4,0.5,0.4-1.1,0.4C197.9,187.5,197,187.3,197,187z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M183.8,171.1c-2.5-1-4.6-2.1-4.7-2.4c-0.1-0.4,1.7,0.2,3.9,1.1c4.6,1.9,5.2,2.1,4.8,1 c-0.1-0.4,0-0.8,0.4-0.8c0.7,0,1.3,1.1,1.3,2.3C189.5,173.3,188.8,173.2,183.8,171.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M185.7,166.2c-1.1-2.8-1.5-4.9-0.7-4.6c0.6,0.2,2.4,4.3,2.4,5.8C187.6,168.6,186.4,167.9,185.7,166.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M146.8,166c-0.4-0.6,1.1-0.6,2.5,0c0.9,0.4,0.8,0.4-0.6,0.4C147.8,166.5,146.9,166.3,146.8,166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M160.8,166.1c2.4-0.8,7.2-1.4,7.2-1c0,0.5-1.7,0.9-5.5,1.1C160.1,166.4,159.6,166.3,160.8,166.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M132.6,163.5c-0.6-0.2-1.1-0.6-1.1-0.8c0-0.6,1.9-0.2,2.8,0.5C135.4,164.1,134.5,164.2,132.6,163.5 L132.6,163.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M129.1,162.2c-0.9-0.4-1.7-0.9-1.7-1.2c0-0.6,2.3,0.2,3.2,1.1C131.6,162.9,130.8,162.9,129.1,162.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M184.5,160c0-0.6,0.6-1.3,1.5-1.8c1.6-0.9,2.1-0.4,0.5,0.6c-0.6,0.4-1,0.9-1,1.4c0,0.4-0.2,0.8-0.5,0.8 C184.8,161,184.5,160.6,184.5,160z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M122.2,158.9c-2.3-1.3-3.3-2.4-2.3-2.4c0.6,0,5.7,3.2,5.7,3.6C125.5,160.8,124.8,160.6,122.2,158.9 L122.2,158.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M190.2,155.7c0.9-0.7,3-2.8,4.9-4.6c1.9-1.9,3.5-3.2,3.6-3.1c0.4,0.4-3.4,4.6-6.4,6.8 C189.5,157.1,187.8,157.8,190.2,155.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M110.4,149.4c-3.1-4.1-3.4-4.9-2.2-4.9c0.9,0,4.3,5.2,3.8,6C111.8,150.9,111.2,150.6,110.4,149.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M105.6,140.1c-0.2-0.5-0.3-3.1-0.3-5.9c0-3.9,0.2-5.6,1.1-7.7c1.3-3.3,4.1-7.6,5-7.6c0.3,0-0.2,1.1-1.2,2.7 c-2.8,4.1-3.9,8-3.9,12.6c0.1,2.2,0.3,4.6,0.6,5.4c0.4,1.1,0.4,1.4-0.2,1.4C106.3,141,105.8,140.6,105.6,140.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M202.1,139c0.6-2,1.4-2.8,1.4-1.1c0,1.6-0.6,3.1-1.2,3.1C201.8,141,201.7,140.6,202.1,139z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M202.2,130.4c-0.4-1.6-0.1-2.2,0.7-1.7c0.6,0.4,0.8,3.2,0.1,3.2C202.8,132,202.4,131.3,202.2,130.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M197.9,121c-1.4-2.1-2.1-3.5-1.7-3.5c0.9,0,2.4,1.6,2.4,2.7c0,0.4,0.3,0.8,0.6,0.8c0.4,0,1,0.7,1.5,1.4 c1,1.8,1.1,2.1,0.2,2.1C200.6,124.4,199.2,122.9,197.9,121z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M187.4,111.2c-1.2-0.7-1.9-1.7-1.1-1.7c0.6,0,3.2,1.7,3.2,2.1C189.5,112.2,188.9,112,187.4,111.2 L187.4,111.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M121.5,110.6c0-0.6,6.1-3.7,6.4-3.2c0.1,0.2,0,0.4-0.3,0.6s-1.8,0.9-3.3,1.7 C122.8,110.4,121.5,110.8,121.5,110.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M181.1,107.9c-1.2-0.5-2.1-1.2-2.1-1.4c0-0.5,3.4,0.7,4.2,1.5C184.1,108.9,183.2,108.8,181.1,107.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M129.5,106.8c0-0.3,3.1-1.8,3.8-1.8c0.8,0,0.1,0.9-0.9,1.2c-0.6,0.2-1.6,0.4-2,0.6S129.5,106.9,129.5,106.8z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M170.9,104.7c-1.5-0.4-1-1.2,0.5-0.8c1.7,0.4,2.6,1.2,1.4,1.2C172.2,104.9,171.4,104.8,170.9,104.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M137.6,104.1c0.4-0.3,2.9-0.8,5.5-1.3c5.4-0.8,5.4-0.8,5.4-0.3c0,0.2-1.9,0.7-4.4,1 c-2.4,0.3-5.1,0.8-5.9,0.9C137.1,104.5,136.9,104.5,137.6,104.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M166.2,103.5c-0.9-0.3-0.8-0.4,0.6-0.4c0.9-0.1,1.8,0.2,1.9,0.4C169.1,104.1,167.6,104.1,166.2,103.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M158.8,102.5c-0.8-0.3-0.6-0.4,0.9-0.4c1-0.1,1.9,0.2,1.9,0.4C161.5,103.1,160.1,103.1,158.8,102.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M319.7,283.2c-0.8-2-0.9-3.2-0.2-3.2c0.3,0,0.5,0.3,0.5,0.6s0.5,1.5,1,2.5c0.8,1.5,0.8,1.9,0.2,1.9 C320.8,285,320.1,284.2,319.7,283.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M211.5,284c0-0.6,1.4-0.6,2.8,0c0.8,0.4,0.6,0.5-0.9,0.5C212.3,284.5,211.5,284.3,211.5,284z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M224.2,284c1.4-0.6,2.9-0.6,2.5,0c-0.1,0.3-1.1,0.5-1.9,0.5C223.5,284.5,223.4,284.4,224.2,284z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M202.7,282.5c-5.6-1.5-9.6-2.8-10.4-3.6c-0.9-0.8,0.5-0.5,6.6,1.5c3.2,1.1,7,2.1,8.4,2.3 c1.3,0.2,2.5,0.5,2.6,0.8C210.2,284.3,208.6,284,202.7,282.5L202.7,282.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M326.5,280.8c0-0.8,3.1-6.8,3.5-6.8c0.5,0-0.9,3.9-2,6C327.6,280.8,326.5,281.4,326.5,280.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M240,279.1c0-0.2,1.1-1.1,2.4-2c1.3-0.9,3.1-2.2,4-3s1.6-1.1,1.6-0.8c0,0.6-3.6,3.6-6.2,5.1 C240.8,279.1,240,279.4,240,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M186.6,277c-1.2-0.5-2.1-1.1-2.1-1.4c0-0.5,3.4,0.7,4.2,1.5C189.6,277.9,188.8,277.9,186.6,277z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M318.9,275.4c-0.3-2.4-0.1-3.4,0.4-2.9c0.4,0.5,0.8,5.5,0.4,5.5C319.4,278,319,276.9,318.9,275.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M181.6,274.8c-0.9-0.4-1.6-1-1.6-1.2c0-0.3,0.8-0.1,1.8,0.3c0.9,0.5,1.8,1,1.8,1.2 C183.5,275.6,183.6,275.6,181.6,274.8L181.6,274.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M249.6,271.1c0.4-0.5,1.6-2,2.7-3.4c1.1-1.4,2.1-2.6,2.1-2.7c0.1,0,0.4,0,0.6,0c0.6,0.2-4.8,6.9-5.6,6.9 C249.1,272,249.1,271.7,249.6,271.1L249.6,271.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M318,269.9c-0.4-1.2-1.2-3-1.9-4c-0.9-1.5-1-1.9-0.5-1.9c1.4,0,3.8,4.6,3.8,7 C319.5,272.8,318.6,272,318,269.9L318,269.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M175.8,270.4c-0.4-1.7-0.4-3.4,0.1-3.4s1.1,1.7,1.1,3.4c0,0.6-0.2,1.1-0.4,1.1S176,271,175.8,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M180.9,268c0.4-0.8,1.1-1.5,1.2-1.5c0.2,0,0.1,0.7-0.4,1.5c-0.4,0.9-1,1.5-1.3,1.5 C180.2,269.5,180.3,268.9,180.9,268L180.9,268z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M332.2,264.9c0.4-1.7,0.6-2.2,1-1.8c0.5,0.4-0.4,3.4-0.9,3.4C332.1,266.5,332,265.9,332.2,264.9L332.2,264.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M311.5,261.5c-1.4-0.8-1.5-1-0.7-1c1,0,3.1,1.2,2.7,1.6C313.4,262.3,312.5,262,311.5,261.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M175.8,259.9c0.4-2.3,0.6-2.8,1-2.3s-0.4,4.4-0.9,4.4C175.6,262,175.5,261.1,175.8,259.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M333,261.6c0-0.2,0.4-2.1,0.8-4.3s0.8-4.1,0.8-4.1c0-0.1,0.2-0.2,0.5-0.2c0.4,0,0.5,0.6,0.2,1.9 c-0.9,5.1-1.4,7.1-1.9,7.1C333.2,262,333,261.9,333,261.6L333,261.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M257,261.1c0-1,4.2-6.6,5.9-7.8c2.1-1.4,6.1-2.3,6.1-1.4c0,0.4-0.2,0.5-0.4,0.4c-0.9-0.5-4.1,0.8-5.9,2.3 c-1,0.9-2.5,2.8-3.4,4.2C257.9,261.3,257,262.2,257,261.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M184.6,258.4c0.9-3.7,3.1-10.4,3.5-10.4c0.6,0,0.3,1.1-1.5,7.1c-0.8,2.4-1.6,4.4-1.8,4.4 S184.5,259,184.6,258.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M298.5,258.5c-1-0.2-3-0.6-4.6-1c-1.6-0.3-2.9-0.8-2.9-1c0-0.4,9,1.2,9.4,1.7 C300.9,258.8,300.2,258.9,298.5,258.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M286.1,255.9c-1.2-0.2-2.1-0.6-2.1-0.9c0-0.4,4,0.3,4.5,0.8C289,256.2,288.2,256.3,286.1,255.9L286.1,255.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M275.4,253.6c-0.5-0.1-0.9-0.4-0.9-0.6c0-0.5,3-0.1,3.3,0.5C278,254,276.9,254,275.4,253.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M227.6,252.4c-0.6-0.6-0.8-1.9-0.2-1.9c0.2,0,0.6,0.4,0.9,1C229.1,252.6,228.5,253.2,227.6,252.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M176.5,251.6c0-1.1,2-12.3,2.2-12.6c0.8-0.8,0.8,0.8-0.2,6.2c-0.6,3.2-1,6.1-1,6.4c0,0.2-0.2,0.4-0.5,0.4 C176.8,252,176.5,251.9,176.5,251.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M213.2,249.3C213.2,249.3,213.2,249.3,213.2,249.3C213.2,249.3,213.2,249.3,213.2,249.3 C213.2,249.3,213.2,249.3,213.2,249.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M213.7,250.8C213.7,250.8,213.7,250.8,213.7,250.8C213.8,250.8,213.7,250.8,213.7,250.8 C213.7,250.8,213.7,250.8,213.7,250.8c-0.1,0-0.1,0-0.1,0c-0.1,0-0.3-0.1-0.5-0.2c0,0,0,0,0,0v0c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0 c0,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0 c0.1-0.1,0.2-0.1,0.4-0.1c0,0,0,0,0,0c0,0.1,0,0.2,0,0.3v0c0,0.1,0,0.2,0,0.3c0,0,0,0,0.1,0.1c0.1,0.1,0.3,0.2,0.4,0.3 C213.6,250.8,213.6,250.8,213.7,250.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M214,250.5C214,250.5,214,250.5,214,250.5c0,0,0.1,0,0.1,0c0,0,0,0,0,0C214.1,250.5,214.1,250.5,214,250.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M214.3,247.8c-0.2,0-0.3,0-0.5,0c-0.1,0-0.1,0-0.2,0l0,0c0,0,0,0,0,0c0,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0 c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1h0 c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0 c0,0,0.1,0,0.1,0C214,247.7,214.1,247.7,214.3,247.8C214.2,247.7,214.3,247.8,214.3,247.8C214.3,247.8,214.3,247.8,214.3,247.8 C214.3,247.8,214.3,247.8,214.3,247.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M214.6,250.6C214.6,250.6,214.6,250.6,214.6,250.6c0,0.1-0.2,0.1-0.3,0.2c-0.2,0.1-0.3,0.1-0.5,0 c0.1,0,0.2-0.1,0.4-0.1C214.4,250.7,214.5,250.6,214.6,250.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M215.1,250C215.1,250,215.1,250,215.1,250C215.1,250,215.1,250,215.1,250C215.1,249.9,215.1,249.9,215.1,250 C215.1,249.9,215.1,249.9,215.1,250z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M215.3,249.5C215.4,249.4,215.4,249.4,215.3,249.5C215.4,249.5,215.4,249.5,215.3,249.5 C215.4,249.5,215.4,249.5,215.3,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M215.4,249.4L215.4,249.4c0-0.1,0-0.2,0-0.3c0,0,0,0,0,0C215.4,249.2,215.4,249.3,215.4,249.4 C215.4,249.4,215.4,249.4,215.4,249.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M307.4,250.6c-0.5-0.1-0.9-0.4-0.9-0.6c0-0.5,3-0.1,3.3,0.5C310,251,308.9,251,307.4,250.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M302.5,249.6c-0.7-0.1-1.5-0.4-1.8-0.7c-0.4-0.4,0-0.4,1.2-0.2C304.5,249.2,305,250,302.5,249.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M293.9,247.8c-2.2-0.5-3.7-1.3-2.5-1.3s5.9,1.1,6.4,1.6C298.4,248.7,296.9,248.6,293.9,247.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M322.5,247.5c0-1.1,1.7-3.1,2.4-2.9c0.4,0.1,0,0.9-0.9,1.9S322.5,247.9,322.5,247.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M335.2,243.8c0-3.9,0.5-4.9,1-2.2c0.4,1.6-0.1,6-0.7,6C335.3,247.5,335.2,245.8,335.2,243.8L335.2,243.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M225.3,245.7c-0.4-1.1-0.4-2.7,0.1-2.7c0.4,0,1.1,1.6,1.1,2.9C226.5,246.8,225.6,246.6,225.3,245.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M285.8,246.1c-1.3-0.3-2.2-1.1-1.2-1.1c1.3,0,3,0.6,3,1.1S287.4,246.6,285.8,246.1L285.8,246.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M188.5,245.1c0-0.9,1.1-3.2,1.3-2.9c0.4,0.4-0.3,3.4-0.9,3.4C188.7,245.5,188.5,245.3,188.5,245.1 L188.5,245.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M274,243.6c-0.7-0.1-1.5-0.4-1.8-0.7c-0.4-0.4,0-0.4,1.2-0.2C276,243.2,276.5,244,274,243.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M325,243.2c0-0.8,3.7-7.3,4.8-8.4c1.7-1.9,2.1-1.2,0.5,0.9c-0.7,0.9-2,3.1-2.8,4.8c-0.9,1.7-1.8,3.1-2,3.1 C325.2,243.5,325,243.4,325,243.2L325,243.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M269.1,242.1c-1.8-0.9-3.6-3.1-2.5-3.1c0.8,0.1,4.6,3.4,4.4,3.7C270.9,242.8,270,242.6,269.1,242.1 L269.1,242.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M189.5,241.2c0-1.1,1.2-4.7,1.6-4.7c0.6,0,0.6,0.1-0.1,2.8c-0.3,1.2-0.8,2.2-1,2.2S189.5,241.4,189.5,241.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M179.2,235.4c0.4-1.7,0.6-2.2,1.1-1.8c0.4,0.4-0.4,3.4-0.9,3.4C179.1,237,179,236.3,179.2,235.4L179.2,235.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M264.2,234.9c-0.3-1.4,0-2.4,0.5-1.9c0.1,0.1,0.4,0.9,0.5,1.8C265.7,237,264.7,237,264.2,234.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M191.2,234c0.1-0.8,0.4-2.1,0.6-3c0.1-0.8,0.5-1.5,0.8-1.5c0.6,0,0.6,0.4-0.1,3.5 C191.9,235.6,190.7,236.6,191.2,234z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M263.8,229.4c-0.4-1.7,0-2.6,0.8-1.4c0.6,0.9,0.6,3,0,3C264.3,231,263.9,230.3,263.8,229.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M193.2,224.4c0.1-0.9,0.4-1.7,0.6-1.8c0.6-0.6,0.8,0.4,0.5,1.9C193.8,226.6,192.8,226.5,193.2,224.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M218.7,225.2c-0.5-1.2,0.2-2.2,1.5-2.2c0.6,0,1.3,0.4,1.5,0.8c0.4,1.2-0.2,2.2-1.5,2.2 C219.5,226,218.8,225.6,218.7,225.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M263,223.9c-1-4.4-2.5-8.9-3.8-11.1c-1-1.9-1.1-2.3-0.5-2.3c1,0,3.5,5.2,4.7,10.2c1.1,4.6,1.2,5.2,0.5,5.2 C263.8,226,263.3,225,263,223.9L263,223.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M181.8,222.6c0.4-1.6,1.2-2.8,1.2-1.6c0,1.3-0.6,2.9-1.1,2.9C181.7,224,181.6,223.4,181.8,222.6L181.8,222.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M182.7,219.1c0.1-0.5,0.5-2,0.9-3.4c0.6-2.4,1.4-4.1,1.4-2.9c0,1.5-1.6,7.1-2.1,7.1 C182.6,220,182.5,219.6,182.7,219.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M195.2,212.4c0.1-0.9,0.4-1.7,0.6-1.8c0.6-0.6,0.8,0.4,0.5,1.9C195.8,214.6,194.8,214.5,195.2,212.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M195.7,208.4c0.4-1.7,0.6-2.2,1.1-1.8c0.4,0.4-0.4,3.4-0.9,3.4C195.6,210,195.5,209.3,195.7,208.4 L195.7,208.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M256.2,207.9c-0.5-0.9-2.5-3.1-4.4-5s-3.1-3.4-2.8-3.4c0.9,0,5.9,4.5,5.6,5.1c-0.1,0.2-0.1,0.4,0.2,0.4 c0.5-0.1,3.6,3.4,3.6,4.1C258.5,210.1,257.1,209.4,256.2,207.9L256.2,207.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M185.5,208.6c0-0.9,1.1-3.2,1.3-2.9c0.4,0.4-0.3,3.4-0.9,3.4C185.7,209,185.5,208.8,185.5,208.6L185.5,208.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M196.2,204.4c0.1-0.9,0.4-1.7,0.6-1.8c0.6-0.6,0.8,0.4,0.5,1.9C196.8,206.6,195.8,206.5,196.2,204.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M196.6,197.7c0.1-1,0.4-1.9,0.6-2.1c0.6-0.6,0.9,0.4,0.6,2.1C197.4,200.1,196.2,200.1,196.6,197.7 L196.6,197.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M189,197.1c1.2-3.1,4.2-9.1,4.6-9.1c0.2,0,0.4,0.1,0.4,0.1c0,0.6-4.6,10.1-5,10.2 C188.6,198.5,188.6,198.1,189,197.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M244,196.9c-2.1-1.3-2.2-1.4-1.9-1.8c0.4-0.4,4.4,1.8,4.4,2.4C246.5,198.2,245.9,198.1,244,196.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M236.5,193.4c-3.1-1.2-3.2-1.3-2.9-1.6c0.4-0.4,5.9,1.8,5.9,2.3c0,0.2-0.1,0.4-0.1,0.4 C239.3,194.4,238,193.9,236.5,193.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M196.9,191.6c-0.6-0.6-0.4-1.6,0.4-1.6c0.4,0,0.8,0.4,0.8,1C198,192,197.4,192.3,196.9,191.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M225.4,190.1c-0.5-0.1-0.9-0.4-0.9-0.6c0-0.5,2.9-0.1,3.3,0.5C228.1,190.5,226.9,190.5,225.4,190.1 L225.4,190.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M212.8,188c-0.4-0.6,1.1-0.6,2.5,0c0.9,0.4,0.8,0.4-0.6,0.4C213.8,188.5,212.9,188.3,212.8,188z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M205.2,187.5c-0.8-0.4-0.6-0.4,0.9-0.4c1-0.1,1.9,0.2,1.9,0.4C208,188.1,206.6,188.1,205.2,187.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M186,171.9c-1.2-0.6-2-1.1-1.6-1.2c0.3-0.1,1.2,0.1,2.1,0.6c1.9,1,2.2,1,1.9,0.1c-0.4-1.1,0.6-0.9,1.2,0.2 c0.2,0.6,0.5,1.1,0.5,1.2C190,173.2,188.2,172.9,186,171.9L186,171.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M144.4,166c-1.6-0.2-3.1-0.6-3.2-0.8c-0.4-0.4,5.8,0.2,7.1,0.8l1,0.4l-1-0.1 C147.7,166.4,145.9,166.2,144.4,166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M164.3,165.6c0.6-0.2,2.1-0.6,3.5-0.8c1.8-0.2,2.1-0.2,1.4,0.1c-0.6,0.2-2.1,0.6-3.5,0.8 C163.9,165.9,163.6,165.9,164.3,165.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M132.9,163.6c-0.5-0.1-0.9-0.4-0.9-0.7c0-0.5,1.6-0.2,3,0.6c0.6,0.4,0.6,0.4-0.2,0.4 C134.2,163.9,133.4,163.8,132.9,163.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M127.2,161.4c-0.7-0.3-1.2-0.8-1.2-0.9c0-0.5,2.9,0.5,3.3,1.1C129.7,162.2,128.5,162.1,127.2,161.4 L127.2,161.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M184.5,159.8c0-0.8,1.9-2,2.4-1.6c0.1,0.1-0.1,0.4-0.6,0.6c-0.4,0.1-0.8,0.6-0.8,1s-0.2,0.7-0.5,0.7 C184.8,160.5,184.5,160.1,184.5,159.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M122.7,159.1c-1.4-0.8-2.2-1.6-1.3-1.6c0.6,0,3.2,1.7,3.2,2.1C124.5,160.1,124.6,160.1,122.7,159.1 L122.7,159.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M116.7,155.4c-2.9-2.2-2.8-3.4,0.1-1.3c1.2,0.9,2.2,1.9,2.2,2.3C119,157.2,119.1,157.2,116.7,155.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M193,153.5c1.9-1.6,2-1.7,3.7-3.8c0.6-0.8,1.4-1.4,1.6-1.1c0.4,0.4-5.4,6.4-6.4,6.4 C191.5,154.9,192,154.3,193,153.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M110.2,149.1c-1-1.3-1.7-2.6-1.5-3c0.1-0.4,0-0.6-0.2-0.4c-0.5,0.3-2.1-2.8-2.7-5.4 c-0.6-2.4,0.8-1.4,1.8,1.4c0.5,1.2,2,4,3.4,6.1C113.8,152,113.3,153.1,110.2,149.1L110.2,149.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M105.2,131.9c0.4-1.9,0.6-2.2,1.1-1.8c0.4,0.4-0.3,3.4-0.9,3.4C105.1,133.5,105.1,132.9,105.2,131.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M201.6,128c-0.8-2.3-0.9-3-0.4-3c0.6,0,2.2,3.9,2.2,5.4C203.5,132,202.5,130.8,201.6,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M106,128.2c0-1,0.9-2.7,1.4-2.7c0.2,0,0.2,0.8-0.1,1.8C106.8,129.1,106,129.6,106,128.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M108,123.7c0-0.6,1.7-3.2,2.1-3.2c0.6,0,0.5,0.4-0.4,2.1C108.8,123.9,108,124.5,108,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M198.4,121.4c-1.9-2.5-2.1-2.9-1.2-2.9c0.6,0,3.4,3.3,3.4,4.2S199.6,122.9,198.4,121.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M115,114.9c2.6-2.2,4.7-3.7,4.4-3.1c-0.3,0.8-5.1,4.7-5.7,4.7C113.5,116.4,114.1,115.8,115,114.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M189.5,112.7c-1.8-1.2-3.6-2.4-4-2.7c-0.4-0.2-0.6-0.6-0.4-0.8c0.4-0.3,7.4,3.8,8.4,5.1 C194.8,115.8,192.8,115,189.5,112.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M122.5,110.1c0-0.5,3-2.2,3.3-1.9c0.2,0.1-0.6,0.7-1.6,1.2C123.3,110,122.5,110.3,122.5,110.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M176.5,106.2c-1.2-0.4-1.9-0.9-1.6-1c0.8-0.3,4.1,0.8,4.4,1.4C179.6,107.2,179.2,107.1,176.5,106.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M131.7,105.8c0.6-0.4,1.4-0.8,2-0.8c1.2,0,0.9,0.2-1.2,0.9C130.9,106.5,130.9,106.4,131.7,105.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M142.2,103c0.6-0.2,1.4-0.4,2-0.4c0.9-0.1,0.9,0.1,0.2,0.4c-0.4,0.2-1.3,0.4-2,0.4 C141.4,103.4,141.4,103.4,142.2,103z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M159.8,102.5c-0.4-0.6,1.1-0.6,2.5,0c0.9,0.3,0.8,0.4-0.6,0.4C160.8,103,159.9,102.8,159.8,102.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M320.3,284.4c-1-1.5-1.5-4.4-0.9-4.4c0.2,0,0.6,0.8,0.9,1.7c0.1,1,0.8,2.1,1.3,2.6c1,0.9,1,0.9,2.9-1.2 c1-1.1,2.2-2.9,2.7-3.9c1-2,2-2.5,1.3-0.5c-0.2,0.6-1,2.1-1.8,3.2C324.4,285.5,321.6,286.5,320.3,284.4L320.3,284.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M209.5,284c-3.6-0.6-4.6-1-4.4-1.2c0.3-0.2,8.9,1.1,9.3,1.5C214.8,284.6,212.1,284.5,209.5,284L209.5,284z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M225,284c0.4-0.2,1.3-0.5,2-0.5c1.1,0,1.1,0,0.2,0.5c-0.6,0.2-1.4,0.5-2,0.5 C224.4,284.5,224.4,284.4,225,284z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M202.6,282.5c-0.9-0.3-1.6-0.6-1.4-0.8c0.4-0.4,3.4,0.4,3.4,0.9c0,0.2-0.1,0.5-0.1,0.4 C204.3,283,203.5,282.7,202.6,282.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M232.5,282.5c0-0.3,0.3-0.5,0.6-0.5c1.2,0,8.2-3.9,11.2-6.2c1.7-1.3,3.2-2.3,3.4-2.1 c0.4,0.5-6.3,5.3-9.6,6.9C233.9,282.5,232.5,283,232.5,282.5L232.5,282.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M191.8,279c-3.6-1.3-6.3-2.9-4.2-2.4c2,0.5,9,3.2,9,3.5C196.5,280.7,196.1,280.6,191.8,279L191.8,279z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M181.5,274.6c-2.1-1-3.5-1.9-3.2-2c0.6-0.2,8.2,3.1,8.2,3.6C186.5,276.8,185.1,276.4,181.5,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M318.8,274.1c-0.2-0.9-0.2-1.8-0.1-2c0.5-0.6,0.9,0.2,0.7,2l-0.1,1.6L318.8,274.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M329.5,274.1c0-1,2.2-7.6,2.6-7.6c0.2,0,0.4,0.2,0.4,0.6c0,1.1-2.2,7.4-2.6,7.4 C329.7,274.5,329.5,274.4,329.5,274.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M250.1,270.6c1.4-1.9,2.6-3.1,3.1-3.1c0.2,0-0.3,0.9-1.1,2C250.4,271.4,248.7,272.5,250.1,270.6L250.1,270.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M317.7,267.7c0.1-0.4,0.1-0.6-0.1-0.5s-0.6-0.3-1-1c-0.5-1-0.5-1.2,0.2-1.2c0.5,0,0.7,0.3,0.5,0.8 c-0.1,0.4,0,0.7,0.2,0.6c0.3,0,0.8,0.4,1,1c0.3,0.9,0.2,1.1-0.4,1.1C317.7,268.5,317.5,268.2,317.7,267.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M255.1,263.8c2-3,2.9-4,2.9-2.9c0,0.8-3.7,5.8-4.4,6C253.2,267,253.9,265.6,255.1,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M182.4,264.4c0.5-1.2,1.4-3.7,2.1-5.6c1.1-3.4,2-5.1,2-3.8c0,0.8-2.9,9.3-3.6,10.7 C181.9,267.4,181.5,266.4,182.4,264.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M332.8,262.4c0.4-1.9,0.6-2.2,1-1.8c0.5,0.5-0.3,3.4-0.9,3.4C332.6,264,332.5,263.4,332.8,262.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M313.1,262.5c-0.6-0.5-1.1-1.1-1.1-1.2c0-0.6,1-0.2,2.4,1C316,263.7,314.9,264,313.1,262.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M175.8,259.9c0.4-2.7,0.5-3.2,0.9-2.9c0.4,0.5-0.4,5.5-0.9,5.5C175.6,262.5,175.6,261.4,175.8,259.9 L175.8,259.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M308.8,260.6c-3.2-0.8-4.8-1.2-4.6-1.5c0.5-0.4,5.9,0.9,5.9,1.4c0,0.2,0,0.4-0.1,0.4 C309.8,260.9,309.3,260.8,308.8,260.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M333.7,257.9c0.4-1.7,0.6-2.2,1-1.8c0.5,0.4-0.4,3.4-0.9,3.4C333.6,259.5,333.5,258.9,333.7,257.9 L333.7,257.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M294.4,257.6c-0.5-0.1-0.9-0.4-0.9-0.6c0-0.4,2.9,0.2,3.4,0.8C297.2,258,295.6,258,294.4,257.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M260,256.6c0-0.7,3.2-3.8,4.5-4.2c0.5-0.2,1-0.1,1,0.1c0,0.3-0.2,0.5-0.5,0.5s-1.5,0.9-2.8,2.1 C261,256.2,260,256.9,260,256.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M289.5,256.6c-0.7-0.1-1.5-0.4-1.8-0.7c-0.4-0.4,0-0.4,1.2-0.2C291.5,256.2,292,257,289.5,256.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M176.2,254.6c0.4-2.1,0.6-2.5,1.1-2.1s-0.4,3.9-0.9,3.9C176.1,256.5,176,255.8,176.2,254.6L176.2,254.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M277,253.9c-0.9-0.3-1.5-0.6-1.4-0.8c0.4-0.4,3.4,0.4,3.4,0.9c0,0.2,0,0.4-0.1,0.4 C278.8,254.4,278,254.2,277,253.9L277,253.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M269.5,252.4c-1.2-0.2-2.4-0.6-2.5-0.8c-0.4-0.4,4.4,0.1,4.8,0.5C272.4,252.8,271.7,252.8,269.5,252.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M334.7,250.9c0.1-0.9,0.4-1.7,0.5-1.8c0.5-0.6,0.8,0.4,0.5,1.9C335.3,253.1,334.3,253,334.7,250.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M176.6,250.6c0.1-0.5,0.4-1.9,0.6-3.2c0.1-1.4,0.6-2.4,0.9-2.4c0.5,0,0.4,1.1-0.4,5.1 c-0.1,0.8-0.5,1.4-0.8,1.4C176.7,251.5,176.6,251.1,176.6,250.6L176.6,250.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M226.2,249.8c-0.9-2.1-0.9-2.2-0.1-2.2c0.2,0,0.9,0.8,1.2,1.8c0.9,2.1,0.9,2.2,0.1,2.2 C227.2,251.5,226.6,250.7,226.2,249.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M309.2,250.9c-0.8-0.2-2.4-0.5-3.4-0.6c-1-0.2-1.9-0.6-1.9-0.8c0-0.4,6.5,0.8,7,1.2 C311.4,251.2,310.7,251.4,309.2,250.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M215.4,249.4C215.4,249.4,215.4,249.4,215.4,249.4C215.4,249.5,215.4,249.5,215.4,249.4 C215.4,249.5,215.4,249.5,215.4,249.4c0,0.1,0,0.2,0,0.2c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0,0.1-0.1,0.1-0.2 c0-0.1,0-0.2,0-0.2C215.4,249.5,215.4,249.5,215.4,249.4L215.4,249.4L215.4,249.4z M215.1,250C215.1,250,215.1,250,215.1,250 C215.1,250,215.1,250,215.1,250C215.1,249.9,215.1,249.9,215.1,250C215.1,249.9,215.1,249.9,215.1,250z M215,248.3 c0.1,0.2,0.2,0.4,0.3,0.6c0,0,0-0.1,0-0.1c0-0.1-0.1-0.2-0.1-0.3C215.1,248.5,215.1,248.4,215,248.3 C215,248.3,215,248.3,215,248.3C215,248.3,215,248.3,215,248.3c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.2-0.2-0.4-0.2 C214.6,247.9,214.8,248.1,215,248.3z M214.7,250.5C214.7,250.6,214.7,250.6,214.7,250.5C214.6,250.6,214.6,250.6,214.7,250.5 c-0.2,0.1-0.3,0.1-0.4,0.2c-0.2,0.1-0.3,0.1-0.4,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0,0.1,0,0.1,0 c0,0,0,0,0,0c0.1,0,0.2,0.1,0.2,0.1c0,0,0,0,0,0c0.2,0.1,0.4,0,0.6-0.1c0,0,0.1,0,0.1,0c0.2-0.1,0.5-0.4,0.7-0.6 C215,250.3,214.9,250.5,214.7,250.5z M214.3,247.8L214.3,247.8C214.3,247.8,214.2,247.7,214.3,247.8c-0.2-0.1-0.4-0.1-0.5,0 c-0.1,0-0.1,0-0.2,0c0.1,0,0.1,0,0.2,0C214,247.7,214.1,247.7,214.3,247.8z M214.2,250.5C214.2,250.5,214.1,250.5,214.2,250.5 c0,0-0.1,0-0.1,0c0,0,0,0,0,0C214.1,250.5,214.1,250.5,214.2,250.5z M213.6,247.8C213.6,247.8,213.6,247.8,213.6,247.8 C213.6,247.8,213.6,247.8,213.6,247.8L213.6,247.8z M213,250.4c0-0.1,0-0.2,0-0.3v0c0-0.1,0-0.2,0-0.3c0,0,0,0,0,0 c-0.2,0-0.4,0.1-0.4,0.1c0,0,0,0,0,0c0-0.1-0.1-0.3-0.1-0.5c0,0.1,0,0.2,0,0.3c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0.1v0 c0,0.1,0,0.1,0.1,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0.2,0.1,0.3,0.1,0.4,0.2 C213.4,250.7,213.2,250.7,213,250.4C213.1,250.5,213,250.5,213,250.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M215.4,249.1C215.4,249.1,215.4,249.1,215.4,249.1c0-0.1,0-0.2-0.1-0.2v0c-0.1-0.2-0.2-0.4-0.3-0.6 c-0.2-0.2-0.4-0.4-0.6-0.5c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.2,0-0.3,0-0.5,0c-0.1,0-0.1,0-0.2,0l0,0c0,0,0,0,0,0 c0,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1 c-0.2,0.3-0.3,0.8-0.2,1.2c0,0,0,0,0,0c0,0.2,0,0.3,0.1,0.5c0,0,0,0,0,0c0.1-0.1,0.2-0.1,0.4-0.1c0,0,0,0,0,0c0,0.1,0,0.2,0,0.3v0 c0,0.1,0,0.2,0,0.3c0,0,0,0,0.1,0.1c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0,0.2,0,0.2,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0 c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.2-0.1,0.3-0.1c0,0,0,0,0.1,0c0,0,0,0,0,0c0.2-0.1,0.3-0.2,0.5-0.4c0,0,0-0.1,0.1-0.1 c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v-0.1 C215.4,249.3,215.4,249.2,215.4,249.1z M215.1,250C215.1,250,215.1,250,215.1,250C215.1,249.9,215.1,249.9,215.1,250 C215.1,249.9,215.1,249.9,215.1,250C215.1,250,215.1,250,215.1,250z M213.2,249.3C213.2,249.3,213.2,249.3,213.2,249.3 C213.2,249.3,213.2,249.3,213.2,249.3C213.2,249.3,213.2,249.3,213.2,249.3z M214.2,250.5c0,0-0.1,0-0.1,0c0,0,0,0,0,0 C214.1,250.5,214.1,250.5,214.2,250.5C214.1,250.5,214.2,250.5,214.2,250.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M321.6,247.6c1.2-1.4,2.8-3.4,3.4-4.5c1-1.9,2-2.8,2-1.9c0,1-2.4,4.7-4.2,6.6 C319.8,250.8,318.8,250.6,321.6,247.6L321.6,247.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M299.6,248.9c-2.2-0.6-2.1-1.1,0.2-0.7c2.2,0.4,3.9,1.2,2.4,1.2C301.7,249.4,300.5,249.2,299.6,248.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M188,247.5c0-1.4,0.6-3,1.1-3c0.3,0,0.4,0.6,0.1,1.4C188.9,247.4,188,248.6,188,247.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M293.2,247.5c-0.9-0.4-0.9-0.4,0.2-0.4c0.7,0,1.6,0.2,2,0.4c0.6,0.4,0.6,0.5-0.2,0.4 C294.7,247.9,293.8,247.8,293.2,247.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M335.2,245.8c0.2-1.2,0.1-3.8-0.2-5.8c-0.5-3.5-0.5-4.6,0.3-3.8c1,1.1,1.1,11.8,0,11.8 C335.1,248,335.1,247.1,335.2,245.8L335.2,245.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M225.3,245.7c-0.4-1.6,0.1-6.6,0.8-7.8c0.2-0.5,0.6-0.9,0.9-0.9s0.2,0.4-0.1,1.1c-0.3,0.6-0.6,2.9-0.6,5 C226.2,247.1,225.9,248.1,225.3,245.7L225.3,245.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M283.6,245.6c-1.8-0.4-3.1-0.9-3.1-1.1c0-0.4,7.2,1.1,7.8,1.6C288.8,246.6,287.2,246.5,283.6,245.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M272.8,243.3c-1.4-0.4-3-0.9-3.8-1.3c-2-1.1-4.5-4.4-4.5-6.1c0-1.4,0.8-1,1.4,0.8c1.1,3.1,5.7,6.2,9.1,6.3 c0.4,0,1.1,0.2,1.5,0.5C277.5,244.2,276,244.1,272.8,243.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M189.7,240.4c0.6-2.7,1.4-2.8,0.9,0c-0.1,0.9-0.5,1.6-0.8,1.6C189.6,242,189.5,241.4,189.7,240.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M326.5,240.2c0-0.8,2.1-4.2,2.5-4.2c0.7,0,0.6,0.4-0.6,2.6C327.4,240.2,326.5,241.1,326.5,240.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M178.6,238.4c0.1-0.4,0.6-2.4,0.9-4.5c0.4-2.1,0.9-3.9,1.1-3.9c0.3,0,0.4,0.8,0.2,1.9 c-0.9,5.2-1.4,7.1-1.9,7.1C178.7,239,178.5,238.7,178.6,238.4L178.6,238.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M333.8,234.5c-0.1-0.2-0.8-0.5-1.4-0.5c-0.8,0-0.9-0.1-0.5-0.6c0.7-0.7,2.5-0.1,2.9,0.8 C335,235.1,334.2,235.3,333.8,234.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M192,230.6c0-0.1,0.6-3.2,1.2-6.9c0.7-3.6,1.5-8.1,1.8-9.9c0.4-1.9,0.8-3.4,1.1-3.4c0.6,0,0.6,0.4,0,3.4 c-0.2,1.3-1.1,5.7-1.8,9.8c-0.8,4.1-1.6,7.4-1.8,7.4S192,230.9,192,230.6L192,230.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M263.8,228.9c-0.3-1.4,0-2.4,0.5-1.9c0.1,0.1,0.4,0.9,0.5,1.8C265.2,231,264.2,231,263.8,228.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M181.4,224.9c0.4-1.9,0.5-2.2,0.9-1.8s-0.3,3.4-0.9,3.4C181.2,226.5,181.1,225.8,181.4,224.9L181.4,224.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M263.2,224.9c-0.3-1.4,0-2.4,0.5-1.9c0.1,0.1,0.4,0.9,0.5,1.8C264.7,227,263.7,227,263.2,224.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M218.8,225c-0.4-1.2,0.1-2,1.2-2c1.4,0,2.3,1.3,1.6,2.2C220.6,226.3,219.1,226.2,218.8,225z M220.7,224.6 c0.1-0.2,0.1-0.6,0-0.7c-0.4-0.4-1.7,0.1-1.7,0.7S220.4,225.2,220.7,224.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M261.7,218.8c-0.8-2.4-0.9-3.2-0.4-3.2c0.6,0,2.2,4.2,2.2,5.9C263.5,223,262.6,221.7,261.7,218.8 L261.7,218.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M259.7,212.7c0.1-0.4,0.1-0.6-0.1-0.5c-0.2,0.2-1.1-0.8-1.9-2.1c-2-3.5-5.5-7.4-8.9-10 c-1.6-1.2-2.8-2.4-2.6-2.5c0.4-0.4,3.7,1.8,4.8,3.2c0.6,0.7,1,1.1,1,0.9c0-0.2,0.4,0,1,0.5c0.5,0.4,0.9,1.1,0.9,1.2 c-0.1,0.2,0.9,1.4,2.2,2.6c2.9,2.8,5.5,7.4,4.2,7.4C259.7,213.5,259.5,213.2,259.7,212.7L259.7,212.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M195.8,208.1c0.1-0.8,0.4-2.2,0.5-3.2c0.1-1.1,0.5-1.9,0.8-1.9s0.4,0.6,0.2,1.4c-0.1,0.8-0.4,2.2-0.5,3.2 s-0.5,1.9-0.8,1.9S195.6,208.9,195.8,208.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M186.6,204.9c0-0.4,0.4-1.8,0.9-3.1c1.4-3.8,2.1-3.4,0.9,0.4c-0.6,1.8-1.2,3.3-1.4,3.3 S186.5,205.2,186.6,204.9L186.6,204.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M196.8,197.9c0.4-2.3,0.6-2.8,1-2.3c0.4,0.4-0.4,4.4-0.9,4.4C196.6,200,196.5,199.1,196.8,197.9L196.8,197.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M243.6,196.6c-1.4-0.8-2.2-1.6-1.4-1.6c0.6,0,3.2,1.7,3.2,2.1C245.5,197.6,245.6,197.6,243.6,196.6 L243.6,196.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M189.5,196.5c0-1.2,4.2-9.2,4.9-9.4c0.5-0.1,0.4,0.2-0.3,1.2c-0.6,0.8-1.6,2.9-2.4,4.7 C190.4,196.4,189.5,197.7,189.5,196.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M239.6,194.6c-0.9-0.4-1.6-0.9-1.6-1.1c0-0.5,2.9,0.5,3.3,1.1C241.8,195.4,241.3,195.4,239.6,194.6 L239.6,194.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M232.1,191.9c-0.9-0.3-1.6-0.8-1.6-0.9c0-0.6,0.1-0.6,1.9,0.1c0.9,0.3,1.6,0.8,1.6,1s-0.1,0.4-0.1,0.4 C233.8,192.4,233,192.1,232.1,191.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M196.8,191.5c-0.4-0.6,0.1-1.5,0.8-1.5c0.2,0,0.4,0.4,0.4,1C198,192.1,197.2,192.4,196.8,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M218.9,189c-3.7-0.6-3.6-1.1,0.1-0.8c3.8,0.4,6.2,1.2,3.8,1.1C221.9,189.4,220.1,189.2,218.9,189z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M212.2,188c-0.9-0.4-0.9-0.4,0.2-0.4c0.7,0,1.6,0.2,2,0.4c0.6,0.4,0.6,0.5-0.2,0.4 C213.7,188.4,212.8,188.2,212.2,188z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M196.2,187c-0.4-0.6,1.1-0.6,2.5,0c0.9,0.4,0.8,0.4-0.6,0.4C197.3,187.5,196.4,187.3,196.2,187z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M186.2,171.9c-1.1-0.5-2.2-1-2.5-1.1c-0.2-0.1-0.4-0.4-0.2-0.5s1.4,0.2,2.8,0.9l2.6,1.2l-1.6-3.4 c-1.9-3.6-2.6-6.1-1.9-6.1c0.3,0,1.4,2.1,2.4,4.6c1.1,2.6,2.1,4.8,2.1,5C190.2,173.3,188.3,172.9,186.2,171.9L186.2,171.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M174.6,167.2c-4.1-1.7-5.6-2.1-7-1.9s-1.6,0.1-0.8-0.2c0.6-0.2,1.6-0.5,2.1-0.5c1.2-0.1,11,3.6,11.9,4.5 S179.6,169.4,174.6,167.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M146.5,166c-1-0.3-1.1-0.4-0.2-0.4c0.6,0,1.4,0.1,2,0.4C149.5,166.6,148.2,166.6,146.5,166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M160.8,166c0.6-0.2,1.6-0.4,2.2-0.4c1.1,0,1.1,0.1,0.2,0.4c-0.6,0.2-1.6,0.4-2.2,0.4 C159.9,166.4,159.9,166.4,160.8,166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M139.5,165c-0.6-0.4-0.6-0.5,0.2-0.4c0.6,0,1.4,0.2,2,0.4c0.9,0.4,0.9,0.4-0.2,0.4 C140.8,165.4,139.9,165.2,139.5,165z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M129.6,162.4c-1.4-0.6-2.7-1.2-2.7-1.4c0-0.4,4.9,1.3,5.5,1.9C133.1,163.5,131.9,163.3,129.6,162.4 L129.6,162.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M184.5,160.1c0-0.4,0.4-1.1,1-1.5s1-0.4,1-0.1c0,0.2-0.2,0.5-0.5,0.5c-0.2,0-0.5,0.4-0.5,1s-0.2,1-0.5,1 C184.8,161,184.5,160.6,184.5,160.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M118.1,156.2c-1.7-1.2-3.1-2.5-3.1-2.8c0-0.6,6.9,4.1,7,4.7C122,158.9,121,158.4,118.1,156.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M189.5,156.6c0-0.4,2.7-2.6,3.2-2.6s-0.2,0.9-1.8,2C190.1,156.6,189.5,156.9,189.5,156.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M111.7,150.9c-1.7-1.9-3.6-5.1-3.3-5.5c0.2-0.2,0.1-0.4-0.2-0.4c-1.1,0-3.7-9.1-2.9-9.9 c0.5-0.4,0.8,0.1,1.3,2.9c0.7,3.6,2.3,7.1,5.2,10.9c1.3,1.8,2,3.1,1.7,3.1C113,152,112.2,151.5,111.7,150.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M196,150.6c0.6-0.8,1.8-2.4,2.6-3.8c1.4-2.2,2.4-2.9,2.4-2c0,0.6-5.1,7.1-5.6,7.1 C195.1,152,195.4,151.4,196,150.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M201.5,141.9c0-1.1,1.1-4.4,1.6-4.4s0.5,0.1-0.1,2.8C202.5,142.3,201.5,143.4,201.5,141.9L201.5,141.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M105.3,131.1c0.4-2.4,1-4.2,1.6-4.2c0.2,0,0.1,1.3-0.3,3C105.8,133.3,104.9,134.1,105.3,131.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M201.8,128.4c-0.5-2.2-2-5.1-4.1-8c-1.2-1.8-1.5-2.4-0.9-2.4c1.3,0,5.1,6.2,6.2,10.2 c0.4,1.4,0.4,1.9-0.1,1.9C202.4,130,201.9,129.2,201.8,128.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M106.6,126.2c1.2-2.6,2.2-4.2,2.5-4.2c0.6,0,0.5,0.3-0.6,2.5c-0.6,1.1-1.2,2-1.6,2S106.5,126.3,106.6,126.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M111,119c1.1-1.5,2-2.3,2-1.8c0,0.7-2.1,3.2-2.6,3.2C110.1,120.5,110.4,119.8,111,119z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M191,113.7c-1.5-1.2-4.1-2.9-5.9-3.8c-1.8-0.8-3.1-1.8-3.1-2.1c0-0.6,1.2-0.1,5.2,2.2 c4.1,2.4,6.9,4.6,6.7,5.3C193.8,115.6,192.5,114.8,191,113.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M119,112.2c0-0.4,4.8-3.3,7.2-4.2c1.7-0.8,0.8,0.1-2,1.6c-1.6,0.9-3.4,2-4,2.4 C119.5,112.3,119,112.4,119,112.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M135.2,104.5c0.6-0.2,1.4-0.4,2-0.4h1l-1,0.4c-0.6,0.2-1.4,0.4-2,0.4h-1L135.2,104.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M165.9,103.5c-1-0.2-2.1-0.5-2.2-0.7c-0.4-0.4,4.2,0.2,5.6,0.8c0.9,0.3,0.9,0.4-0.2,0.3 C168.3,103.9,166.9,103.7,165.9,103.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M142.8,103.1c0.6-0.2,2.4-0.6,4-0.8c1.8-0.2,2.6-0.1,2,0.2c-0.6,0.2-2.4,0.6-4,0.7 C143,103.3,142.1,103.3,142.8,103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M159.2,102.5c-0.9-0.4-0.9-0.4,0.2-0.4c0.7,0,1.6,0.2,2,0.4c0.6,0.4,0.6,0.5-0.2,0.4 C160.7,102.9,159.8,102.8,159.2,102.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M320.3,284.4c-1-1.5-1.6-4.9-0.9-4.9c0.2,0,0.6,1,0.8,2.1c0.4,2.2,1.6,3.5,3,3c2-0.8,6-9,8.4-17.3 c0.6-2.1,1.3-3.9,1.5-3.9c0.5,0,0.6-0.3-1.1,5.5C328.3,281.4,322.9,288.4,320.3,284.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M210.8,284c-0.9-0.4-0.9-0.5,0.2-0.5c0.7,0,1.6,0.2,2,0.5c0.6,0.4,0.6,0.5-0.2,0.5 C212.2,284.5,211.3,284.2,210.8,284z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M225.2,284c4.1-1.2,9.2-2.3,8.9-1.9c-0.6,0.5-5.1,1.7-8.1,2.1C224.2,284.4,224.1,284.4,225.2,284z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M197.4,280.9c-1.6-0.5-2.8-1.1-2.6-1.2c0.4-0.4,5.7,1.3,6.1,1.9C201.2,282.1,200.7,282.1,197.4,280.9 L197.4,280.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M187.8,277.3c-6.7-2.9-8.8-3.9-8.8-4.3c0-0.2,1.3,0.2,2.9,1c1.6,0.8,4.8,2.1,7.2,3.1s4.4,1.9,4.4,2.1 C193.5,279.7,193.1,279.6,187.8,277.3L187.8,277.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M318.8,274.5c-0.2-2.3-0.8-5.1-1.4-6.5c-1-2.3-4.9-6.5-6-6.5c-0.2,0-0.5-0.2-0.5-0.5c0-1,2.3,0.2,4.6,2.5 c1.8,1.8,2.4,2.5,2.1,3.2c-0.2,0.6-0.2,0.8,0.1,0.6c0.8-0.5,1.5,2.2,1.8,7C320,279.7,319.2,279.8,318.8,274.5L318.8,274.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M248.3,272.5c3.6-3.9,6.8-8.1,9.7-13.1c1.8-3,5.8-7.2,6.4-6.6c0.2,0.2-0.1,0.6-0.6,0.9 c-1.6,0.9-3,2.8-5.8,7.5c-1.5,2.5-3.5,5.4-4.6,6.5s-1.9,2.2-1.9,2.4c0,0.4-4.3,4.5-5.8,5.5C245.2,275.9,246.4,274.5,248.3,272.5 L248.3,272.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M176.1,270.6c-0.6-2.4-0.7-3.6-0.1-3.6c0.2,0,0.6,1,0.8,2.1s0.6,2.4,0.9,2.8c0.4,0.4,0.3,0.6-0.2,0.6 C176.9,272.5,176.4,271.8,176.1,270.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M181.3,267.1c0.6-1.4,2.1-5.1,3.2-8.5c1.1-3.4,2.3-6.1,2.6-6.1c0.5,0-3.6,12.2-5.1,15 C180.6,270.3,179.9,269.9,181.3,267.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M175.7,260.9c0.1-1.2,0.4-3.6,0.6-5.5c0.2-1.9,0.6-3.4,0.9-3.4s0.4,0.6,0.2,1.6c-0.1,0.9-0.4,3.4-0.6,5.5 c-0.2,2.1-0.6,3.9-0.8,3.9S175.5,262,175.7,260.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M333.1,261.2c0.2-0.8,0.7-4.2,1.1-7.5c1.1-8.1,1.8-10.4,1.5-4.7c-0.3,5.1-1.6,12.5-2.4,13.2 C333,262.6,332.9,262.3,333.1,261.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M296.8,258c-0.9-0.4-0.9-0.5,0.2-0.5c0.7,0,1.6,0.2,2,0.5c0.6,0.4,0.6,0.5-0.2,0.5 C298.2,258.5,297.3,258.2,296.8,258z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M288.8,256.5c-1.1-0.2-2.1-0.6-2.2-0.8c-0.4-0.4,4.3,0.3,5.6,0.8c1,0.4,1,0.5-0.2,0.4 C291.3,256.9,289.8,256.7,288.8,256.5L288.8,256.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M280,254.6c-0.7-0.1-1.5-0.4-1.8-0.8c-0.4-0.4,0.1-0.4,1.5-0.1c2.4,0.4,4.1,1.2,2.5,1.1 C281.7,254.9,280.7,254.8,280,254.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M227.6,252.4c-1.6-1.9-2.8-7.3-2.2-10.7c0.4-3.4,0.9-2.6,0.9,1.7c0,2.9,0.3,4.5,1.1,6.5 C228.6,252.4,228.7,253.6,227.6,252.4L227.6,252.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M270.8,252.5c-0.9-0.4-0.9-0.4,0.2-0.4c0.7,0,1.7,0.2,2.2,0.4c0.9,0.4,0.9,0.4-0.2,0.4 C272.3,252.9,271.3,252.8,270.8,252.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M213.5,250.8c0.1,0,0.2,0,0.2,0c0,0,0,0,0,0c0,0,0,0-0.1,0h0v0c-0.1,0-0.3-0.1-0.5-0.2c0,0,0,0,0,0 c-0.1,0-0.2-0.1-0.2-0.1c0,0,0,0,0,0c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0c0,0,0,0,0-0.1 c0,0,0-0.1,0-0.1v0c0,0,0-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0.1-0.1,0.2-0.1,0.4-0.1c0,0,0,0,0,0c0,0.1,0,0.2,0,0.3v0 c0,0.1,0,0.2,0,0.3c0,0,0,0,0.1,0.1C213.2,250.7,213.4,250.7,213.5,250.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M213.8,250.8C213.8,250.8,213.8,250.8,213.8,250.8C213.8,250.8,213.8,250.8,213.8,250.8 C213.8,250.8,213.8,250.8,213.8,250.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M214,250.5c0,0,0.1,0,0.1,0c0,0,0,0,0,0C214.1,250.5,214.1,250.5,214,250.5C214,250.5,214,250.5,214,250.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M215.1,250C215.1,250,215.1,250,215.1,250C215.1,250,215.1,250,215.1,250C215.1,249.9,215.1,249.9,215.1,250 C215.1,249.9,215.1,249.9,215.1,250z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M215.3,248.9c-0.1-0.2-0.2-0.4-0.3-0.6c-0.2-0.2-0.4-0.4-0.6-0.5c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c-0.2,0-0.3,0-0.5,0c-0.1,0-0.1,0-0.2,0l0,0c0,0,0,0,0,0c0,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c0,0,0.1-0.1,0.1-0.1 c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1-0.1c0.1,0,0.2-0.1,0.3,0c0.1,0,0.1,0,0.2,0.1c0.1,0,0.1,0,0.2,0.1 l0,0c0,0,0.1,0.1,0.2,0.1c0,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0,0,0,0v0c0,0,0.1,0.1,0.1,0.1 c0,0,0.1,0.1,0.1,0.1C215.2,248.6,215.2,248.7,215.3,248.9C215.3,248.8,215.3,248.8,215.3,248.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M215.3,249.5C215.4,249.4,215.4,249.4,215.3,249.5C215.4,249.5,215.4,249.5,215.3,249.5 C215.4,249.5,215.4,249.5,215.3,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M215.4,249.4c0-0.1,0-0.2,0-0.2c0,0,0,0,0,0C215.4,249.2,215.4,249.3,215.4,249.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M304.3,249.9c-1.1-0.2-2.1-0.6-2.2-0.8c-0.4-0.4,4.3,0.3,5.6,0.9c1,0.4,1,0.4-0.2,0.4 C306.8,250.4,305.3,250.2,304.3,249.9L304.3,249.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M320.5,249.3c0-0.1,0.8-1.1,1.8-2.1c1-1.1,2.8-3.9,4-6.4c2.1-4.4,4.3-7.2,5.4-7.2c0.3,0-0.1,0.8-1,1.8 s-2.4,3.5-3.3,5.6c-1.6,3.6-3.8,6.6-5.8,8.1C320.9,249.3,320.5,249.5,320.5,249.3L320.5,249.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M177.1,247.6c0.1-0.8,0.6-3.1,0.9-5.2c0.4-2.1,0.9-3.9,1.1-3.9c0.2,0,0.4,0.6,0.1,1.6 c-0.2,0.9-0.6,3.2-0.9,5.2c-0.3,1.9-0.8,3.6-1,3.6C177.1,249,177,248.4,177.1,247.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M188.4,245.9c0.4-1.9,0.5-2.2,0.9-1.8s-0.3,3.4-0.9,3.4C188.2,247.5,188.1,246.8,188.4,245.9L188.4,245.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M290,246.9c-0.9-0.3-1.5-0.6-1.4-0.8c0.4-0.4,3.4,0.4,3.4,0.9c0,0.2,0,0.4-0.1,0.4 C291.8,247.4,291,247.2,290,246.9L290,246.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M283.8,245.5c-0.9-0.4-0.9-0.4,0.2-0.4c0.7,0,1.6,0.2,2,0.4c0.6,0.4,0.6,0.5-0.2,0.4 C285.2,245.9,284.3,245.8,283.8,245.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M279.5,244.5c-0.6-0.4-0.6-0.5,0.2-0.4c0.5,0,1.5,0.2,2,0.4c0.9,0.4,0.9,0.4-0.2,0.4 C280.8,244.9,279.9,244.8,279.5,244.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M335.3,241.5c-0.5-4.4-1.2-7-2.1-7.4c-1-0.4-0.9-1.1,0.2-0.8c0.5,0.1,1.2,0.7,1.5,1.2c0.8,1.2,1.5,7.9,1,9.2 C335.8,244.3,335.5,243.4,335.3,241.5L335.3,241.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M267.5,240.6c-2-1.9-3.5-5.2-3.5-8c0-2.1,0.9-1.2,1.1,1.1c0.5,3.4,3.1,7.8,4.8,7.8c0.3,0,0.5,0.2,0.5,0.5 C270.5,242.9,269.5,242.5,267.5,240.6L267.5,240.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M226,238.5c0-1,1.6-4.2,2.8-5.9c1.6-2,2.2-1.8,0.8,0.3c-0.6,0.8-1.5,2.5-2.1,3.8 C226.6,238.9,226,239.6,226,238.5L226,238.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M190.6,236.6c1.7-8.1,2.9-13.4,3.1-13.6c0.7-0.7,0.6,0.6-0.6,5.6c-0.6,3.1-1.3,6.4-1.5,7.4s-0.6,1.9-0.9,1.9 C190.6,238,190.5,237.4,190.6,236.6L190.6,236.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M179.2,235.4c0.1-0.4,0.6-2.8,1.1-5.3c0.5-2.6,1.1-4.8,1.3-4.9c0.6-0.4,0.6,0.1-0.6,5.4 c-0.6,2.6-1,4.9-1,5.1c0,0.2-0.2,0.4-0.5,0.4C179.2,236,179.1,235.7,179.2,235.4L179.2,235.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M231.6,230c0.2-0.7,3.4-2.8,3.4-2.1c0,0.2-0.8,0.9-1.8,1.6C232.2,230.1,231.4,230.4,231.6,230L231.6,230z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M263.8,228.4c-0.2-0.9-0.2-1.6,0-1.8c0.5-0.4,0.6-0.1,1,1.8C265.1,230.4,264.2,230.5,263.8,228.4 L263.8,228.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M220.1,225.6c1.1-0.2,1.1-2.1,0.1-2.1c-0.4,0-0.9,0.4-1.2,0.9c-0.6,0.8-0.6,0.8-0.3-0.1 c0.1-0.5,0.3-1.1,0.3-1.1c0-0.4,1.9-0.1,2.4,0.4c0.8,0.8-0.1,2.4-1.3,2.4C219.3,225.9,219.3,225.8,220.1,225.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M263,223.4c-0.2-1.2-0.7-2.9-1-3.9c-0.2-0.9-0.4-1.9-0.2-2.1c0.1-0.2,0-0.4-0.2-0.4c-0.5,0-2.4-4.4-2.2-5.1 c0-0.2-0.1-0.4-0.4-0.4c-0.5,0-2-2.4-2.1-3.4c0-0.2-0.5-0.7-0.9-1.1c-0.5-0.4-1.2-1.1-1.5-1.7l-0.6-1.1l1.5,1.1 c3.4,2.4,6.8,9.6,8.8,18.8C264.7,226.4,263.6,225.7,263,223.4L263,223.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M182.3,220.6c0.4-1.6,1.2-2.8,1.2-1.6c0,1.3-0.6,2.9-1.1,2.9C182.2,222,182.1,221.4,182.3,220.6L182.3,220.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M194.4,218.4c0.4-1.9,0.5-2.2,0.9-1.8s-0.3,3.4-0.9,3.4C194.2,220,194.1,219.2,194.4,218.4L194.4,218.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M184,214.4c0-1,3.6-13.6,4.8-16.4c1.5-3.8,1.7-2.1,0.2,2.1c-0.8,2.2-2.1,6.2-2.8,8.9 C184.8,214.1,184.1,215.9,184,214.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M195.2,212.9c0.6-2.7,1.4-2.8,0.9,0c-0.1,0.9-0.5,1.6-0.8,1.6C195.1,214.5,195,213.9,195.2,212.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M195.7,208.9c0.1-0.9,0.4-2.9,0.6-4.2c0.2-1.4,0.6-2.6,0.8-2.6c0.3,0,0.4,0.7,0.2,1.6 c-0.1,0.9-0.4,2.8-0.6,4.2c-0.2,1.4-0.6,2.6-0.8,2.6C195.6,210.5,195.5,209.8,195.7,208.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M249,200.2c-5.6-4.6-14.3-8.2-24.1-10.2c-5.7-1.1-7.2-1.8-2.9-1.2c4.2,0.6,11.3,2.4,15.8,4.2 c5.1,2.1,11.6,5.9,13.1,8c0.7,0.9,1.1,1.6,1.1,1.6C251.8,202.4,250.5,201.4,249,200.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M197.1,196.9c-0.1-1.1,0.2-1.9,0.4-1.9c0.6,0,0.6,1.4,0,2.8C197.1,198.6,197.1,198.4,197.1,196.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M190.5,194.1c0-0.9,1.1-3.1,1.6-3.1s-0.5,2.9-1.1,3.3C190.7,194.4,190.5,194.4,190.5,194.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M196.9,192.1c-0.3-1.6,0-2.3,0.7-1.9c0.6,0.4,0.6,3.2,0,3.2C197.3,193.5,197,192.9,196.9,192.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M205.8,187.5c-0.9-0.4-0.8-0.4,0.5-0.4c0.9,0,1.9,0.2,2.5,0.4c0.9,0.4,0.8,0.4-0.5,0.4 C207.4,187.9,206.3,187.8,205.8,187.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M187.1,172.4c-0.6-0.3-1.1-0.8-1.1-1.1c0-0.2,0.6-0.1,1.3,0.4s1.6,0.8,1.9,0.6c0.4-0.1,0.4-0.2-0.1-0.2 c-0.4-0.1-0.5-0.2-0.4-0.6c0.1-0.2,0.1-0.5-0.2-0.5c-0.7,0-3.1-5.3-2.8-5.9c0.2-0.2,0.1-0.6-0.2-0.6c-0.6-0.2-1.2-3.4-0.6-3.4 c0.2,0,0.8,0.9,1.1,2.1c0.4,1.1,1.4,3.8,2.4,5.8c0.9,2.1,1.7,3.8,1.7,3.9C190,173.2,188.2,172.9,187.1,172.4L187.1,172.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M179.1,169c-1.2-0.6-2.1-1.1-1.9-1.2c0.4-0.4,4.4,1.4,4.4,1.9S181.6,170.2,179.1,169z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M173.9,166.9c-0.8-0.3-1.4-0.7-1.4-0.9c0-0.5,2.9,0.5,3.3,1.1C176.1,167.6,175.7,167.6,173.9,166.9 L173.9,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M136,164.4c-0.9-0.2-1.4-0.6-1-0.7c0.4-0.1,1.8,0.1,3,0.6c1.6,0.5,1.9,0.7,1,0.7 C138.3,164.9,136.9,164.7,136,164.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M130.9,162.9c-2.3-0.9-1.6-1.4,0.9-0.5c1.2,0.4,2.2,0.9,2.2,0.9C134,163.7,132.3,163.4,130.9,162.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M118.4,156.4c-4.8-3.2-5.6-4.1-8.2-7.6c-1.3-1.9-2.1-3.2-1.8-3.7c0.2-0.6,0.1-0.7-0.2-0.4 c-0.4,0.2-0.5,0.1-0.2-0.5c0.2-0.6,0.2-0.8-0.2-0.6c-0.6,0.4-2.5-4.5-1.9-5c0.4-0.4,0.8,0.1,0.9,1.3c0.1,0.6,0.2,1.1,0.4,1.1 c0.2,0,0.4,0.5,0.7,1.1c0.2,0.6,1.2,2.6,2.3,4.2c1.1,1.7,1.9,3.2,1.8,3.2c-0.2,0.3,5.2,4.8,8.2,6.9c1.7,1.1,3,2.1,3,2.2 C123,159.4,121.9,158.8,118.4,156.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M187,158.1c0-0.2,0.8-0.9,1.8-1.6c1-0.6,1.8-0.9,1.6-0.6C190.2,156.7,187,158.7,187,158.1L187,158.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M194.3,152.2c1.9-1.8,3.4-3.1,3.6-3c0.3,0.3-5.9,6.2-6.5,6.2C191.2,155.5,192.4,154.1,194.3,152.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M200.6,143.9c0.8-1.8,1.6-4,1.8-5c0.3-1.8,1.2-2.7,1.2-1.2c0,1.2-1.5,5.4-2.6,7.4 C199.1,148.1,198.9,147.3,200.6,143.9L200.6,143.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M105.2,136.4c-0.2-0.9-0.2-1.6-0.1-1.8c0.4-0.4,0.6-0.1,0.9,1.8C106.5,138.4,105.7,138.5,105.2,136.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M105.2,131.9c0.7-4.6,2.2-8.2,5.2-12c2.7-3.5,3-2.9,0.4,0.8c-2.5,3.6-4.2,7.6-4.7,11 c-0.2,1.3-0.6,2.4-0.8,2.4C105.1,134,105,133.1,105.2,131.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M201.9,128.6c-0.4-1.6-1.6-4.2-2.6-5.8c-0.9-1.6-1.6-2.9-1.5-2.9s-0.4-0.6-1.1-1.2c-1.2-1.1-1.2-1.2-0.4-1.2 c1.2,0.2,4.8,5.2,4.4,6.2c-0.2,0.5-0.1,0.7,0.2,0.5c0.5-0.3,1,0.6,2.1,4.1c0.6,2.1,0.7,3.1,0.1,3.1 C202.9,131.5,202.3,130.2,201.9,128.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M113,116.8c0-0.3,5.8-4.8,7.7-5.9c0.8-0.5,1.3-0.7,1.3-0.4c0,0.2-0.7,0.8-1.4,1.2c-0.8,0.4-2.7,1.8-4.2,3.1 C113.8,116.9,113,117.3,113,116.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M192.8,114.8c-0.8-1.1-1.5-1.8-1.6-1.7c-0.1,0.2-1.2-0.4-2.4-1.2c-1.2-0.8-4.1-2.4-6.4-3.5 c-4.1-1.9-5.4-2.9-3.1-2.2c2.2,0.7,9.4,4.4,10.6,5.5c0.7,0.7,1.3,1.1,1.4,0.9c0.4-0.4,3.5,2.7,3.2,3.3 C194.3,116.4,193.7,116.1,192.8,114.8L192.8,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M126.2,108.1c0.8-0.8,4.2-2.1,4.2-1.7c0,0.2-1.1,0.8-2.4,1.2C126.8,108.2,126,108.3,126.2,108.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M172.6,104.9c-0.9-0.3-1.6-0.7-1.4-0.8c0.4-0.4,3.4,0.3,3.4,0.9c0,0.2-0.1,0.4-0.1,0.4 C174.3,105.4,173.5,105.2,172.6,104.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M137.2,104.1c0.6-0.2,2-0.6,3.2-0.8c1.4-0.2,1.9-0.2,1.2,0.2c-0.6,0.2-2,0.6-3.2,0.8 C137.1,104.4,136.6,104.4,137.2,104.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M166.8,103.5l-1-0.4h1c0.6,0,1.4,0.2,2,0.4l1,0.4h-1C168.2,103.9,167.3,103.8,166.8,103.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M159.8,102.5l-1-0.4h1c0.6,0,1.4,0.2,2,0.4l1,0.4h-1C161.2,102.9,160.3,102.8,159.8,102.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M320.2,284.3c-0.5-0.8-0.9-2.8-1-5.1c-0.1-2.6,0-3.6,0.2-2.9c0.2,0.5,0.5,1.8,0.5,2.8c0.1,3.9,0.6,5.5,2,6 c1.2,0.5,1.2,0.5,0.2,0.5C321.5,285.5,320.7,285,320.2,284.3L320.2,284.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M324.6,283.5c0.6-0.8,1.1-1.4,1.3-1.3c0.4,0.4-0.9,2.1-1.6,2.5C323.7,284.9,323.8,284.6,324.6,283.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M209.9,284c-1.4-0.2-2.6-0.5-2.8-0.8c-0.4-0.4,4.9,0.2,6.1,0.8l1,0.4h-1C212.7,284.4,211.1,284.2,209.9,284z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M225.2,284c0.6-0.2,1.4-0.4,2-0.4c0.8,0,0.8,0.1-0.2,0.4C225.3,284.5,224,284.5,225.2,284z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M203.2,282.6c-2.9-0.7-11.8-3.8-12-4.1c-0.1-0.2,0.2-0.2,0.9,0c1.9,0.5,11.6,3.6,12.9,4 c0.9,0.4,1.1,0.4,0.2,0.4C204.7,282.9,203.8,282.8,203.2,282.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M327.2,279.4c1.2-2.2,4.5-11.8,5.2-15.1c0.2-1.1,0.8-3.8,1.2-6c0.9-4.6,1.6-5.8,1.1-1.8c-1,8-6.2,24-8,24.7 C326.4,281.3,326.6,280.6,327.2,279.4L327.2,279.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M241,278.6c0-0.2,0.7-0.9,1.6-1.4s3.1-2.4,5-4.1c1.9-1.8,3.4-3,3.4-2.8c0,0.5-5.8,5.9-8.2,7.5 C241.8,278.5,241,278.9,241,278.6L241,278.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M182.9,275.1c-3.6-1.6-6.5-3.1-6.6-3.6c-0.6-2.4-0.8-4.5-0.3-4.5c0.2,0,0.5,0.9,0.5,1.9 c0,2.6,0.3,2.9,10.1,7.3c1.6,0.7,2.9,1.4,2.9,1.5C189.5,278.1,189.8,278.2,182.9,275.1L182.9,275.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M318.8,272.8c-0.2-1.1-0.5-2.5-0.6-3c-0.2-0.9-0.2-1,0.6-0.2c0.6,0.5,0.8,1.5,0.6,3l-0.2,2.2L318.8,272.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M252.2,268c0.9-1,2.2-2.9,3.2-4.4c0.9-1.4,1.9-2.6,2.2-2.6c0.4,0,0.4,0.2,0,0.6c-0.3,0.3-1.3,1.9-2.4,3.5 c-1,1.5-2.4,3.2-3.2,3.7l-1.4,0.9L252.2,268L252.2,268z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M315.1,264.1c-0.5-0.6-1.7-1.6-2.8-2.2c-1.1-0.5-1.9-1.1-1.8-1.2c0.4-0.5,4,1.7,5.5,3.2c1,1,1.1,1.5,0.5,1.5 C316.2,265.4,315.5,264.8,315.1,264.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M182.8,263.6c0.2-0.5,0.5-1.3,0.6-1.8s0.5-0.9,0.8-0.9s0.4,0.4,0.1,0.9c-0.2,0.5-0.5,1.2-0.6,1.8 c-0.1,0.5-0.5,0.9-0.8,0.9S182.5,264.1,182.8,263.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M176,258.5c0-4.1,1.9-15.3,1.9-11.8c0.1,1.7-1.4,12.3-1.6,12.7C176.2,259.5,176,259.1,176,258.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M300.8,259c-1.1-0.2-2.1-0.6-2.2-0.8c-0.4-0.4,4.3,0.3,5.6,0.9c1,0.4,1,0.5-0.2,0.4 C303.3,259.4,301.8,259.2,300.8,259L300.8,259z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M282.2,255c-0.8-0.2-2.4-0.6-3.5-0.8s-1.7-0.5-1.4-0.6c0.6-0.2,8.1,1.2,8.5,1.6 C286.3,255.6,283.9,255.4,282.2,255z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M262.5,253.8c0-0.2,1-0.8,2.1-1.2c2.2-1.1,4.5-1.2,6.1-0.4c0.8,0.4,0.4,0.4-1.1,0.2s-2.8,0-4.5,0.8 C262.7,254.1,262.5,254.1,262.5,253.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M186.6,252.5c0.4-1.6,3.9-15.1,4.2-16c0.1-0.4,0.4-0.6,0.5-0.2c0.1,0.3-0.3,2.4-0.9,4.5 c-0.6,2.2-1.5,5.8-2.1,7.9C187.4,252.5,186,255.4,186.6,252.5L186.6,252.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M227.3,251.8c-0.4-0.7-0.7-1.5-0.6-1.7c0.1-0.2-0.1-0.8-0.5-1.2c-0.6-0.6-0.8-1.4-0.6-2.9l0.2-2.1l0.4,2 c0.2,1.1,0.9,3.1,1.4,4.4C228.8,252.8,228.6,253.8,227.3,251.8L227.3,251.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M335.1,248.7c0.2-1.9,0.5-3.4,0.6-3.6c0.4-0.4,0.3,3.4,0,5.4C335.1,253.3,334.7,252.1,335.1,248.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M213,250.1c0,0.1,0,0.2,0,0.3c-0.1,0-0.2,0-0.2,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c-0.1,0-0.1-0.1-0.1-0.1 c0,0-0.1-0.1-0.1-0.1v0c0,0,0-0.1,0.1-0.1v0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0.1-0.1,0.2-0.1,0.4-0.2 C213,249.9,213,250,213,250.1L213,250.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M214,250.5c0,0,0.1,0,0.1,0c0,0,0,0,0,0C214.1,250.5,214.1,250.5,214,250.5C214,250.5,214,250.5,214,250.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M215.1,250C215.1,250,215.1,250,215.1,250C215.1,249.9,215.1,249.9,215.1,250 C215.1,249.9,215.1,249.9,215.1,250C215.1,250,215.1,250,215.1,250z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M319.5,249.6c1.7-1.2,5-4.5,4.6-4.8c-0.1-0.1,0.3-0.4,1-0.8c1.1-0.6,1.1-0.5,0.2,0.2 c-0.5,0.4-0.9,0.8-0.6,0.8c0.2,0-0.9,1.2-2.4,2.8s-3,2.8-3.4,2.7C318.6,250.4,318.8,250.1,319.5,249.6L319.5,249.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M303.2,249.5l-1-0.4h1c0.5,0,1.5,0.2,2,0.4l1,0.4h-1C304.7,249.9,303.8,249.8,303.2,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M298.2,248.5l-1-0.4h1c0.5,0,1.5,0.2,2,0.4l1,0.4h-1C299.7,248.9,298.8,248.8,298.2,248.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M289.8,246.8l-2-0.7l2.2,0.3c2.5,0.3,4.5,1.1,2.8,1.1C292.2,247.5,290.9,247.1,289.8,246.8L289.8,246.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M278,244.4c-1.4-0.4-1.9-0.6-1.2-0.7c0.5-0.1,2,0.1,3.2,0.6C282.6,245,281.2,245.2,278,244.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M178.2,241.5c1.1-8.4,7.4-35.1,8.8-37.5c0.9-1.4,0.6,0.4-1,5.6c-2.1,7.6-4.2,16.6-5.9,25.9 C178.6,243.5,177.6,247,178.2,241.5L178.2,241.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M269.8,242.3c-0.8-0.4-1.8-1.2-2.2-1.9c-0.4-0.8-0.9-1.2-1.1-1.1c-0.5,0.3-1.1-0.7-0.7-1.3 c0.2-0.3,1,0.4,1.8,1.5s1.8,2,2.1,2s1.1,0.4,1.6,0.8C272.5,243.1,271.7,243.2,269.8,242.3L269.8,242.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M326.5,240.2c0.3-0.8,0.8-1.8,1-2.4c0.7-1.4,4.2-4.9,5-4.9c0.3,0,1.1,0.6,1.8,1.2c1,1,1.2,1.6,1.2,3.9v2.6 l-0.6-2.8c-0.7-3.3-1.1-4-2.2-4c-0.9,0-4.2,2.9-4.1,3.6c0.1,0.6-1.4,3.2-2,3.6C326.1,241.4,326.1,241.1,326.5,240.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M225.5,239.8c0-1.8,3.6-8.3,4.6-8.3c0.2,0-0.2,0.9-1,2.1c-0.9,1.1-1.8,3.1-2.1,4.2c-0.3,1.1-0.8,2.1-1.1,2.1 C225.7,240,225.5,239.9,225.5,239.8L225.5,239.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M265,237.1c-0.8-4.6-1.2-9.6-0.9-9.6c0.2,0,0.5,0.8,0.6,1.6c0.5,3.1,0.9,8.4,0.5,8.4 C265.1,237.5,265,237.4,265,237.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M191.5,232.9c0-1.1,1.1-4.9,1.4-4.9c0.2,0,0.1,1.2-0.1,2.8c-0.3,1.5-0.7,2.8-0.9,2.8 S191.5,233.2,191.5,232.9L191.5,232.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M231,230.2c0.9-1.1,4-2.9,4.3-2.6c0.1,0.1-0.4,0.6-1.1,1.1c-0.8,0.4-1.8,1.1-2.1,1.5 c-0.4,0.4-0.9,0.8-1.1,0.8C230.6,231,230.7,230.6,231,230.2L231,230.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M192.7,227.1c0.1-0.2,0.9-4.1,1.6-8.6c0.8-4.6,1.4-8.4,1.5-8.4c0.7-0.8,0.6,1.2-0.5,7.6 c-1.5,8.8-1.8,9.9-2.4,9.9C192.7,227.5,192.6,227.3,192.7,227.1L192.7,227.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M263.2,224.4c-0.6-3.6-0.6-4.4-0.1-4.4c0.2,0,0.5,0.9,0.5,1.9c0,1.1,0.2,2.1,0.5,2.3c0.6,0.4,0.6,2.2,0,2.2 C263.8,226.5,263.4,225.6,263.2,224.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M218.8,225.2c-0.6-1.4,1.6-3.1,2.4-1.8c0.1,0.2-0.2,0.4-0.8,0.4c-0.6-0.1-1.1,0.2-1.2,0.6 c-0.4,0.9,1.4,1.4,1.9,0.6c0.4-0.6,0.4-0.6,0.2,0.1C221.1,226.1,219.2,226.2,218.8,225.2L218.8,225.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M260.8,216c-0.1-0.2-0.1-0.8,0-1.1c0.3-0.6,1.1,0.3,1.2,1.2C262,216.6,261.1,216.6,260.8,216z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M259.9,212.7c0.2-0.6,0.1-0.8-0.2-0.5s-0.5,0.1-0.2-0.5c0.2-0.6,0.1-0.8-0.4-0.4c-0.5,0.3-0.5,0.2-0.2-0.2 c0.3-0.5,0.5-0.4,1.1,0.2c0.8,1.1,0.8,1.6,0.1,2C259.7,213.4,259.6,213.2,259.9,212.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M196.2,206.5c0.1-1.5,0.2-3.2,0.2-3.9c0-0.6,0.2-1.1,0.5-1.1s0.4,1.1,0.2,2.9 C196.8,208.2,195.9,210.1,196.2,206.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M256.8,208.6c-0.1-0.1-0.1-0.5,0-0.9s0-0.7-0.3-0.6c-0.4,0.1-1.2-0.6-1.9-1.6l-1.4-1.7l1.9,1.4 c2.3,1.9,3.6,3.6,2.6,3.6C257.3,208.9,256.9,208.8,256.8,208.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M249.6,200.5c-0.9-0.8-1.9-1.5-2.1-1.5s-0.8-0.5-1.4-1.1c-0.9-1.1-0.9-1,1.2,0.1c1.2,0.6,2.6,1.8,3.1,2.6 C251.8,202.4,251.6,202.3,249.6,200.5L249.6,200.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M196.9,195.4c0.1-5.4,0.4-6.6,0.9-3.7c0.4,1.9-0.1,8.8-0.6,8.8C196.9,200.5,196.8,198.2,196.9,195.4 L196.9,195.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M242.4,195.8c-2.3-1.4-2.9-2-1.6-1.5c1.3,0.5,4.2,2.2,4.2,2.5C245,197.2,244.1,196.9,242.4,195.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M236.6,193.2c-0.9-0.4-1.6-0.8-1.4-0.9c0.3-0.4,3.4,0.9,3.4,1.4C238.5,194.1,238.6,194.1,236.6,193.2 L236.6,193.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M229,190.7l-1.8-0.7l1.7,0.2c1.7,0.2,2.4,0.6,2,0.9C230.8,191.3,229.9,191.1,229,190.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M192.9,188.9c0.6-0.9,1.2-1.7,1.6-1.8c0.4-0.1,0.1,0.6-0.6,1.6c-0.6,1-1.4,1.8-1.6,1.8 C192.1,190.5,192.3,189.8,192.9,188.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M223.8,189.5l-1-0.4h1c0.6,0,1.4,0.2,2,0.4l1,0.4h-1C225.2,189.9,224.3,189.8,223.8,189.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M212.8,188l-1-0.4h1c0.6,0,1.4,0.2,2,0.4l1,0.4h-1C214.2,188.4,213.3,188.2,212.8,188z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M206.2,187.5l-1-0.4h1c0.6,0,1.4,0.2,2,0.4l1,0.4h-1C207.7,187.9,206.8,187.8,206.2,187.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M196,187c-0.6-0.4-0.6-0.5,0.2-0.4c0.6,0,1.4,0.2,2,0.4c0.9,0.4,0.9,0.4-0.2,0.4 C197.3,187.4,196.4,187.2,196,187z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M184.6,171.3c-3.6-1.6-5.4-2.8-3.1-2.1c0.7,0.2,2.6,1,4.2,1.8s3.4,1.5,3.8,1.6c0.5,0.2,0.4,0.2-0.2,0.2 C188.7,172.9,186.6,172.2,184.6,171.3L184.6,171.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M187,169c-0.4-0.8-0.4-1.2,0-1.9s0.5-0.6,0.2,0.4c-0.2,0.8-0.1,1.1,0.2,0.9c0.4-0.2,0.4-0.1,0.2,0.5 s-0.1,0.8,0.4,0.4c0.4-0.2,0.6-0.2,0.3,0.1C187.8,170.2,187.6,170.2,187,169L187,169z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M176.1,167.7c-0.9-0.4-1.6-0.8-1.4-0.9c0.3-0.4,3.4,0.9,3.4,1.4C178,168.6,178.1,168.6,176.1,167.7 L176.1,167.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M160,166.4c0.1-0.1,2.3-0.6,4.8-1.1c3.6-0.6,4.9-0.6,6.4-0.2c1,0.3,1.9,0.8,1.9,1s-0.9,0.1-1.9-0.4 c-1.5-0.6-2.4-0.7-4.1-0.3C164,166.1,159.7,166.6,160,166.4L160,166.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M142.2,165.5c-0.6-0.3-0.1-0.4,1.8-0.1c1.5,0.1,2.9,0.4,2.9,0.4C147.4,166.2,143.2,165.9,142.2,165.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M185.7,165.4c0.1-0.5-0.1-1.2-0.4-1.6c-0.8-0.8-1.1-2.7-0.4-2.7s1.6,3.7,1,4.5 C185.5,166.1,185.5,166.1,185.7,165.4L185.7,165.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M135.1,164.1c-1.4-0.4-2.6-0.9-2.6-1.1c0-0.3,4.6,0.9,6.8,1.7C140.6,165.2,137.4,164.8,135.1,164.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M125.8,160.7c-0.8-0.4-1.3-0.9-1.2-1.1c0.3-0.2,3.3,1.2,3.3,1.6C128,161.6,127.3,161.5,125.8,160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M185.5,158.9c2.3-1.9,6.5-4.4,6.5-4.1c0,0.2-1.3,1.2-2.9,2.2c-1.6,1-3.1,2.1-3.5,2.4c-0.4,0.2-0.8,0.5-1,0.5 C184.4,159.9,184.8,159.5,185.5,158.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M120.6,157.8c-1.5-0.9-2.9-2.1-3.2-2.5c-0.2-0.5,0.9,0.1,2.7,1.2c3.9,2.6,3.6,2.4,3.3,2.6 C123.3,159.3,122,158.7,120.6,157.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M113.9,152.9c-2.4-2.2-5.2-5.5-3.9-4.4c0.4,0.3,1,0.4,1.2,0.2s0.2-0.1,0.1,0.2c-0.2,0.4,0.7,1.4,1.9,2.5 c1.9,1.6,3.7,3.8,3.1,3.7C116.3,155,115.2,154.1,113.9,152.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M195.4,151.2c3.1-3.4,5.6-7.4,6.6-10.6c0.4-1.2,0.8-1.9,0.9-1.6c0.8,2.2-5.4,12.1-8.9,14.4 C193.3,153.8,193.9,152.8,195.4,151.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M107.9,144.1c0.2-0.5,0.1-0.6-0.3-0.4c-0.4,0.2-0.5,0.1-0.3-0.4c0.3-0.9,0.3-0.9,1.1,0.6 c0.4,0.8,0.4,1.1-0.2,1.1C107.9,144.9,107.7,144.5,107.9,144.1L107.9,144.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M106.3,141.9c-0.2-0.6-0.2-1.2-0.1-1.4c0.2-0.1,0.2,0.1,0.2,0.4c0,0.4,0.2,0.4,0.5,0.3 c0.6-0.4,0.7,0.2,0.1,1.1C106.8,142.9,106.6,142.8,106.3,141.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M105.3,136.9c-0.2-1.8-0.1-4.5,0.2-6.1c0.6-3.3,3.3-9.3,4.4-9.7c0.5-0.1,0.3,0.3-0.3,1.2 c-0.6,0.8-1.1,1.7-1.1,2.1s-0.2,0.7-0.4,0.7c-0.2,0-0.8,1.6-1.3,3.6c-0.8,2.7-0.8,4.4-0.6,7.5 C106.6,140.7,105.8,141.5,105.3,136.9L105.3,136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M202.5,130.2c0-0.7,0.2-1.1,0.5-0.9c0.3,0.1,0.5,0.8,0.5,1.3s-0.2,0.9-0.5,0.9 C202.8,131.5,202.5,130.9,202.5,130.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M202,128c-0.6-0.3-0.6-0.6-0.2-1c0.4-0.4,0.6-0.3,0.9,0.4c0.1,0.6,0.2,1.1,0.2,1.1 C202.8,128.5,202.4,128.2,202,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M200.6,125.3c-0.4-0.8-0.4-1.2,0-1.2s0.6,0.6,0.6,1.2C201.4,126.8,201.3,126.8,200.6,125.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M199.2,122.7c-0.2-0.5-0.4-1.2-0.3-1.6c0.1-0.3-0.2-0.6-0.6-0.5c-0.3,0.1-0.6-0.1-0.6-0.4s-0.7-1.2-1.6-1.9 c-0.9-0.8-2.4-2.3-3.2-3.4l-1.6-2.1l1.5,1.1c3.4,2.4,7.9,8.1,7.3,9.1C199.8,123.4,199.6,123.3,199.2,122.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M111.5,118.5c0.9-1.2,1.8-1.9,1.8-1.8c0.3,0.3-2.4,3.8-3,3.8C110.1,120.5,110.7,119.6,111.5,118.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M115.8,114.6c0.6-0.7,1.4-1.3,1.9-1.7c1.4-0.8,0.6,0.3-1.3,1.7l-1.6,1.2L115.8,114.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M188.8,112c-1.1-0.8-3.4-2.1-5.1-3s-3.1-1.7-2.9-1.8c0.4-0.4,9.3,4.4,9.9,5.4 C191.2,113.7,191.2,113.8,188.8,112L188.8,112z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M128.8,107.1c0.1-0.2,0.9-0.7,1.8-1c0.9-0.2,1.4-0.3,1.2-0.1c-0.1,0.2-0.9,0.7-1.8,1 C129.1,107.2,128.6,107.3,128.8,107.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M173.8,105.2c-1.9-0.7-3.2-1.2-2.8-1.2c1.2-0.1,6.6,1.6,6.6,2c0,0.2-0.1,0.4-0.1,0.4 C177.3,106.4,175.7,105.9,173.8,105.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M139.8,103.5c0.6-0.2,1.4-0.4,2-0.4c0.8,0,0.8,0.1-0.2,0.4C139.8,104.1,138.5,104.1,139.8,103.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M163.8,103l-1-0.4h1c0.6,0,1.4,0.2,2,0.4l1,0.4h-1C165.2,103.4,164.3,103.2,163.8,103z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M146.5,102.5c0.7-0.2,1.7-0.4,2.2-0.4c0.8,0,0.8,0.1-0.2,0.4c-0.7,0.2-1.7,0.4-2.2,0.4 C145.4,102.9,145.5,102.8,146.5,102.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M159.8,102.5c-1.2-0.6,0.1-0.6,1.8,0c1,0.3,1.1,0.4,0.2,0.4C161.2,102.9,160.3,102.8,159.8,102.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M320.9,285c-0.5-0.2-0.9-0.8-0.9-1c0-0.3,0.4-0.1,0.8,0.2c1,1,1.8,1,3.4-0.2s1.8-0.9,0.2,0.5 C323.2,285.6,322.2,285.8,320.9,285z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M211.2,284.1c-0.6-0.1-2.7-0.5-4.8-0.9c-4.1-0.8-12.2-3.2-11.9-3.5c0.1-0.1,2,0.4,4.1,1 c2.2,0.6,6.5,1.7,9.5,2.2c5.2,1,7.1,1.5,4.9,1.4C212.7,284.4,211.8,284.3,211.2,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M229.9,283c2-0.5,3.9-1.1,4.2-1.3c0.4-0.2,0.4-0.2,0.1,0.2c-0.6,0.6-5.6,2.1-6.9,2 C226.7,284,227.9,283.5,229.9,283L229.9,283z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M319.5,281.9c0-1,0.1-1,0.5-0.4c0.6,1,0.6,1.5,0,1.5C319.8,283,319.5,282.5,319.5,281.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M327,280.8c0-0.2,0.2-1,0.6-1.8s1-2.2,1.4-3.5c0.4-1.2,0.9-2.5,1-2.8c0.5-0.8,2.3-7.1,3-10.5 c1-5.2,1.1-5.6,1.4-4.6c0.3,1.1-1.9,10.1-3.8,15.5C329.1,277.3,327.1,281.8,327,280.8L327,280.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M241.9,277.8c3.3-2.2,4.1-2.6,3.4-2c-1,1-4.9,3.6-5.4,3.6C239.5,279.5,240.4,278.7,241.9,277.8L241.9,277.8z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M189.1,277.9c-1.4-0.6-2.6-1.1-2.4-1.2c0.2-0.2,5.9,1.8,5.9,2.1S191.9,279,189.1,277.9L189.1,277.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M180.6,274.1c-1.4-0.7-2.6-1.4-2.4-1.5c0.2-0.2,5.9,2.2,5.9,2.6S183.3,275.4,180.6,274.1L180.6,274.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M318.9,272.6c-0.5-0.5-0.4-2.6,0.1-2.6c0.3,0,0.5,0.7,0.5,1.5C319.5,273,319.4,273.2,318.9,272.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M176.5,271.8c-0.3-0.4-0.5-1-0.4-1.3s0.4,0,0.8,0.8C177.6,272.7,177.4,272.9,176.5,271.8L176.5,271.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M180.5,269.4c0-0.2,1.3-3.4,2.3-5.6c0.8-1.9,4.2-12.5,5.7-18.1c0.6-2.2,1.2-4,1.4-3.9 c0.9,0.9-7.5,26.6-8.9,27.5C180.7,269.5,180.5,269.5,180.5,269.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M252.5,267.8c0.7-0.8,1.3-1.6,1.4-1.7c0.1-0.1,0.2-0.1,0.4,0c0.1,0.1-0.5,0.9-1.4,1.7l-1.6,1.5L252.5,267.8z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M175.5,267.5c0-0.5,0.2-1,0.5-1s0.5,0.5,0.5,1s-0.2,1-0.5,1C175.8,268.5,175.5,268,175.5,267.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M314.5,263.5c-1-1-2.5-2-3.4-2.2s-1.5-0.5-1.5-0.8s0.5-0.2,1.2,0c2.7,1,4,2,4.9,3.5 C316.8,265.9,316.7,265.9,314.5,263.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M255.1,264.1c0.4-0.5,0.8-1,0.9-1.1c0.1-0.1,0.9-1.4,1.5-2.6c0.7-1.4,2-3.2,2.9-4.2l1.6-1.9l-1.7,2.8 c-1,1.5-2.5,4-3.4,5.4s-1.9,2.6-2.1,2.6C254.6,265,254.7,264.6,255.1,264.1L255.1,264.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M175.8,260.1c0.2-1.9,0.5-4,0.8-4.9c0.4-1.1,0.4-0.9,0.2,1.2c-0.1,1.5-0.2,3.7-0.2,4.9 c0,1.1-0.2,2.1-0.5,2.1C175.8,263.5,175.6,262.1,175.8,260.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M303.1,259.4c-1.2-0.2-2.1-0.6-2-0.8c0.3-0.2,5.9,0.8,5.9,1.1C307,260.1,305.5,259.9,303.1,259.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M294.1,257.5c-0.9-0.2-1.8-0.5-2-0.7c-0.5-0.5,1.5-0.2,3.6,0.5S296.8,258.1,294.1,257.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M284.1,255.4c-1.2-0.2-2.1-0.6-2-0.8c0.3-0.2,5.9,0.8,5.9,1.1C288,256.1,286.5,255.9,284.1,255.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M334.5,253.8c0-1.1,0.2-2.4,0.5-2.8c0.6-0.9,0.6,2.3,0,3.8C334.6,255.6,334.5,255.3,334.5,253.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M273.2,253c-0.9-0.4-0.9-0.4,0.2-0.4c0.7,0,1.7,0.2,2.2,0.4c0.9,0.4,0.9,0.4-0.2,0.4 C274.8,253.4,273.8,253.2,273.2,253z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M266,252c1.7-0.6,3-0.6,1.8,0c-0.5,0.2-1.5,0.4-2,0.4C265,252.4,265,252.3,266,252z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M308.8,250.8l-2-0.7l2.2,0.3c1.2,0.1,2.7,0.4,3.2,0.7C314,251.8,311,251.5,308.8,250.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M316.5,250.8c1-0.4,1.9-0.6,2-0.5c0.4,0.4-0.3,0.7-2,0.9l-1.7,0.2L316.5,250.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M177.3,248c0.4-3.9,2.1-13.1,2.5-13.4c0.2-0.1,0.2,0.4,0.1,1.2c-0.1,0.9-0.6,3.3-0.9,5.5 c-0.4,2.2-0.9,5.4-1.2,7l-0.6,3L177.3,248L177.3,248z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M213.1,250.5H213c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0h0c-0.2,0-0.3-0.1-0.3-0.2c0,0,0,0,0,0 c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0.1,0,0.1-0.1,0.2-0.1v0C213,250.2,213,250.3,213.1,250.5 C213,250.5,213.1,250.5,213.1,250.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M319,250.1c0-0.2,0.7-0.9,1.5-1.3c0.9-0.5,1.5-0.8,1.5-0.6c0,0.1-0.6,0.7-1.5,1.3 C319.7,250.1,319,250.4,319,250.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M225.6,246.4c0-1.6,0.1-1.9,0.4-1.1c0.6,1.3,0.6,3.2,0.1,3.2C225.9,248.5,225.7,247.6,225.6,246.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M294.8,247.8l-2-0.7l2.2,0.3c1.2,0.1,2.7,0.4,3.2,0.7C300,248.8,297,248.5,294.8,247.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M285.2,245.8l-2-0.7l2.2,0.3c1.2,0.1,2.7,0.4,3.2,0.7C290.5,246.8,287.5,246.5,285.2,245.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M276.1,243.9c-1.2-0.2-2.1-0.6-2-0.8c0.3-0.2,5.9,0.8,5.9,1.1C280,244.6,278.5,244.4,276.1,243.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M269.8,242.3c-0.8-0.4-1.8-1.2-2.1-1.9l-0.6-1.2l0.9,1.1c0.5,0.6,2,1.4,3.1,1.9c1.2,0.4,1.8,0.8,1.2,0.8 S270.6,242.7,269.8,242.3L269.8,242.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M225.6,240.5c0.4-4.2,3.2-8.9,7.2-11.6c1.2-0.9,2.4-1.4,2.5-1.3s-0.4,0.6-1.2,1c-3.3,1.7-7.6,7.9-7.7,11 c0,0.6-0.2,1.6-0.5,2.1C225.6,242.5,225.6,242.2,225.6,240.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M190.1,239.2c0.3-0.9,0.6-1.6,0.8-1.6c0.4,0.4-0.4,3.3-0.9,3.3C189.8,241,189.9,240.2,190.1,239.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M326.5,240.5c0-0.7,1.4-3.6,1.5-2.9c0,0.2-0.4,1.1-0.8,2C326.9,240.5,326.5,240.9,326.5,240.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M334.5,236.6c0-0.6-0.5-1.5-1-2.1s-0.9-1.1-0.8-1.3c0.4-0.4,2.8,2.4,2.8,3.1c0,0.4-0.2,0.8-0.5,0.9 C334.8,237.4,334.5,237.1,334.5,236.6L334.5,236.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M191.1,236.2c-0.1-0.3,0.4-2.6,0.9-5.2c0.6-2.6,1.2-5.9,1.5-7.4s0.8-4.8,1.2-7.2c1.6-9.9,1.9-12.2,1.9-18.9 c0.1-3.8,0.2-6.9,0.5-6.9c0.6,0,0.4,10.4-0.1,14.9c-1.1,8.8-1.6,10.9-3.7,22.4C192.2,233.7,191.1,237.6,191.1,236.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M330.3,234.8c0.5-0.7,1-1.2,1.4-1.2c0.3,0,0,0.6-0.6,1.2s-1.2,1.2-1.4,1.2S329.9,235.4,330.3,234.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M263.8,228.2c-0.5-1.2-0.4-3.2,0.2-3.2c0.3,0,0.5,0.9,0.5,2C264.5,229.1,264.3,229.5,263.8,228.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M181.5,225.1c0-1.1,1.6-7.6,1.9-7.4c0.3,0.3-1.3,7.8-1.6,7.8C181.6,225.5,181.5,225.3,181.5,225.1 L181.5,225.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M183.6,216.2c0-0.6,0.3-1.8,0.6-2.8c0.4-1.1,0.6-1.4,0.6-0.8c0,0.6-0.3,1.8-0.6,2.8 C183.9,216.6,183.6,216.9,183.6,216.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M187.2,202.9c1.5-4.9,2.4-7.4,4.3-11.3c2.2-4.6,3.4-5.6,5.8-4.6c1.4,0.6,1.4,0.6-0.4,0.3 c-1.4-0.2-2-0.1-2.6,0.7c-1.1,1.2-4.2,8.6-5.9,13.4c-0.6,1.9-1.3,3.6-1.5,3.6S186.9,204.1,187.2,202.9L187.2,202.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M250.8,201.4c-1.6-1.7-2.6-2.8-2-2.4c1,0.6,5.6,5.4,5.2,5.4C253.8,204.5,252.4,203.1,250.8,201.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M246.6,198.3c-0.9-1-8.1-4.6-12.3-6c-1.9-0.7-3.1-1.2-2.6-1.2c2.2-0.1,15.1,5.9,15.6,7.2 C247.6,199.2,247.3,199.2,246.6,198.3L246.6,198.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M217.2,188.5l-1-0.4h1c0.6,0,1.4,0.2,2,0.4l1,0.4h-1C218.7,188.9,217.8,188.8,217.2,188.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M181.6,170c-3-1.4-4.4-2.4-2-1.6c2.9,1.2,5.9,2.6,5.9,2.8C185.5,171.7,184.9,171.5,181.6,170z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M139.2,165l-1-0.4h1c0.6,0,1.4,0.2,2,0.4l1,0.4h-1C140.7,165.4,139.8,165.2,139.2,165z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M133.2,163.5c-3.3-1.2-1.8-1.2,1.8,0c1.5,0.5,2.3,0.9,1.8,0.9C136.2,164.4,134.6,164,133.2,163.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M128.1,161.7c-0.9-0.4-1.6-0.8-1.4-0.9c0.3-0.4,3.4,0.9,3.4,1.4C130,162.6,130.1,162.6,128.1,161.7 L128.1,161.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M184.5,161.5c0-0.6,0.2-1,0.5-1s0.5,0.4,0.5,1s-0.2,1-0.5,1C184.8,162.5,184.5,162.1,184.5,161.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M122.9,159.1c-1.3-0.7-2.3-1.4-2.2-1.5c0.2-0.2,5.3,2.2,5.3,2.6C126,160.8,125.2,160.4,122.9,159.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M190.4,155.7c3.6-2.8,5.6-4.6,8-8.1c2.6-3.6,3.3-4.1,1.5-1.1c-2.1,3.5-9.9,10.9-11.4,10.9 C188.2,157.5,189,156.7,190.4,155.7L190.4,155.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M113.1,152.1c-0.8-0.8-1.6-1.6-1.6-1.9c0-0.2,0.8,0.4,1.8,1.3s1.8,1.8,1.8,1.9 C115,153.8,114.5,153.4,113.1,152.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M201.6,142.1c0.8-1.4,0.9-2.9,0.9-7c0-3.2,0.2-5.2,0.6-5.4c0.9-0.6,0.3,9.6-0.8,12.2 c-0.5,1.1-1.1,2.1-1.3,2.1S201.1,143.1,201.6,142.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M105.3,136.8c-0.2-1.8-0.2-3.8,0.1-4.4c0.3-0.8,0.5-0.1,0.7,2.6C106.4,139.7,105.8,141.2,105.3,136.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M106.1,128.8c0.1-1.4,0.7-3.1,1.1-2.4c0.2,0.2-0.1,1.2-0.4,1.9C106.2,129.4,106.1,129.5,106.1,128.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M111.7,118.3c1-1.2,2.4-2.7,3.2-3.2c0.8-0.5,0.2,0.3-1.4,2.1C110.1,120.9,109.1,121.5,111.7,118.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M194.9,117.1c-0.6-0.7-1.8-1.9-2.4-2.8c-1.1-1.3-1.1-1.4-0.1-0.6c2.9,2.4,4.9,4.7,4.3,4.7 C196.3,118.3,195.5,117.8,194.9,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M117,113.6c0-0.4,5.9-4.3,6.2-4.1c0.1,0.1-1.2,1.2-3,2.3S117,113.8,117,113.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M188.9,111.7c-1.1-1.2-1.1-1.3-0.1-0.7c0.6,0.3,1.2,0.9,1.4,1.3C190.6,113.3,190.3,113.2,188.9,111.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M185.8,110c-0.8-0.6-1.2-1-0.9-1c0.6,0,3.2,1.9,2.7,2C187.4,111,186.6,110.6,185.8,110z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M126.2,108.1c0.2-0.2,1-0.7,1.9-1c1.9-0.7,1.3,0-0.8,0.8C126.5,108.2,126,108.3,126.2,108.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M179.9,107.3c-1.6-0.6-2.9-1.2-2.9-1.4c0-0.5,4.9,1.3,5.7,2.1C183.3,108.7,183.3,108.7,179.9,107.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M173.2,105l-1-0.4h1c0.6,0,1.4,0.2,2,0.4l1,0.4h-1C174.7,105.4,173.8,105.2,173.2,105z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M137.5,104c1.7-0.6,3-0.6,1.8,0c-0.6,0.2-1.4,0.4-2,0.4C136.4,104.4,136.5,104.3,137.5,104z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M169.2,104l-1-0.4h1c0.6,0,1.4,0.2,2,0.4l1,0.4h-1C170.7,104.4,169.8,104.2,169.2,104z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M142.8,103c0.6-0.2,1.4-0.4,2-0.4c0.8,0,0.8,0.1-0.2,0.4C142.8,103.6,141.5,103.6,142.8,103z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M209.6,283.6c0.4-0.1,1.2-0.1,1.8,0c0.4,0.1,0.1,0.2-0.9,0.2S209.1,283.8,209.6,283.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M205.2,283c-0.7-0.4-0.4-0.4,1-0.1c1.1,0.1,2.1,0.4,2.2,0.5C208.9,283.7,206.2,283.4,205.2,283L205.2,283z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M234,281.9c0.7-0.3,2.6-1.2,4.1-2c1.6-0.8,2.9-1.3,2.9-1.1c0,0.4-5.5,3-7,3.5l-1.2,0.3L234,281.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M199.5,281.5c-1.1-0.4-1.1-0.4-0.2-0.5c0.6,0,1.4,0.2,1.8,0.5C201.9,282,201.2,282,199.5,281.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M318.8,272.5c-0.2-0.9-0.1-1.8,0.1-2c0.3-0.3,0.5,0.3,0.5,1.5C319.5,274.4,319.2,274.6,318.8,272.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M180.5,269.1c0-0.2,0.2-0.6,0.4-0.9s0.8-1.6,1.3-2.9s1.1-2.5,1.4-2.6c0.4-0.2-1.1,4-2.1,5.9 C181,269.6,180.5,269.8,180.5,269.1L180.5,269.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M175.9,268.1c-0.6-0.5-0.4-2.6,0.1-2.6c0.3,0,0.5,0.7,0.5,1.5C176.5,268.5,176.4,268.8,175.9,268.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M332.7,263.2c0.2-0.8,0.6-1.7,0.9-2c0.2-0.3,0.2,0.2,0,1.2C332.9,264.6,332.3,265.2,332.7,263.2L332.7,263.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M175.8,261.4c0.4-3.5,0.7-3.6,0.7-0.2c0,1.6-0.2,2.9-0.5,2.9C175.6,264,175.6,263,175.8,261.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M183.8,261.1c1.2-3,3.9-12,5.6-18.6c1.1-4.2,2-7.4,2.1-7.1c0.1,0.4-0.1,1.6-0.4,2.7s-1.2,4.7-2.1,7.9 c-2.1,8.1-4.6,16-5.2,16C183.6,262,183.6,261.6,183.8,261.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M258.1,259.2c1.6-2.9,5.4-6.7,6.5-6.7c0.4,0-0.2,0.6-1.2,1.2c-1.8,1.2-3.9,3.9-5.4,6.9 c-0.4,0.8-0.9,1.4-1.1,1.4S257.2,260.8,258.1,259.2L258.1,259.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M312,261.5c-0.4-0.2-2.5-0.9-4.6-1.4s-3.8-1-3.6-1.1c0.4-0.4,7.6,1.4,8.5,2.1 C313.3,262,313.1,262.2,312,261.5L312,261.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M333.5,259.4c0-0.4,0.2-1,0.5-1.4c0.4-0.6,0.5-0.5,0.5,0.4c0,0.6-0.2,1.2-0.5,1.4 C333.8,259.9,333.5,259.8,333.5,259.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M297.2,258l-1-0.5h1c0.5,0,1.5,0.2,2,0.5l1,0.5h-1C298.7,258.5,297.8,258.2,297.2,258z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M292.2,257l-1-0.5h1c0.5,0,1.5,0.2,2,0.5l1,0.5h-1C293.7,257.5,292.8,257.2,292.2,257z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M286.8,255.9c-1.1-0.2-2.1-0.6-2.2-0.8c-0.4-0.4,4,0.4,5.2,0.8l1,0.4h-1C289.2,256.4,287.9,256.2,286.8,255.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M176.6,253.5c0-1.2,0.1-2.7,0.4-3.2c0.4-0.8,0.4-0.6,0.4,0.8c0,0.9-0.2,2.4-0.4,3.2 C176.6,255.6,176.6,255.6,176.6,253.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M277.1,253.9c-1.2-0.2-2.1-0.6-2-0.8c0.3-0.2,5.9,0.8,5.9,1.1C281,254.6,279.5,254.4,277.1,253.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M334.5,253.5c0-0.7,0.2-1.7,0.5-2.2c0.4-0.9,0.5-0.8,0.5,0.5c0,0.9-0.2,1.9-0.5,2.2 C334.6,254.6,334.5,254.5,334.5,253.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M268.5,252c-1-0.3-1-0.4-0.2-0.4c0.5,0,1.5,0.2,2.2,0.4c1,0.3,1,0.4,0.2,0.4 C270.2,252.4,269.2,252.2,268.5,252z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M308.2,250.6c-0.5-0.1-2.6-0.6-4.6-1s-3.5-0.9-3.4-1c0.2-0.2,9.9,1.8,10.2,2.1 C310.7,251,309.7,251,308.2,250.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M318.5,250c2.3-1.2,3.1-1.2,1.2,0c-0.8,0.6-1.9,1-2.2,1C317.1,250.9,317.5,250.6,318.5,250z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M225.6,244.1c-0.1-2.1,0.1-4.4,0.4-5.1c0.3-0.8,0.4,0.4,0.3,3.6c-0.1,2.7-0.2,4.9-0.3,5.1 C225.8,247.9,225.7,246.2,225.6,244.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M292.5,247.4c-1.2-0.3-1.9-0.6-1.5-0.7c0.4-0.1,1.9,0.1,3.2,0.6C297.1,248.1,295.8,248.2,292.5,247.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M177.6,246.2c0-0.8,0.1-1.9,0.4-2.5c0.4-0.9,0.4-0.9,0.4,0.2c0,0.7-0.2,1.8-0.4,2.5 C177.6,247.7,177.6,247.7,177.6,246.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M283,245.4c-1.2-0.3-1.9-0.6-1.5-0.7c0.4-0.1,1.9,0.1,3.2,0.6C287.6,246.1,286.3,246.2,283,245.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M272.8,243.2c-1.6-0.4-3.1-0.9-3.4-1.1c-0.4-0.4,6.3,1.1,7.9,1.7C278.5,244.2,275.5,243.9,272.8,243.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M178.5,240.4c0-1.1,1.9-11.1,2.2-11.4c0.4-0.4,0.3,0.2-0.8,6.1C178.9,240.4,178.5,242.1,178.5,240.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M226.5,237.2c0-1.4,4.6-7.8,5.6-7.8c0.3,0-0.3,0.8-1.2,1.8c-1,1-2.2,2.8-2.9,4 C227,237.3,226.5,237.9,226.5,237.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M191.6,233.5c0-0.7,0.2-1.7,0.4-2.2c0.4-0.9,0.4-0.9,0.4,0.2c0,0.7-0.2,1.7-0.4,2.2 C191.6,234.6,191.6,234.6,191.6,233.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M192.6,229c0-0.7,0.2-1.8,0.4-2.5c0.4-1.2,0.4-1.2,0.4,0.2c0,0.9-0.1,1.9-0.4,2.5 C192.6,230.1,192.6,230.1,192.6,229z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M263.9,227.2c-0.3-1.5-0.1-2.1,0.4-1.6c0.1,0.2,0.2,0.9,0.1,1.8l-0.1,1.4L263.9,227.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M181.1,227.2c0-0.6,0.2-1.4,0.4-2l0.4-1v1c0,0.6-0.2,1.4-0.4,2l-0.4,1V227.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M193.6,223.5c0-0.7,0.2-1.8,0.4-2.5c0.4-1.2,0.4-1.2,0.4,0.2c0,0.9-0.1,1.9-0.4,2.5 C193.6,224.6,193.6,224.6,193.6,223.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M182.6,220.5c0-0.4,0.2-1.3,0.4-2c0.3-1,0.4-1.1,0.4-0.2c0,0.6-0.1,1.4-0.4,2 C182.8,220.9,182.6,220.9,182.6,220.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M194.6,218c0-0.9,0.1-2.2,0.4-2.8c0.4-0.9,0.4-0.8,0.4,0.5c0,0.9-0.2,2.1-0.4,2.8 C194.6,219.6,194.6,219.6,194.6,218z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M195.6,211.2c0-0.8,0.2-2.1,0.4-2.8c0.4-1.1,0.4-1.1,0.4,0.5c0,0.9-0.1,2.2-0.4,2.8 C195.6,212.6,195.6,212.5,195.6,211.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M185.1,211.1c-0.1-1.1,3.9-13.6,5.2-16.3c1.4-2.8,1.4-2.5-1.1,4.2c-0.9,2.6-2.2,6.6-2.9,8.8 C185.6,209.9,185.1,211.4,185.1,211.1L185.1,211.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M253.7,204.4l-1.4-1.6l1.6,1.4c1.5,1.4,1.9,1.8,1.4,1.8C255.2,206,254.5,205.2,253.7,204.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M196.8,198.9c0.4-3.6,0.7-3.6,0.7-0.2c0,1.6-0.2,2.9-0.5,2.9C196.6,201.5,196.6,200.6,196.8,198.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M245.8,197.7c-0.6-0.4-0.9-0.8-0.8-0.9c0.1-0.1,0.6,0.1,1.1,0.5c0.6,0.4,0.9,0.8,0.8,0.9 C246.8,198.3,246.3,198.1,245.8,197.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M237.8,193.6c-2.2-0.9-3.4-1.6-2.6-1.4c1.5,0.3,7.9,3.2,7.1,3.1C242,195.4,239.9,194.6,237.8,193.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M229.8,191l-1-0.4h1c0.6,0,1.4,0.2,2,0.4l1,0.4h-1C231.2,191.4,230.3,191.2,229.8,191z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M192.4,189.6c0.2-0.5,0.9-1.2,1.4-1.6c0.6-0.5,0.6-0.2-0.3,0.9C192.3,190.7,191.6,191.1,192.4,189.6 L192.4,189.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M225.8,190l-1-0.4h1c0.6,0,1.4,0.2,2,0.4l1,0.4h-1C227.2,190.4,226.3,190.2,225.8,190z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M220.8,189l-1-0.4h1c0.6,0,1.4,0.2,2,0.4l1,0.4h-1C222.2,189.4,221.3,189.2,220.8,189z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M185,171.4c-1.2-0.6-5.5-2.4-9.5-4s-6.6-2.9-5.8-2.6c1.6,0.4,14.9,5.8,17.2,7 C188.9,172.8,187.6,172.6,185,171.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M149.6,166.1c0.4-0.1,1.2-0.1,1.8,0c0.4,0.1,0.1,0.2-0.9,0.2S149.1,166.3,149.6,166.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M164.2,165.4c2.6-0.5,4.6-0.5,2.5,0.1c-0.8,0.2-2.1,0.4-3,0.4C162.5,165.9,162.6,165.8,164.2,165.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M139.5,165c-1-0.3-1.1-0.4-0.2-0.4c0.6,0,1.7,0.2,2.5,0.4c1.4,0.4,1.4,0.4,0.2,0.4 C141.3,165.4,140.2,165.2,139.5,165z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M184.5,161.1c0-0.9,0.2-1.6,0.5-1.6s0.5,0.6,0.5,1.2c0,0.7-0.2,1.4-0.5,1.6 C184.7,162.4,184.5,161.9,184.5,161.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M123.2,159.2c-3.8-2.1-3.2-2.3,0.7-0.2c3.1,1.7,3.5,1.9,2.8,1.9C126.5,161,124.9,160.2,123.2,159.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M114,152.8c-1.2-1.2-2.1-2.2-1.9-2.2s1.2,1,2.4,2.2s2.1,2.2,1.9,2.2S115.2,154,114,152.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M197.9,148.2c1.2-1.6,1.9-1.6,0.9,0c-0.4,0.7-1,1.2-1.3,1.2C197.2,149.5,197.4,148.9,197.9,148.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M200.3,144.5c1.1-2.1,1.9-2.4,0.9-0.3c-0.4,1-1,1.8-1.2,1.8S199.9,145.4,200.3,144.5L200.3,144.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M105.7,138.2c0-1.1,0.1-1.5,0.2-0.9s0.1,1.5,0,2C105.7,139.8,105.6,139.3,105.7,138.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M202.6,137.8c0-0.8,0.2-1.9,0.4-2.5c0.4-0.8,0.4-0.7,0.4,0.8c0,0.9-0.2,2.1-0.4,2.5 C202.6,139.1,202.5,138.9,202.6,137.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M105.6,131.4c0-0.9,0.2-2.1,0.5-2.7c0.3-0.6,0.3-0.2,0.2,1.5C105.8,133.2,105.5,133.9,105.6,131.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M111.5,118.7c0.6-0.8,1.6-1.7,2.2-2.1s0.2,0.2-0.9,1.3C110.5,120.3,109.9,120.7,111.5,118.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M194.7,116.8c-0.5-0.4-0.8-0.8-0.6-1c0.1-0.2,0.7,0.2,1.2,0.7C196.3,117.7,196.1,117.8,194.7,116.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M115.7,114.6c0.2-0.3,1.1-1.1,1.9-1.7s1.4-0.8,1.2-0.5c-0.2,0.3-1.1,1.1-1.9,1.7 C116.1,114.7,115.5,114.9,115.7,114.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M121.4,110.5c2.1-1.3,2.8-1.3,0.8,0c-0.8,0.6-1.7,1-2,1C120,111.5,120.5,111.1,121.4,110.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M182.9,108.5c-3.4-1.6-4.4-2.4-1.9-1.4c2.4,1.1,5.9,2.8,5.2,2.8C186,109.9,184.4,109.3,182.9,108.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M128.1,107.2c0.4-0.4,3.9-1.8,3.9-1.5c0,0.1-0.8,0.6-1.8,1C128.3,107.5,127.6,107.7,128.1,107.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M176.2,105.8c-0.9-0.7-0.8-0.7,0.8-0.2c2.1,0.7,2.4,0.9,1.2,0.9C177.6,106.5,176.8,106.2,176.2,105.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M135.5,104.5c1.7-0.6,3-0.6,1.8,0c-0.6,0.2-1.4,0.4-2,0.4C134.4,104.9,134.5,104.8,135.5,104.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M166.9,103.7c-2.1-0.4-3.8-0.8-3.6-1s8.3,1.2,8.7,1.6C172.3,104.6,171.4,104.5,166.9,103.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M144.6,102.7c0.4-0.1,1.2-0.1,1.8,0c0.4,0.2,0.1,0.2-0.9,0.2S144.1,102.8,144.6,102.7z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M322.5,285c0.7-0.2,1.5-0.6,1.8-0.9s0.1,0-0.4,0.5s-1.4,0.9-1.8,0.8C321.6,285.4,321.7,285.2,322.5,285 L322.5,285z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M222.1,284.1c0.8-0.1,1.9-0.1,2.5,0s0,0.2-1.4,0.2C221.9,284.4,221.4,284.2,222.1,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M319.1,274.2c0-1.1,0.1-1.5,0.2-0.9s0.1,1.5,0,2C319.2,275.9,319.1,275.4,319.1,274.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M175.6,265.4c-0.1-1.5,0.1-2.3,0.4-2.1c0.6,0.4,0.6,2.1,0,3.5C175.7,267.5,175.6,267.1,175.6,265.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M297,258c-1-0.3-1-0.4-0.2-0.4c0.5,0,1.7,0.2,2.5,0.4c1.4,0.4,1.4,0.4,0.2,0.4 C298.8,258.4,297.7,258.2,297,258z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M273.5,253c-1-0.3-1-0.4-0.2-0.4c0.5,0,1.5,0.2,2.2,0.4c1,0.3,1,0.4,0.2,0.4 C275.2,253.4,274.2,253.2,273.5,253z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M305.5,250c-1-0.3-1-0.4-0.2-0.4c0.5,0,1.5,0.2,2.2,0.4c1,0.3,1,0.4,0.2,0.4 C307.2,250.4,306.2,250.2,305.5,250z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M296,248c-1-0.3-1-0.4-0.2-0.4c0.5,0,1.5,0.2,2.2,0.4c1,0.3,1,0.4,0.2,0.4C297.7,248.4,296.7,248.2,296,248z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M286.5,246c-1-0.3-1-0.4-0.2-0.4c0.5,0,1.7,0.2,2.5,0.4c1.4,0.4,1.4,0.4,0.2,0.4 C288.3,246.4,287.2,246.2,286.5,246z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M230.6,230.7c0.4-0.5,1.6-1.4,2.5-1.9c1.9-1.1,1.4-0.6-1.4,1.4C230.6,231.1,230.1,231.3,230.6,230.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M181.6,224.8c0-0.6,0.2-1.6,0.4-2.2c0.3-1,0.4-1.1,0.4-0.2c0,0.6-0.2,1.6-0.4,2.2 C181.7,225.5,181.6,225.6,181.6,224.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M196.6,201.4c0.1-0.6,0.2-1.7,0.4-2.4c0.4-1.1,0.4-0.9,0.4,0.9c0.1,1.1-0.1,2.2-0.4,2.4 S196.5,202.1,196.6,201.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M230.2,191c-0.6-0.2-0.7-0.4-0.2-0.4c0.4,0,1.2,0.2,1.8,0.4s0.7,0.4,0.2,0.4 C231.6,191.4,230.8,191.2,230.2,191z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M226,190c-1-0.3-1.1-0.4-0.2-0.4c0.6,0,1.4,0.1,2,0.4C229,190.6,227.7,190.6,226,190z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M215.4,188.1c0.6-0.1,1.5-0.1,2,0c0.4,0.1-0.1,0.2-1.1,0.2C215.1,188.3,214.8,188.2,215.4,188.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M198.9,187.1c0.6-0.1,1.5-0.1,2,0c0.4,0.1-0.1,0.2-1.1,0.2C198.6,187.3,198.2,187.2,198.9,187.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M152.1,166.1c0.8-0.1,1.9-0.1,2.8,0c0.8,0.1,0.1,0.2-1.4,0.2S151.4,166.2,152.1,166.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M130.6,162.6c-1.2-0.4-2.1-0.9-1.9-0.9c0.1-0.1,1.4,0.2,2.9,0.8s2.4,1,1.9,0.9 C133.1,163.4,131.8,163.1,130.6,162.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M184.5,160.2c0-0.4,0.9-1.2,1.9-1.9c2.8-1.8,3.5-2.1,2.1-0.9c-0.7,0.6-1.6,1.1-2.1,1.4 c-0.5,0.1-0.9,0.7-0.9,1.2s-0.2,0.9-0.5,0.9C184.8,161,184.5,160.7,184.5,160.2L184.5,160.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M202.8,136.8c0.4-1.9,0.7-2.2,0.7-0.9c0,0.5-0.2,1.3-0.5,1.7C202.6,138.1,202.6,137.9,202.8,136.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M123.6,109.3c0.5-0.4,3.4-1.8,3.4-1.6c0,0.3-2.8,1.8-3.3,1.8C123.5,109.5,123.4,109.4,123.6,109.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M176,105.8c-0.9-0.3-1.4-0.7-1-0.7s1.4,0.3,2.2,0.7C179.2,106.6,178.3,106.7,176,105.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M171.5,104.5c-1-0.3-1.1-0.4-0.2-0.4c0.6,0,1.4,0.2,2,0.4C174.5,105.1,173.2,105.1,171.5,104.5z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M213.9,284.1c0.6-0.1,1.6-0.1,2.2,0c0.6,0.1,0.1,0.2-1.1,0.2S213.2,284.2,213.9,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M175.6,265.5c0-1,0.1-1.4,0.2-0.9c0.1,0.5,0.1,1.2,0,1.8C175.7,266.9,175.6,266.4,175.6,265.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M312.6,251.1c0.8-0.1,1.9-0.1,2.5,0s0,0.2-1.4,0.2C312.4,251.3,311.9,251.2,312.6,251.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M196.5,201.3c0-0.4,0.2-0.9,0.5-1.1c0.3-0.1,0.5,0.1,0.5,0.4s-0.2,0.9-0.5,1.1 C196.8,201.9,196.5,201.7,196.5,201.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M209.4,187.6c0.6-0.1,1.6-0.1,2.2,0c0.6,0.1,0.1,0.2-1.1,0.2S208.8,187.7,209.4,187.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M155.6,166.1c0.8-0.1,1.9-0.1,2.8,0c0.8,0.1,0.1,0.2-1.4,0.2S154.9,166.2,155.6,166.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M203.1,134.2c0-1.4,0.1-1.9,0.2-1.1c0.1,0.8,0.1,1.9,0,2.5S203.1,135.6,203.1,134.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M122,110.3c0-0.2,0.7-0.6,1.5-1.1c0.8-0.4,1.5-0.7,1.5-0.6c0,0.2-0.7,0.6-1.5,1.1 C122.7,110.2,122,110.4,122,110.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M151.6,102.2c1.6-0.1,4.1-0.1,5.5,0s0.1,0.2-2.9,0.2C151.2,102.3,150.1,102.2,151.6,102.2z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M214.1,284.1c0.4-0.1,1.2-0.1,1.8,0c0.4,0.1,0.1,0.2-0.9,0.2S213.6,284.3,214.1,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M222.6,284.1c0.4-0.1,1.2-0.1,1.8,0c0.4,0.1,0.1,0.2-0.9,0.2S222.1,284.3,222.6,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M209.6,187.6c0.4-0.1,1.2-0.1,1.8,0c0.4,0.1,0.1,0.2-0.9,0.2S209.1,187.8,209.6,187.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M201.9,187.1c0.9-0.1,2.2-0.1,3,0s0,0.2-1.6,0.2S201,187.2,201.9,187.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M156.6,102.2c0.4-0.1,1.2-0.1,1.8,0c0.4,0.2,0.1,0.2-0.9,0.2S156.1,102.3,156.6,102.2z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M144.5,138v2.5h-3.2v6.3h-2.9v-6.3h-10.1v-2.3l11.1-15.9h1.9V138H144.5z M138.4,138v-11.9L130,138H138.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M147.1,135c0-2.8,0.4-5.1,1.2-7.1c0.3-0.7,0.7-1.4,1.1-2.1c0.4-0.7,0.9-1.3,1.5-1.8s1.2-0.9,1.8-1.2 c0.7-0.3,1.4-0.5,2.2-0.5c1.8,0,3.5,0.9,4.9,2.8c1.8,2.3,2.7,5.5,2.7,9.4c0,0.9,0,1.8-0.1,2.7c-0.1,0.9-0.2,1.7-0.4,2.5 c-0.2,0.8-0.5,1.5-0.8,2.3c-0.3,0.7-0.7,1.4-1.2,2.1c-0.3,0.4-0.7,0.8-1.1,1.2c-0.4,0.4-0.9,0.7-1.3,1s-1,0.5-1.5,0.7 c-0.5,0.2-1,0.2-1.5,0.2c-1,0-2-0.3-2.9-0.9s-1.7-1.4-2.4-2.5c-0.7-1.1-1.3-2.4-1.7-3.9C147.3,138.4,147.1,136.8,147.1,135z  M150.5,135.4c0,1.4,0.1,2.7,0.2,4c0.2,1.2,0.4,2.4,0.7,3.3c0.3,1,0.8,1.9,1.3,2.5c0.5,0.6,1.2,0.9,2,0.9c0.3,0,0.6-0.1,1-0.2 c0.3-0.1,0.7-0.4,1-0.7c0.3-0.3,0.6-0.7,0.9-1.2s0.5-1,0.7-1.7c0.3-1,0.5-2.2,0.6-3.7c0.1-1.4,0.2-3.1,0.2-4.9c0-2.7-0.3-5-0.8-6.8 c-0.4-1.2-0.8-2-1.3-2.6c-0.5-0.6-1.2-0.9-2-0.9c-1,0-1.8,0.5-2.5,1.5c-0.7,1-1.2,2.4-1.4,4.2c-0.2,1.1-0.3,2.1-0.3,3.1 S150.5,134.4,150.5,135.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M180.7,138v2.5h-3.2v6.3h-2.9v-6.3h-10.1v-2.3l11.1-15.9h1.9V138H180.7z M174.6,138v-11.9l-8.4,11.9H174.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagenotfound);
export default __webpack_public_path__ + "static/media/pagenotfound.cf0bc81a3ac2b04aea897396ef80a1b4.svg";
export { ForwardRef as ReactComponent };